export default {
  courses: [{
    id: "1",
    code: "ACC 405",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2",
    code: "ACC 440",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "3",
    code: "ADL 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "4",
    code: "ADL 103",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "5",
    code: "ADL 105",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30",
    time: [24, 25, 26],
    seen: false
  }, {
    id: "6",
    code: "ADL 201",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "7",
    code: "ADL 203",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "8",
    code: "ADL 205",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "9",
    code: "ADL 207",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45",
    time: [21, 22, 23],
    seen: false
  }, {
    id: "10",
    code: "ADL 209",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 11:15 - 13:50",
    time: [36, 37, 38],
    seen: false
  }, {
    id: "11",
    code: "ADL 211",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "12",
    code: "ADL 241",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 17:30",
    time: [73, 74],
    seen: false
  }, {
    id: "13",
    code: "ADL 260",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 15:40",
    time: [55, 56],
    seen: false
  }, {
    id: "14",
    code: "ADL 290",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 11:15 - 12:55",
    time: [52, 53],
    seen: false
  }, {
    id: "15",
    code: "AE 202",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 13:50, Çarşamba 10:20 - 12:00",
    time: [21, 22, 35, 36],
    seen: false
  }, {
    id: "16",
    code: "AE 301",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Çarşamba 15:50 - 17:30",
    time: [17, 18, 41, 42],
    seen: false
  }, {
    id: "17",
    code: "AE 305",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Perşembe 14:55 - 16:35",
    time: [19, 20, 56, 57],
    seen: false
  }, {
    id: "18",
    code: "AE 306",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "19",
    code: "AE 311",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 13:50, Çarşamba 10:20 - 12:00",
    time: [21, 22, 35, 36],
    seen: false
  }, {
    id: "20",
    code: "AE 401",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Cuma 10:20 - 12:00",
    time: [17, 18, 67, 68],
    seen: false
  }, {
    id: "21",
    code: "AE 404",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "22",
    code: "AE 405",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 13:50",
    time: [4, 5, 6],
    seen: false
  }, {
    id: "23",
    code: "AE 409",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Perşembe 10:20 - 12:00",
    time: [23, 24, 51, 52],
    seen: false
  }, {
    id: "24",
    code: "AE 419",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "25",
    code: "AE 423",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Cuma 15:50 - 17:30",
    time: [7, 8, 73, 74],
    seen: false
  }, {
    id: "26",
    code: "AE 426",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 10:10, Cuma 08:30 - 10:10",
    time: [49, 50, 65, 66],
    seen: false
  }, {
    id: "27",
    code: "AE 441",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 16:35, Cuma 14:00 - 15:40",
    time: [40, 41, 71, 72],
    seen: false
  }, {
    id: "28",
    code: "AET 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Çarşamba 11:15 - 12:55",
    time: [6, 7, 36, 37],
    seen: false
  }, {
    id: "29",
    code: "AET 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Salı 08:30 - 10:10",
    time: [1, 2, 17, 18],
    seen: false
  }, {
    id: "30",
    code: "AET 105",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Perşembe 08:30 - 10:10",
    time: [19, 20, 49, 50],
    seen: false
  }, {
    id: "31",
    code: "AET 107",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Çarşamba 09:25 - 11:05",
    time: [3, 4, 34, 35],
    seen: false
  }, {
    id: "32",
    code: "AET 191",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Çarşamba 11:15 - 12:55",
    time: [6, 7, 36, 37],
    seen: false
  }, {
    id: "33",
    code: "AET 193",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Çarşamba 09:25 - 11:05",
    time: [3, 4, 34, 35],
    seen: false
  }, {
    id: "34",
    code: "AET 201",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "35",
    code: "AET 203",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "36",
    code: "AET 205",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "37",
    code: "AET 207",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 13:50",
    time: [67, 68, 69, 70],
    seen: false
  }, {
    id: "38",
    code: "AET 209",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 11:15 - 12:55",
    time: [36, 37],
    seen: false
  }, {
    id: "39",
    code: "AET 231",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "40",
    code: "AET 235",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "41",
    code: "AET 291",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "42",
    code: "AET 293",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "43",
    code: "AET 293",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "44",
    code: "ARCH 101",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "45",
    code: "ARCH 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:55, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 21, 65, 66, 67, 68],
    seen: false
  }, {
    id: "46",
    code: "ARCH 203",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "47",
    code: "ARCH 205",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 14:45, Cuma 13:05 - 14:45",
    time: [38, 39, 70, 71],
    seen: false
  }, {
    id: "48",
    code: "ARCH 207",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:55",
    time: [49, 50, 51, 52, 53],
    seen: false
  }, {
    id: "49",
    code: "ARCH 301",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 17:30, Perşembe 14:00 - 17:30",
    time: [6, 7, 8, 9, 10, 55, 56, 57, 58],
    seen: false
  }, {
    id: "50",
    code: "ARCH 301",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 17:30, Perşembe 14:00 - 17:30",
    time: [6, 7, 8, 9, 10, 55, 56, 57, 58],
    seen: false
  }, {
    id: "51",
    code: "ARCH 303",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:55",
    time: [33, 34, 35, 36, 37],
    seen: false
  }, {
    id: "52",
    code: "ARCH 305",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "53",
    code: "ARCH 306",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "54",
    code: "ARCH 330",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "55",
    code: "ARCH 332",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "56",
    code: "ARCH 350",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "57",
    code: "ARCH 362",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00",
    time: [49, 50, 51, 52],
    seen: false
  }, {
    id: "58",
    code: "ARCH 401",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:55, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 21, 65, 66, 67, 68],
    seen: false
  }, {
    id: "59",
    code: "ARCH 401",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:55, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 21, 65, 66, 67, 68],
    seen: false
  }, {
    id: "60",
    code: "ARCH 404",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 16:35",
    time: [70, 71, 72, 73],
    seen: false
  }, {
    id: "61",
    code: "ARCH 430",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 17:30",
    time: [23, 24, 25, 26],
    seen: false
  }, {
    id: "62",
    code: "ARCH 451",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 11:15 - 12:55",
    time: [52, 53],
    seen: false
  }, {
    id: "63",
    code: "ARCH 480",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "64",
    code: "ARCH 495",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "65",
    code: "ARCH 498",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:55, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 21, 65, 66, 67, 68],
    seen: false
  }, {
    id: "66",
    code: "ARCH 501",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "67",
    code: "ARCH 504",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "68",
    code: "ARCH 532",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "69",
    code: "BA 125",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "70",
    code: "BA 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "71",
    code: "BA 221",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "72",
    code: "BA 221",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "73",
    code: "BA 250",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50",
    time: [20, 21, 22],
    seen: false
  }, {
    id: "74",
    code: "BA 250",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "75",
    code: "BA 251",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 13:50",
    time: [4, 5, 6],
    seen: false
  }, {
    id: "76",
    code: "BA 251",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "77",
    code: "BA 255",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50",
    time: [20, 21, 22],
    seen: false
  }, {
    id: "78",
    code: "BA 255",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "79",
    code: "BA 260",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "80",
    code: "BA 260",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "81",
    code: "BA 315",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "82",
    code: "BA 320",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "83",
    code: "BA 320",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "84",
    code: "BA 320",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "85",
    code: "BA 324",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "86",
    code: "BA 350",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "87",
    code: "BA 351",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50",
    time: [20, 21, 22],
    seen: false
  }, {
    id: "88",
    code: "BA 355",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "89",
    code: "BA 356",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "90",
    code: "BA 360",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "91",
    code: "BA 419",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "92",
    code: "BA 443",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "93",
    code: "BA 445",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "94",
    code: "BA 508",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "95",
    code: "BA 515",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "96",
    code: "BA 560",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 18:35 - 21:10",
    time: [76, 77, 78],
    seen: false
  }, {
    id: "97",
    code: "BA 567",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "98",
    code: "BA 600",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "99",
    code: "BA 600",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "100",
    code: "BA 600",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 16:45 - 17:30",
    time: [90],
    seen: false
  }, {
    id: "101",
    code: "BA 600",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 15:50 - 16:35",
    time: [89],
    seen: false
  }, {
    id: "102",
    code: "BA 600",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 18:35 - 19:20",
    time: [92],
    seen: false
  }, {
    id: "103",
    code: "BA 600",
    group: "6",
    type: "Yüz yüze",
    day: "Pazar 13:05 - 13:50",
    time: [102],
    seen: false
  }, {
    id: "104",
    code: "BA 600",
    group: "7",
    type: "Yüz yüze",
    day: "Cumartesi 17:40 - 18:25",
    time: [91],
    seen: false
  }, {
    id: "105",
    code: "BA 600",
    group: "8",
    type: "Yüz yüze",
    day: "Pazar 14:55 - 15:40",
    time: [104],
    seen: false
  }, {
    id: "106",
    code: "BA 630",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "107",
    code: "BA 631",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "108",
    code: "BA 632",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "109",
    code: "BA 697",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "110",
    code: "BA 697",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "111",
    code: "BA 697",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "112",
    code: "BA 697",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "113",
    code: "BA 699",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "114",
    code: "BA 699",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "115",
    code: "BA 699",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "116",
    code: "BA 699",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "117",
    code: "BEN 503",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "118",
    code: "BEN 505",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "119",
    code: "BEN 521",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "120",
    code: "BES 101",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 11:05, Çarşamba 09:25 - 11:05",
    time: [18, 19, 34, 35],
    seen: false
  }, {
    id: "121",
    code: "BES 103",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "122",
    code: "BES 105",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00, Cuma 14:00 - 15:40",
    time: [50, 51, 52, 71, 72],
    seen: false
  }, {
    id: "123",
    code: "BES 107",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 15:40",
    time: [21, 22, 23, 24],
    seen: false
  }, {
    id: "124",
    code: "BES 109",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "125",
    code: "BES 201",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 17:30, Cuma 09:25 - 12:00",
    time: [57, 58, 66, 67, 68],
    seen: false
  }, {
    id: "126",
    code: "BES 203",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Salı 14:00 - 16:35",
    time: [19, 20, 23, 24, 25],
    seen: false
  }, {
    id: "127",
    code: "BES 205",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 17:30",
    time: [7, 8, 9, 10],
    seen: false
  }, {
    id: "128",
    code: "BES 207",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55, Perşembe 09:25 - 12:00",
    time: [35, 36, 37, 50, 51, 52],
    seen: false
  }, {
    id: "129",
    code: "BES 209",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 17:30",
    time: [39, 40, 41, 42],
    seen: false
  }, {
    id: "130",
    code: "BES 360",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "131",
    code: "BILT 100",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 14:45",
    time: [54, 55],
    seen: false
  }, {
    id: "132",
    code: "BILT 100",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:00",
    time: [51, 52],
    seen: false
  }, {
    id: "133",
    code: "BILT 100",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55",
    time: [20, 21],
    seen: false
  }, {
    id: "134",
    code: "BILT 100",
    group: "4",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 16:35",
    time: [56, 57],
    seen: false
  }, {
    id: "135",
    code: "BLG 153",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 10:10",
    time: [49, 50],
    seen: false
  }, {
    id: "136",
    code: "BME 305",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55, Perşembe 14:55 - 16:35",
    time: [20, 21, 56, 57],
    seen: false
  }, {
    id: "137",
    code: "BME 311",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:55, Çarşamba 11:15 - 12:55",
    time: [4, 5, 36, 37],
    seen: false
  }, {
    id: "138",
    code: "BME 317",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 11:05, Pazartesi 13:05 - 14:45",
    time: [2, 3, 6, 7],
    seen: false
  }, {
    id: "139",
    code: "BME 319",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55, Perşembe 14:55 - 16:35",
    time: [20, 21, 56, 57],
    seen: false
  }, {
    id: "140",
    code: "BME 319",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55, Perşembe 13:05 - 14:45",
    time: [20, 21, 54, 55],
    seen: false
  }, {
    id: "141",
    code: "BME 323",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "142",
    code: "BME 401",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "143",
    code: "BME 408",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "144",
    code: "BME 410",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 11:05, Perşembe 13:05 - 14:45",
    time: [2, 3, 54, 55],
    seen: false
  }, {
    id: "145",
    code: "BME 425",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 11:05, Cuma 09:25 - 11:05",
    time: [34, 35, 66, 67],
    seen: false
  }, {
    id: "146",
    code: "BNK 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "147",
    code: "BNK 101",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "148",
    code: "BNK 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 11:05",
    time: [18, 19],
    seen: false
  }, {
    id: "149",
    code: "BNK 203",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 16:35",
    time: [56, 57],
    seen: false
  }, {
    id: "150",
    code: "BNK 205",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "151",
    code: "BNK 206",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "152",
    code: "BNK 207",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "153",
    code: "BNK 213",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30",
    time: [24, 25, 26],
    seen: false
  }, {
    id: "154",
    code: "BNK 291",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "155",
    code: "BNK 291",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "156",
    code: "BNK 293",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45",
    time: [21, 22, 23],
    seen: false
  }, {
    id: "157",
    code: "BNK 294",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "158",
    code: "BNK 296",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 16:35",
    time: [24, 25],
    seen: false
  }, {
    id: "159",
    code: "BNK 296",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 17:30",
    time: [57, 58],
    seen: false
  }, {
    id: "160",
    code: "BNK 297",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "161",
    code: "BUS 210",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 11:05",
    time: [2, 3],
    seen: false
  }, {
    id: "162",
    code: "BUS 210",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:55",
    time: [4, 5],
    seen: false
  }, {
    id: "163",
    code: "BUS 210",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55",
    time: [20, 21],
    seen: false
  }, {
    id: "164",
    code: "BUS 210",
    group: "4",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 13:50",
    time: [53, 54],
    seen: false
  }, {
    id: "165",
    code: "BUS 210",
    group: "5",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 15:40",
    time: [55, 56],
    seen: false
  }, {
    id: "166",
    code: "BUS 210",
    group: "6",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 17:30",
    time: [57, 58],
    seen: false
  }, {
    id: "167",
    code: "CBM 101",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "168",
    code: "CBM 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "169",
    code: "CBM 301",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 16:35, Cuma 10:20 - 12:00",
    time: [54, 55, 56, 57, 67, 68],
    seen: false
  }, {
    id: "170",
    code: "CDM 101",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 12:00",
    time: [81, 82, 83, 84],
    seen: false
  }, {
    id: "171",
    code: "CDM 111",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "172",
    code: "CDM 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40, Cuma 13:05 - 15:40",
    time: [22, 23, 24, 70, 71, 72],
    seen: false
  }, {
    id: "173",
    code: "CDM 203",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "174",
    code: "CDM 211",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "175",
    code: "CDM 215",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "176",
    code: "CDM 216",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "177",
    code: "CDM 217",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "178",
    code: "CDM 217",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "179",
    code: "CDM 231",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40, Cuma 13:05 - 15:40",
    time: [22, 23, 24, 70, 71, 72],
    seen: false
  }, {
    id: "180",
    code: "CDM 301",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Perşembe 12:10 - 15:40",
    time: [17, 18, 19, 20, 53, 54, 55, 56],
    seen: false
  }, {
    id: "181",
    code: "CDM 304",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "182",
    code: "CDM 307",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 16:35",
    time: [70, 71, 72, 73],
    seen: false
  }, {
    id: "183",
    code: "CDM 311",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "184",
    code: "CDM 331",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Perşembe 12:10 - 15:40",
    time: [17, 18, 19, 20, 53, 54, 55, 56],
    seen: false
  }, {
    id: "185",
    code: "CDM 335",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "186",
    code: "CDM 336",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45, Çarşamba 10:20 - 12:00",
    time: [22, 23, 35, 36],
    seen: false
  }, {
    id: "187",
    code: "CDM 337",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "188",
    code: "CDM 341",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "189",
    code: "CDM 400",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45, Çarşamba 10:20 - 12:00",
    time: [22, 23, 35, 36],
    seen: false
  }, {
    id: "190",
    code: "CDM 401",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "191",
    code: "CDM 410",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "192",
    code: "CDM 431",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "193",
    code: "CDM 432",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "194",
    code: "CDM 450",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "195",
    code: "CDM 480",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 16:35",
    time: [70, 71, 72, 73],
    seen: false
  }, {
    id: "196",
    code: "CDM 495",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40, Cumartesi 14:00 - 16:35",
    time: [38, 39, 40, 87, 88, 89],
    seen: false
  }, {
    id: "197",
    code: "CDM 497",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40, Cumartesi 14:00 - 16:35",
    time: [38, 39, 40, 87, 88, 89],
    seen: false
  }, {
    id: "198",
    code: "CDM 498",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 13:50",
    time: [81, 82, 83, 84, 85, 86],
    seen: false
  }, {
    id: "199",
    code: "CE 215",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "200",
    code: "CE 215",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "201",
    code: "CE 215",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "202",
    code: "CE 215",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 14:55 - 17:30",
    time: [72, 73, 74],
    seen: false
  }, {
    id: "203",
    code: "CE 215",
    group: "5",
    type: "Yüz yüze",
    day: "Cuma 14:55 - 17:30",
    time: [72, 73, 74],
    seen: false
  }, {
    id: "204",
    code: "CE 215",
    group: "6",
    type: "Yüz yüze",
    day: "Cuma 14:55 - 17:30",
    time: [72, 73, 74],
    seen: false
  }, {
    id: "205",
    code: "CE 221",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05, Salı 14:00 - 15:40",
    time: [1, 2, 3, 23, 24],
    seen: false
  }, {
    id: "206",
    code: "CE 221",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05, Salı 14:00 - 15:40",
    time: [1, 2, 3, 23, 24],
    seen: false
  }, {
    id: "207",
    code: "CE 221",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05, Çarşamba 08:30 - 10:10",
    time: [1, 2, 3, 33, 34],
    seen: false
  }, {
    id: "208",
    code: "CE 221",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40, Cuma 08:30 - 10:10",
    time: [38, 39, 40, 65, 66],
    seen: false
  }, {
    id: "209",
    code: "CE 221",
    group: "5",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40, Cuma 12:10 - 13:50",
    time: [38, 39, 40, 69, 70],
    seen: false
  }, {
    id: "210",
    code: "CE 221",
    group: "6",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40, Cuma 12:10 - 13:50",
    time: [38, 39, 40, 69, 70],
    seen: false
  }, {
    id: "211",
    code: "CE 302",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Perşembe 08:30 - 10:10",
    time: [1, 2, 49, 50],
    seen: false
  }, {
    id: "212",
    code: "CE 302",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Cuma 12:10 - 13:50",
    time: [7, 8, 69, 70],
    seen: false
  }, {
    id: "213",
    code: "CE 303",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05, Cuma 08:30 - 10:10",
    time: [1, 2, 3, 65, 66],
    seen: false
  }, {
    id: "214",
    code: "CE 303",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05, Cuma 10:20 - 12:00",
    time: [1, 2, 3, 67, 68],
    seen: false
  }, {
    id: "215",
    code: "CE 303",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05, Cuma 14:55 - 16:35",
    time: [17, 18, 19, 72, 73],
    seen: false
  }, {
    id: "216",
    code: "CE 308",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30, Çarşamba 13:05 - 14:45",
    time: [24, 25, 26, 38, 39],
    seen: false
  }, {
    id: "217",
    code: "CE 308",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30, Perşembe 10:20 - 12:00",
    time: [40, 41, 42, 51, 52],
    seen: false
  }, {
    id: "218",
    code: "CE 315",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30, Çarşamba 13:05 - 14:45",
    time: [24, 25, 26, 38, 39],
    seen: false
  }, {
    id: "219",
    code: "CE 315",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30, Perşembe 10:20 - 12:00",
    time: [40, 41, 42, 51, 52],
    seen: false
  }, {
    id: "220",
    code: "CE 323",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05, Cuma 08:30 - 10:10",
    time: [1, 2, 3, 65, 66],
    seen: false
  }, {
    id: "221",
    code: "CE 323",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05, Cuma 10:20 - 12:00",
    time: [1, 2, 3, 67, 68],
    seen: false
  }, {
    id: "222",
    code: "CE 323",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05, Cuma 14:55 - 16:35",
    time: [17, 18, 19, 72, 73],
    seen: false
  }, {
    id: "223",
    code: "CE 342",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Perşembe 08:30 - 10:10",
    time: [1, 2, 49, 50],
    seen: false
  }, {
    id: "224",
    code: "CE 342",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Cuma 12:10 - 13:50",
    time: [7, 8, 69, 70],
    seen: false
  }, {
    id: "225",
    code: "CE 476",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "226",
    code: "CE 477",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "227",
    code: "CE 490",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "228",
    code: "CE 518",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 18:35 - 21:10",
    time: [76, 77, 78],
    seen: false
  }, {
    id: "229",
    code: "CE 534",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "230",
    code: "CE 601",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "231",
    code: "CE 605",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "232",
    code: "CE 695",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 18:35 - 19:20",
    time: [92],
    seen: false
  }, {
    id: "233",
    code: "CE 698",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "234",
    code: "CE 699",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "235",
    code: "CG 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55, Salı 13:05 - 14:45",
    time: [3, 4, 5, 22, 23],
    seen: false
  }, {
    id: "236",
    code: "CG 103",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30",
    time: [24, 25, 26],
    seen: false
  }, {
    id: "237",
    code: "CG 105",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Çarşamba 10:20 - 12:00",
    time: [19, 20, 35, 36],
    seen: false
  }, {
    id: "238",
    code: "CG 107",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "239",
    code: "CG 201",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:55, Cuma 08:30 - 12:55",
    time: [49, 50, 51, 52, 53, 65, 66, 67, 68, 69],
    seen: false
  }, {
    id: "240",
    code: "CG 203",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "241",
    code: "CG 205",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 17:30",
    time: [39, 40, 41, 42],
    seen: false
  }, {
    id: "242",
    code: "CG 207",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "243",
    code: "CG 211",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00",
    time: [19, 20],
    seen: false
  }, {
    id: "244",
    code: "CG 212",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00",
    time: [35, 36],
    seen: false
  }, {
    id: "245",
    code: "CG 213",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "246",
    code: "CG 217",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40",
    time: [7, 8],
    seen: false
  }, {
    id: "247",
    code: "CG 222",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00",
    time: [19, 20],
    seen: false
  }, {
    id: "248",
    code: "CHEM 100",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Çarşamba 11:15 - 12:55",
    time: [3, 4, 36, 37],
    seen: false
  }, {
    id: "249",
    code: "CHEM 100",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Çarşamba 11:15 - 12:55",
    time: [6, 7, 36, 37],
    seen: false
  }, {
    id: "250",
    code: "CHEM 100",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35, Çarşamba 09:25 - 11:05",
    time: [8, 9, 34, 35],
    seen: false
  }, {
    id: "251",
    code: "CHEM 100",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 09:25 - 11:05, Perşembe 14:55 - 16:35",
    time: [18, 19, 56, 57],
    seen: false
  }, {
    id: "252",
    code: "CHEM 100",
    group: "5",
    type: "Yüz yüze",
    day: "Salı 14:55 - 16:35, Çarşamba 09:25 - 11:05",
    time: [24, 25, 34, 35],
    seen: false
  }, {
    id: "253",
    code: "CHN 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Çarşamba 17:40 - 19:20",
    time: [9, 10, 43, 44],
    seen: false
  }, {
    id: "254",
    code: "CHN 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 17:40 - 19:20, Perşembe 17:40 - 19:20",
    time: [11, 12, 59, 60],
    seen: false
  }, {
    id: "255",
    code: "CHN 301",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 17:30, Perşembe 15:50 - 17:30",
    time: [25, 26, 57, 58],
    seen: false
  }, {
    id: "256",
    code: "CIVE 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "257",
    code: "CIVE 205",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Cuma 08:30 - 10:10",
    time: [9, 10, 65, 66],
    seen: false
  }, {
    id: "258",
    code: "CIVE 207",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Cuma 08:30 - 10:10",
    time: [9, 10, 65, 66],
    seen: false
  }, {
    id: "259",
    code: "CIVE 209",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "260",
    code: "CIVE 219",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "261",
    code: "CIVE 301",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40, Cuma 13:05 - 14:45",
    time: [38, 39, 40, 70, 71],
    seen: false
  }, {
    id: "262",
    code: "CIVE 302",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40, Salı 15:50 - 17:30",
    time: [6, 7, 8, 25, 26],
    seen: false
  }, {
    id: "263",
    code: "CIVE 303",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40, Cuma 11:15 - 12:55",
    time: [54, 55, 56, 68, 69],
    seen: false
  }, {
    id: "264",
    code: "CIVE 304",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:55 - 17:30",
    time: [72, 73, 74],
    seen: false
  }, {
    id: "265",
    code: "CIVE 305",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00, Salı 08:30 - 10:10",
    time: [2, 3, 4, 17, 18],
    seen: false
  }, {
    id: "266",
    code: "CIVE 305",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40, Perşembe 08:30 - 10:10",
    time: [22, 23, 24, 49, 50],
    seen: false
  }, {
    id: "267",
    code: "CIVE 309",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40, Cuma 13:05 - 14:45",
    time: [38, 39, 40, 70, 71],
    seen: false
  }, {
    id: "268",
    code: "CIVE 311",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40, Salı 15:50 - 17:30",
    time: [6, 7, 8, 25, 26],
    seen: false
  }, {
    id: "269",
    code: "CIVE 314",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40, Cuma 11:15 - 12:55",
    time: [54, 55, 56, 68, 69],
    seen: false
  }, {
    id: "270",
    code: "CIVE 324",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:55 - 17:30",
    time: [72, 73, 74],
    seen: false
  }, {
    id: "271",
    code: "CIVE 414",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "272",
    code: "CIVE 418",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "273",
    code: "CIVE 424",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "274",
    code: "CIVE 425",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "275",
    code: "CIVE 428",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "276",
    code: "CIVE 438",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "277",
    code: "CIVE 441",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "278",
    code: "CIVE 480",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "279",
    code: "CIVE 490",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Çarşamba 08:30 - 10:10",
    time: [9, 10, 33, 34],
    seen: false
  }, {
    id: "280",
    code: "CLM 101",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "281",
    code: "CLM 101",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "282",
    code: "CLM 103",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:55",
    time: [49, 50, 51, 52, 53],
    seen: false
  }, {
    id: "283",
    code: "CLM 103",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 18:25",
    time: [55, 56, 57, 58, 59],
    seen: false
  }, {
    id: "284",
    code: "CLM 103",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:55",
    time: [65, 66, 67, 68, 69],
    seen: false
  }, {
    id: "285",
    code: "CLM 103",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 18:25",
    time: [71, 72, 73, 74, 75],
    seen: false
  }, {
    id: "286",
    code: "CLM 105",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "287",
    code: "CLM 105",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "288",
    code: "CLM 200",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "289",
    code: "CLM 209",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "290",
    code: "CLM 211",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "291",
    code: "CLM 213",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:55",
    time: [1, 2, 3, 4, 5],
    seen: false
  }, {
    id: "292",
    code: "CLM 213",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 18:25",
    time: [7, 8, 9, 10, 11],
    seen: false
  }, {
    id: "293",
    code: "CLM 213",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:55",
    time: [17, 18, 19, 20, 21],
    seen: false
  }, {
    id: "294",
    code: "CLM 213",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 14:00 - 18:25",
    time: [23, 24, 25, 26, 27],
    seen: false
  }, {
    id: "295",
    code: "CLM 215",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00, Çarşamba 15:50 - 17:30",
    time: [1, 2, 3, 4, 41, 42],
    seen: false
  }, {
    id: "296",
    code: "CLM 215",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35, Çarşamba 15:50 - 17:30",
    time: [6, 7, 8, 9, 41, 42],
    seen: false
  }, {
    id: "297",
    code: "CLM 215",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Çarşamba 15:50 - 17:30",
    time: [17, 18, 19, 20, 41, 42],
    seen: false
  }, {
    id: "298",
    code: "CLM 215",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 13:05 - 16:35, Çarşamba 15:50 - 17:30",
    time: [22, 23, 24, 25, 41, 42],
    seen: false
  }, {
    id: "299",
    code: "CLM 217",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 14:45",
    time: [38, 39],
    seen: false
  }, {
    id: "300",
    code: "CLM 219",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "301",
    code: "CLM 220",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:55",
    time: [66, 67, 68, 69],
    seen: false
  }, {
    id: "302",
    code: "CLM 223",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 19:20",
    time: [41, 42, 43, 44],
    seen: false
  }, {
    id: "303",
    code: "CLM 301",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 15:40",
    time: [17, 18, 19, 20, 21, 22, 23, 24],
    seen: false
  }, {
    id: "304",
    code: "CLM 301",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 15:40",
    time: [33, 34, 35, 36, 37, 38, 39, 40],
    seen: false
  }, {
    id: "305",
    code: "CLM 305",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:55",
    time: [1, 2, 3, 4, 5],
    seen: false
  }, {
    id: "306",
    code: "CLM 305",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 18:25",
    time: [7, 8, 9, 10, 11],
    seen: false
  }, {
    id: "307",
    code: "CLM 317",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:55",
    time: [50, 51, 52, 53],
    seen: false
  }, {
    id: "308",
    code: "CLM 321",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 19:20",
    time: [73, 74, 75, 76],
    seen: false
  }, {
    id: "309",
    code: "CLM 325",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 19:20",
    time: [41, 42, 43, 44],
    seen: false
  }, {
    id: "310",
    code: "CLM 331",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 19:20",
    time: [57, 58, 59, 60],
    seen: false
  }, {
    id: "311",
    code: "CLM 331",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 15:40",
    time: [53, 54, 55, 56],
    seen: false
  }, {
    id: "312",
    code: "CLM 333",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "313",
    code: "CLM 355",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "314",
    code: "CLM 401",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 13:50",
    time: [49, 50, 51, 52, 53, 54],
    seen: false
  }, {
    id: "315",
    code: "CLM 401",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 13:50",
    time: [65, 66, 67, 68, 69, 70],
    seen: false
  }, {
    id: "316",
    code: "CLM 413",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 15:40",
    time: [49, 50, 51, 52, 53, 54, 55, 56],
    seen: false
  }, {
    id: "317",
    code: "CLM 413",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 15:40",
    time: [65, 66, 67, 68, 69, 70, 71, 72],
    seen: false
  }, {
    id: "318",
    code: "CLM 426",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 19:20",
    time: [25, 26, 27, 28],
    seen: false
  }, {
    id: "319",
    code: "CLM 433",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "320",
    code: "CLM 495",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "321",
    code: "CLM 495",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "322",
    code: "CLM 495",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "323",
    code: "CLM 495",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "324",
    code: "CLM 495",
    group: "5",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:55",
    time: [18, 19, 20, 21],
    seen: false
  }, {
    id: "325",
    code: "CLM 495",
    group: "6",
    type: "Yüz yüze",
    day: "Salı 15:50 - 19:20",
    time: [25, 26, 27, 28],
    seen: false
  }, {
    id: "326",
    code: "CLM 497",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "327",
    code: "CLM 497",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "328",
    code: "CLM 497",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "329",
    code: "CLM 497",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "330",
    code: "CLM 497",
    group: "5",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:55",
    time: [18, 19, 20, 21],
    seen: false
  }, {
    id: "331",
    code: "CLM 497",
    group: "6",
    type: "Yüz yüze",
    day: "Salı 15:50 - 19:20",
    time: [25, 26, 27, 28],
    seen: false
  }, {
    id: "332",
    code: "COMM 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "333",
    code: "COMM 101",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "334",
    code: "COMM 101",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "335",
    code: "COMM 101",
    group: "4",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "336",
    code: "COMM 102",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Cuma 09:25 - 11:05",
    time: [1, 2, 66, 67],
    seen: false
  }, {
    id: "337",
    code: "COMM 102",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 12:10 - 13:50, Perşembe 09:25 - 11:05",
    time: [21, 22, 50, 51],
    seen: false
  }, {
    id: "338",
    code: "CPSY 510",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "339",
    code: "CPSY 512",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "340",
    code: "CPSY 512",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "341",
    code: "CPSY 512",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "342",
    code: "CPSY 512",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 11:15 - 13:50",
    time: [68, 69, 70],
    seen: false
  }, {
    id: "343",
    code: "CPSY 512",
    group: "5",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "344",
    code: "CPSY 512",
    group: "6",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "345",
    code: "CPSY 512",
    group: "7",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "346",
    code: "CPSY 514",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "347",
    code: "CPSY 517",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "348",
    code: "DM 401",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05, Cuma 08:30 - 11:05",
    time: [17, 18, 19, 65, 66, 67],
    seen: false
  }, {
    id: "349",
    code: "DM 410",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "350",
    code: "DT 100",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "351",
    code: "DT 100",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "352",
    code: "DT 191",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "353",
    code: "DT 191",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "354",
    code: "DT 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "355",
    code: "DT 201",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30",
    time: [24, 25, 26],
    seen: false
  }, {
    id: "356",
    code: "DT 203",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "357",
    code: "DT 205",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "358",
    code: "DT 206",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:55 - 17:30",
    time: [72, 73, 74],
    seen: false
  }, {
    id: "359",
    code: "DT 207",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "360",
    code: "DT 207",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "361",
    code: "DT 209",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 17:30",
    time: [57, 58],
    seen: false
  }, {
    id: "362",
    code: "DT 214",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "363",
    code: "DT 291",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "364",
    code: "DT 291",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "365",
    code: "DT 293",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:55 - 17:30",
    time: [72, 73, 74],
    seen: false
  }, {
    id: "366",
    code: "ECON 101",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "367",
    code: "ECON 101",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "368",
    code: "ECON 101",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "369",
    code: "ECON 101",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "370",
    code: "ECON 101",
    group: "5",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "371",
    code: "ECON 101",
    group: "6",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "372",
    code: "ECON 101",
    group: "7",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "373",
    code: "ECON 101",
    group: "8",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "374",
    code: "ECON 211",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "375",
    code: "ECON 215",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "376",
    code: "ECON 280",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 11:05, Salı 09:25 - 11:05",
    time: [2, 3, 18, 19],
    seen: false
  }, {
    id: "377",
    code: "ECON 280",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 13:50, Perşembe 10:20 - 12:00",
    time: [5, 6, 51, 52],
    seen: false
  }, {
    id: "378",
    code: "ECON 280",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 09:25 - 11:05, Çarşamba 09:25 - 11:05",
    time: [18, 19, 34, 35],
    seen: false
  }, {
    id: "379",
    code: "ECON 280",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 12:10 - 13:50, Perşembe 12:10 - 13:50",
    time: [21, 22, 53, 54],
    seen: false
  }, {
    id: "380",
    code: "ECON 280",
    group: "5",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Çarşamba 11:15 - 12:55",
    time: [23, 24, 36, 37],
    seen: false
  }, {
    id: "381",
    code: "ECON 280",
    group: "6",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 11:05, Cuma 12:10 - 13:50",
    time: [66, 67, 69, 70],
    seen: false
  }, {
    id: "382",
    code: "ECON 300",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "383",
    code: "ECON 301",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "384",
    code: "ECON 303",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "385",
    code: "ECON 305",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "386",
    code: "ECON 315",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "387",
    code: "ECON 401",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "388",
    code: "ECON 409",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "389",
    code: "ECON 411",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "390",
    code: "ECON 444",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "391",
    code: "ECON 496",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 12:55",
    time: [83, 84, 85],
    seen: false
  }, {
    id: "392",
    code: "ECON 496",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 15:50 - 18:25",
    time: [89, 90, 91],
    seen: false
  }, {
    id: "393",
    code: "ECON 514",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "394",
    code: "ECON 527",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 18:35 - 21:10",
    time: [76, 77, 78],
    seen: false
  }, {
    id: "395",
    code: "ECON 535",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "396",
    code: "EEE 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Salı 12:10 - 12:55, Çarşamba 13:05 - 14:45",
    time: [1, 2, 21, 38, 39],
    seen: false
  }, {
    id: "397",
    code: "EEE 201",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Salı 13:05 - 13:50, Perşembe 12:10 - 13:50",
    time: [3, 4, 22, 53, 54],
    seen: false
  }, {
    id: "398",
    code: "EEE 201",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 13:05 - 13:50, Perşembe 12:10 - 13:50, Perşembe 15:50 - 17:30",
    time: [22, 53, 54, 57, 58],
    seen: false
  }, {
    id: "399",
    code: "EEE 205",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Çarşamba 11:15 - 12:55",
    time: [17, 18, 36, 37],
    seen: false
  }, {
    id: "400",
    code: "EEE 205",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "401",
    code: "EEE 205",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00, Cuma 12:10 - 13:50",
    time: [35, 36, 69, 70],
    seen: false
  }, {
    id: "402",
    code: "EEE 205",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 11:05, Cuma 14:00 - 15:40",
    time: [66, 67, 71, 72],
    seen: false
  }, {
    id: "403",
    code: "EEE 205",
    group: "5",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Cuma 09:25 - 11:05",
    time: [23, 24, 66, 67],
    seen: false
  }, {
    id: "404",
    code: "EEE 205",
    group: "6",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Perşembe 13:05 - 14:45",
    time: [17, 18, 54, 55],
    seen: false
  }, {
    id: "405",
    code: "EEE 207",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Salı 12:10 - 12:55, Çarşamba 13:05 - 14:45",
    time: [1, 2, 21, 38, 39],
    seen: false
  }, {
    id: "406",
    code: "EEE 207",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Salı 13:05 - 13:50, Perşembe 12:10 - 13:50",
    time: [3, 4, 22, 53, 54],
    seen: false
  }, {
    id: "407",
    code: "EEE 207",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 13:05 - 13:50, Perşembe 12:10 - 13:50, Perşembe 15:50 - 17:30",
    time: [22, 53, 54, 57, 58],
    seen: false
  }, {
    id: "408",
    code: "EEE 211",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 15:40",
    time: [5, 6, 7, 8],
    seen: false
  }, {
    id: "409",
    code: "EEE 211",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 13:50, Perşembe 08:30 - 10:10",
    time: [5, 6, 49, 50],
    seen: false
  }, {
    id: "410",
    code: "EEE 213",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 15:40",
    time: [5, 6, 7, 8],
    seen: false
  }, {
    id: "411",
    code: "EEE 213",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 13:50, Perşembe 08:30 - 10:10",
    time: [5, 6, 49, 50],
    seen: false
  }, {
    id: "412",
    code: "EEE 215",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50, Salı 15:50 - 17:30",
    time: [20, 21, 22, 25, 26],
    seen: false
  }, {
    id: "413",
    code: "EEE 215",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50, Perşembe 11:15 - 12:55",
    time: [20, 21, 22, 52, 53],
    seen: false
  }, {
    id: "414",
    code: "EEE 215",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05, Cuma 08:30 - 10:10",
    time: [49, 50, 51, 65, 66],
    seen: false
  }, {
    id: "415",
    code: "EEE 215",
    group: "4",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05, Cuma 10:20 - 12:00",
    time: [49, 50, 51, 67, 68],
    seen: false
  }, {
    id: "416",
    code: "EEE 242",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Çarşamba 15:50 - 17:30",
    time: [19, 20, 41, 42],
    seen: false
  }, {
    id: "417",
    code: "EEE 242",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 13:50, Perşembe 12:10 - 13:50",
    time: [5, 6, 53, 54],
    seen: false
  }, {
    id: "418",
    code: "EEE 242",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Perşembe 12:10 - 13:50",
    time: [9, 10, 53, 54],
    seen: false
  }, {
    id: "419",
    code: "EEE 242",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:55, Çarşamba 13:05 - 14:45",
    time: [4, 5, 38, 39],
    seen: false
  }, {
    id: "420",
    code: "EEE 281",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Perşembe 14:00 - 15:40",
    time: [19, 20, 55, 56],
    seen: false
  }, {
    id: "421",
    code: "EEE 281",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Perşembe 10:20 - 12:00",
    time: [23, 24, 51, 52],
    seen: false
  }, {
    id: "422",
    code: "EEE 301",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35, Perşembe 13:05 - 14:45",
    time: [23, 24, 25, 54, 55],
    seen: false
  }, {
    id: "423",
    code: "EEE 301",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35, Perşembe 14:55 - 16:35",
    time: [23, 24, 25, 56, 57],
    seen: false
  }, {
    id: "424",
    code: "EEE 301",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40, Cuma 12:10 - 13:50",
    time: [22, 23, 24, 69, 70],
    seen: false
  }, {
    id: "425",
    code: "EEE 301",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45, Cuma 14:00 - 15:40",
    time: [21, 22, 23, 71, 72],
    seen: false
  }, {
    id: "426",
    code: "EEE 307",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 13:50",
    time: [3, 4, 5, 6],
    seen: false
  }, {
    id: "427",
    code: "EEE 307",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Çarşamba 08:30 - 10:10",
    time: [3, 4, 33, 34],
    seen: false
  }, {
    id: "428",
    code: "EEE 307",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Çarşamba 10:20 - 12:00",
    time: [3, 4, 35, 36],
    seen: false
  }, {
    id: "429",
    code: "EEE 307",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Çarşamba 12:10 - 13:50",
    time: [3, 4, 37, 38],
    seen: false
  }, {
    id: "430",
    code: "EEE 309",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35, Perşembe 13:05 - 14:45",
    time: [23, 24, 25, 54, 55],
    seen: false
  }, {
    id: "431",
    code: "EEE 309",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35, Perşembe 14:55 - 16:35",
    time: [23, 24, 25, 56, 57],
    seen: false
  }, {
    id: "432",
    code: "EEE 309",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40, Cuma 12:10 - 13:50",
    time: [22, 23, 24, 69, 70],
    seen: false
  }, {
    id: "433",
    code: "EEE 309",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45, Cuma 14:00 - 15:40",
    time: [21, 22, 23, 71, 72],
    seen: false
  }, {
    id: "434",
    code: "EEE 331",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Cuma 09:25 - 12:00",
    time: [17, 18, 66, 67, 68],
    seen: false
  }, {
    id: "435",
    code: "EEE 331",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Cuma 09:25 - 12:00",
    time: [19, 20, 66, 67, 68],
    seen: false
  }, {
    id: "436",
    code: "EEE 333",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Cuma 09:25 - 12:00",
    time: [17, 18, 66, 67, 68],
    seen: false
  }, {
    id: "437",
    code: "EEE 333",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Cuma 09:25 - 12:00",
    time: [19, 20, 66, 67, 68],
    seen: false
  }, {
    id: "438",
    code: "EEE 411",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 12:10 - 14:45",
    time: [69, 70, 71],
    seen: false
  }, {
    id: "439",
    code: "EEE 424",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Cuma 15:50 - 17:30",
    time: [7, 8, 73, 74],
    seen: false
  }, {
    id: "440",
    code: "EEE 461",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 13:50, Salı 12:10 - 13:50",
    time: [5, 6, 21, 22],
    seen: false
  }, {
    id: "441",
    code: "EEE 472",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "442",
    code: "EEE 514",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "443",
    code: "EEE 517",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "444",
    code: "EEE 551",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "445",
    code: "EEE 698",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 15:50 - 16:35",
    time: [89],
    seen: false
  }, {
    id: "446",
    code: "EEE 699",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "447",
    code: "EEE 699",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "448",
    code: "EEE 699",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "449",
    code: "EEE 699",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "450",
    code: "EISL 507",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "451",
    code: "EISL 515",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "452",
    code: "EISL 560",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 18:35 - 21:10",
    time: [76, 77, 78],
    seen: false
  }, {
    id: "453",
    code: "EISL 567",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "454",
    code: "ELT 501",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 18:35 - 21:10",
    time: [76, 77, 78],
    seen: false
  }, {
    id: "455",
    code: "ELT 523",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "456",
    code: "ELT 528",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "457",
    code: "ELT 530",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "458",
    code: "ENG 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "459",
    code: "ENG 101",
    group: "10",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "460",
    code: "ENG 101",
    group: "11",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "461",
    code: "ENG 101",
    group: "12",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "462",
    code: "ENG 101",
    group: "13",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "463",
    code: "ENG 101",
    group: "14",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "464",
    code: "ENG 101",
    group: "15",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "465",
    code: "ENG 101",
    group: "16",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "466",
    code: "ENG 101",
    group: "17",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "467",
    code: "ENG 101",
    group: "18",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "468",
    code: "ENG 101",
    group: "19",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "469",
    code: "ENG 101",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "470",
    code: "ENG 101",
    group: "20",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "471",
    code: "ENG 101",
    group: "21",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "472",
    code: "ENG 101",
    group: "22",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "473",
    code: "ENG 101",
    group: "23",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "474",
    code: "ENG 101",
    group: "24",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "475",
    code: "ENG 101",
    group: "25",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "476",
    code: "ENG 101",
    group: "26",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "477",
    code: "ENG 101",
    group: "27",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "478",
    code: "ENG 101",
    group: "28",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "479",
    code: "ENG 101",
    group: "29",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "480",
    code: "ENG 101",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "481",
    code: "ENG 101",
    group: "30",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "482",
    code: "ENG 101",
    group: "31",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "483",
    code: "ENG 101",
    group: "32",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "484",
    code: "ENG 101",
    group: "33",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "485",
    code: "ENG 101",
    group: "34",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "486",
    code: "ENG 101",
    group: "35",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "487",
    code: "ENG 101",
    group: "36",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "488",
    code: "ENG 101",
    group: "37",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "489",
    code: "ENG 101",
    group: "38",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "490",
    code: "ENG 101",
    group: "39",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "491",
    code: "ENG 101",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "492",
    code: "ENG 101",
    group: "40",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "493",
    code: "ENG 101",
    group: "41",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "494",
    code: "ENG 101",
    group: "42",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "495",
    code: "ENG 101",
    group: "43",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "496",
    code: "ENG 101",
    group: "44",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "497",
    code: "ENG 101",
    group: "45",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "498",
    code: "ENG 101",
    group: "46",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "499",
    code: "ENG 101",
    group: "47",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "500",
    code: "ENG 101",
    group: "48",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "501",
    code: "ENG 101",
    group: "49",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "502",
    code: "ENG 101",
    group: "5",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "503",
    code: "ENG 101",
    group: "50",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "504",
    code: "ENG 101",
    group: "51",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "505",
    code: "ENG 101",
    group: "52",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "506",
    code: "ENG 101",
    group: "53",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "507",
    code: "ENG 101",
    group: "54",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "508",
    code: "ENG 101",
    group: "55",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "509",
    code: "ENG 101",
    group: "56",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "510",
    code: "ENG 101",
    group: "57",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "511",
    code: "ENG 101",
    group: "58",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "512",
    code: "ENG 101",
    group: "59",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "513",
    code: "ENG 101",
    group: "6",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "514",
    code: "ENG 101",
    group: "60",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "515",
    code: "ENG 101",
    group: "61",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "516",
    code: "ENG 101",
    group: "62",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "517",
    code: "ENG 101",
    group: "63",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "518",
    code: "ENG 101",
    group: "64",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "519",
    code: "ENG 101",
    group: "65",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "520",
    code: "ENG 101",
    group: "66",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "521",
    code: "ENG 101",
    group: "67",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "522",
    code: "ENG 101",
    group: "68",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "523",
    code: "ENG 101",
    group: "69",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "524",
    code: "ENG 101",
    group: "7",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "525",
    code: "ENG 101",
    group: "70",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "526",
    code: "ENG 101",
    group: "71",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "527",
    code: "ENG 101",
    group: "72",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "528",
    code: "ENG 101",
    group: "73",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "529",
    code: "ENG 101",
    group: "74",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "530",
    code: "ENG 101",
    group: "75",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "531",
    code: "ENG 101",
    group: "76",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "532",
    code: "ENG 101",
    group: "77",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 19:20",
    time: [74, 75, 76],
    seen: false
  }, {
    id: "533",
    code: "ENG 101",
    group: "78",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 19:20",
    time: [74, 75, 76],
    seen: false
  }, {
    id: "534",
    code: "ENG 101",
    group: "79",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 19:20",
    time: [74, 75, 76],
    seen: false
  }, {
    id: "535",
    code: "ENG 101",
    group: "8",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "536",
    code: "ENG 101",
    group: "80",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 19:20",
    time: [74, 75, 76],
    seen: false
  }, {
    id: "537",
    code: "ENG 101",
    group: "9",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "538",
    code: "ENG 410",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40",
    time: [7, 8],
    seen: false
  }, {
    id: "539",
    code: "ENG 410",
    group: "10",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40",
    time: [23, 24],
    seen: false
  }, {
    id: "540",
    code: "ENG 410",
    group: "11",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10",
    time: [33, 34],
    seen: false
  }, {
    id: "541",
    code: "ENG 410",
    group: "12",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10",
    time: [33, 34],
    seen: false
  }, {
    id: "542",
    code: "ENG 410",
    group: "13",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00",
    time: [35, 36],
    seen: false
  }, {
    id: "543",
    code: "ENG 410",
    group: "14",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00",
    time: [35, 36],
    seen: false
  }, {
    id: "544",
    code: "ENG 410",
    group: "15",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:00",
    time: [51, 52],
    seen: false
  }, {
    id: "545",
    code: "ENG 410",
    group: "16",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:00",
    time: [51, 52],
    seen: false
  }, {
    id: "546",
    code: "ENG 410",
    group: "17",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 15:40",
    time: [55, 56],
    seen: false
  }, {
    id: "547",
    code: "ENG 410",
    group: "18",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 15:40",
    time: [55, 56],
    seen: false
  }, {
    id: "548",
    code: "ENG 410",
    group: "19",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 17:30",
    time: [57, 58],
    seen: false
  }, {
    id: "549",
    code: "ENG 410",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40",
    time: [7, 8],
    seen: false
  }, {
    id: "550",
    code: "ENG 410",
    group: "20",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 17:30",
    time: [57, 58],
    seen: false
  }, {
    id: "551",
    code: "ENG 410",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30",
    time: [9, 10],
    seen: false
  }, {
    id: "552",
    code: "ENG 410",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30",
    time: [9, 10],
    seen: false
  }, {
    id: "553",
    code: "ENG 410",
    group: "5",
    type: "Yüz yüze",
    day: "Pazartesi 17:40 - 19:20",
    time: [11, 12],
    seen: false
  }, {
    id: "554",
    code: "ENG 410",
    group: "6",
    type: "Yüz yüze",
    day: "Pazartesi 17:40 - 19:20",
    time: [11, 12],
    seen: false
  }, {
    id: "555",
    code: "ENG 410",
    group: "7",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00",
    time: [19, 20],
    seen: false
  }, {
    id: "556",
    code: "ENG 410",
    group: "8",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00",
    time: [19, 20],
    seen: false
  }, {
    id: "557",
    code: "ENG 410",
    group: "9",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40",
    time: [23, 24],
    seen: false
  }, {
    id: "558",
    code: "ETI 100",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "559",
    code: "ETI 100",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "560",
    code: "ETI 102",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "561",
    code: "ETI 102",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "562",
    code: "ETI 117",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "563",
    code: "ETI 117",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "564",
    code: "ETI 117",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "565",
    code: "ETI 120",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "566",
    code: "ETI 120",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "567",
    code: "ETI 121",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "568",
    code: "ETI 121",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "569",
    code: "ETI 123",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "570",
    code: "ETI 123",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "571",
    code: "ETI 125",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "572",
    code: "ETI 125",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "573",
    code: "ETI 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "574",
    code: "ETI 203",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "575",
    code: "ETI 203",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "576",
    code: "ETI 213",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "577",
    code: "ETI 213",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "578",
    code: "ETI 215",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "579",
    code: "ETI 215",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "580",
    code: "ETI 217",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "581",
    code: "ETI 217",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "582",
    code: "ETI 217",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "583",
    code: "ETI 217",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "584",
    code: "ETI 219",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "585",
    code: "ETI 219",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "586",
    code: "ETI 250",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "587",
    code: "ETI 250",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "588",
    code: "ETI 301",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "589",
    code: "ETI 301",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "590",
    code: "ETI 304",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "591",
    code: "ETI 307",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "592",
    code: "ETI 307",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "593",
    code: "ETI 307",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "594",
    code: "ETI 308",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "595",
    code: "ETI 310",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "596",
    code: "ETI 311",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "597",
    code: "ETI 311",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "598",
    code: "ETI 313",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "599",
    code: "ETI 319",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "600",
    code: "ETI 319",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "601",
    code: "ETI 320",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "602",
    code: "ETI 337",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "603",
    code: "ETI 337",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "604",
    code: "ETI 337",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "605",
    code: "ETI 338",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "606",
    code: "ETI 381",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "607",
    code: "ETI 421",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "608",
    code: "ETI 430",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "609",
    code: "ETI 430",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "610",
    code: "ETI 430",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "611",
    code: "ETI 430",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "612",
    code: "ETI 431",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "613",
    code: "EUTF 507",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 18:35 - 21:10",
    time: [44, 45, 46],
    seen: false
  }, {
    id: "614",
    code: "FA 111",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "615",
    code: "FA 111",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00",
    time: [17, 18, 19, 20],
    seen: false
  }, {
    id: "616",
    code: "FA 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Cuma 13:05 - 16:35",
    time: [17, 18, 19, 20, 70, 71, 72, 73],
    seen: false
  }, {
    id: "617",
    code: "FA 201",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 16:35, Cuma 08:30 - 12:00",
    time: [22, 23, 24, 25, 65, 66, 67, 68],
    seen: false
  }, {
    id: "618",
    code: "FA 203",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "619",
    code: "FA 203",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "620",
    code: "FA 205",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "621",
    code: "FA 207",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "622",
    code: "FA 207",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 16:35",
    time: [54, 55, 56, 57],
    seen: false
  }, {
    id: "623",
    code: "FA 213",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "624",
    code: "FA 213",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "625",
    code: "FA 301",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "626",
    code: "FA 316",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "627",
    code: "FA 390",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 16:35",
    time: [22, 23, 24, 25],
    seen: false
  }, {
    id: "628",
    code: "FA 411",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "629",
    code: "FA 427",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "630",
    code: "FB 301",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00",
    time: [17, 18, 19, 20],
    seen: false
  }, {
    id: "631",
    code: "FB 401",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 16:35",
    time: [54, 55, 56, 57],
    seen: false
  }, {
    id: "632",
    code: "FD 301",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35, Çarşamba 13:05 - 16:35",
    time: [6, 7, 8, 9, 38, 39, 40, 41],
    seen: false
  }, {
    id: "633",
    code: "FD 303",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "634",
    code: "FD 313",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00",
    time: [49, 50, 51, 52],
    seen: false
  }, {
    id: "635",
    code: "FD 401",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 65, 66, 67, 68],
    seen: false
  }, {
    id: "636",
    code: "FENG 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 17:40 - 19:20",
    time: [11, 12],
    seen: false
  }, {
    id: "637",
    code: "FENG 345",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Çarşamba 12:10 - 13:50",
    time: [19, 20, 37, 38],
    seen: false
  }, {
    id: "638",
    code: "FENG 345",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Çarşamba 12:10 - 13:50",
    time: [19, 20, 37, 38],
    seen: false
  }, {
    id: "639",
    code: "FENG 345",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10, Perşembe 12:10 - 13:50",
    time: [33, 34, 53, 54],
    seen: false
  }, {
    id: "640",
    code: "FENG 345",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10, Cuma 15:50 - 17:30",
    time: [33, 34, 73, 74],
    seen: false
  }, {
    id: "641",
    code: "FENG 345",
    group: "5",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10, Perşembe 11:15 - 12:55",
    time: [33, 34, 52, 53],
    seen: false
  }, {
    id: "642",
    code: "FENG 345",
    group: "6",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10, Perşembe 17:40 - 19:20",
    time: [33, 34, 59, 60],
    seen: false
  }, {
    id: "643",
    code: "FENG 346",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 17:40 - 20:15",
    time: [11, 12, 13],
    seen: false
  }, {
    id: "644",
    code: "FENG 495",
    group: "1",
    type: "Yüz yüze",
    day: "Pazar 20:25 - 22:05",
    time: [110, 111],
    seen: false
  }, {
    id: "645",
    code: "FENG 497",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 20:25 - 23:00, Cumartesi 23:10 - 23:55",
    time: [94, 95, 96],
    seen: false
  }, {
    id: "646",
    code: "FFD 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 17:30, Perşembe 14:00 - 17:30",
    time: [6, 7, 8, 9, 10, 55, 56, 57, 58],
    seen: false
  }, {
    id: "647",
    code: "FFD 101",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 17:30, Perşembe 14:00 - 17:30",
    time: [6, 7, 8, 9, 10, 55, 56, 57, 58],
    seen: false
  }, {
    id: "648",
    code: "FFD 101",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 17:30, Perşembe 14:00 - 17:30",
    time: [6, 7, 8, 9, 10, 55, 56, 57, 58],
    seen: false
  }, {
    id: "649",
    code: "FFD 101",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 17:30, Perşembe 14:00 - 17:30",
    time: [6, 7, 8, 9, 10, 55, 56, 57, 58],
    seen: false
  }, {
    id: "650",
    code: "FFD 111",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "651",
    code: "FFD 111",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "652",
    code: "FFD 111",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "653",
    code: "FFD 121",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00",
    time: [19, 20],
    seen: false
  }, {
    id: "654",
    code: "FFD 121",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45",
    time: [22, 23],
    seen: false
  }, {
    id: "655",
    code: "FFD 121",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 11:15 - 12:55",
    time: [36, 37],
    seen: false
  }, {
    id: "656",
    code: "FFD 121",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 14:45",
    time: [38, 39],
    seen: false
  }, {
    id: "657",
    code: "FFD 121",
    group: "5",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 10:10",
    time: [49, 50],
    seen: false
  }, {
    id: "658",
    code: "FFD 201",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 16:35",
    time: [38, 39, 40, 41],
    seen: false
  }, {
    id: "659",
    code: "FFD 201",
    group: "10",
    type: "Yüz yüze",
    day: "Salı 14:00 - 17:30",
    time: [23, 24, 25, 26],
    seen: false
  }, {
    id: "660",
    code: "FFD 201",
    group: "11",
    type: "Yüz yüze",
    day: "Salı 14:00 - 17:30",
    time: [23, 24, 25, 26],
    seen: false
  }, {
    id: "661",
    code: "FFD 201",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 16:35",
    time: [38, 39, 40, 41],
    seen: false
  }, {
    id: "662",
    code: "FFD 201",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 16:35",
    time: [38, 39, 40, 41],
    seen: false
  }, {
    id: "663",
    code: "FFD 201",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 16:35",
    time: [70, 71, 72, 73],
    seen: false
  }, {
    id: "664",
    code: "FFD 201",
    group: "5",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 16:35",
    time: [70, 71, 72, 73],
    seen: false
  }, {
    id: "665",
    code: "FFD 201",
    group: "6",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 15:40",
    time: [53, 54, 55, 56],
    seen: false
  }, {
    id: "666",
    code: "FFD 201",
    group: "7",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 15:40",
    time: [53, 54, 55, 56],
    seen: false
  }, {
    id: "667",
    code: "FFD 201",
    group: "8",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "668",
    code: "FFD 201",
    group: "9",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "669",
    code: "FFD 301",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00",
    time: [17, 18, 19, 20],
    seen: false
  }, {
    id: "670",
    code: "FFD 301",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 16:35",
    time: [22, 23, 24, 25],
    seen: false
  }, {
    id: "671",
    code: "FFD 301",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "672",
    code: "FFD 301",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 16:35",
    time: [38, 39, 40, 41],
    seen: false
  }, {
    id: "673",
    code: "FFD 451",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 13:50",
    time: [37, 38],
    seen: false
  }, {
    id: "674",
    code: "FFD 501",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "675",
    code: "FFD 503",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "676",
    code: "FFD 505",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 18:35 - 21:10",
    time: [76, 77, 78],
    seen: false
  }, {
    id: "677",
    code: "FFD 509",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "678",
    code: "FFD 514",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "679",
    code: "FFD 516",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "680",
    code: "FFD 601",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "681",
    code: "FFD 652",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "682",
    code: "FFD 656",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "683",
    code: "FFD 662",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "684",
    code: "FFD 695",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "685",
    code: "FFD 695",
    group: "10",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "686",
    code: "FFD 695",
    group: "11",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "687",
    code: "FFD 695",
    group: "12",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "688",
    code: "FFD 695",
    group: "13",
    type: "Yüz yüze",
    day: "Pazar 14:55 - 15:40",
    time: [104],
    seen: false
  }, {
    id: "689",
    code: "FFD 695",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "690",
    code: "FFD 695",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 15:50 - 16:35",
    time: [89],
    seen: false
  }, {
    id: "691",
    code: "FFD 695",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "692",
    code: "FFD 695",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "693",
    code: "FFD 695",
    group: "6",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "694",
    code: "FFD 695",
    group: "7",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "695",
    code: "FFD 695",
    group: "8",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "696",
    code: "FFD 695",
    group: "9",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "697",
    code: "FFD 697",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "698",
    code: "FFD 698",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "699",
    code: "FFD 698",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "700",
    code: "FFD 698",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "701",
    code: "FFD 699",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "702",
    code: "FFD 699",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "703",
    code: "FFD 699",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "704",
    code: "FFD 699",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "705",
    code: "FFD 699",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "706",
    code: "FFD 699",
    group: "6",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "707",
    code: "FFD 699",
    group: "7",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "708",
    code: "FFD 699",
    group: "8",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "709",
    code: "FR 103",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "710",
    code: "FR 103",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "711",
    code: "FR 103",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "712",
    code: "FR 103",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "713",
    code: "FR 103",
    group: "5",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "714",
    code: "FR 103",
    group: "6",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "715",
    code: "FR 104",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 17:30, Cuma 08:30 - 10:10",
    time: [25, 26, 65, 66],
    seen: false
  }, {
    id: "716",
    code: "FR 121",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55, Perşembe 11:15 - 12:55",
    time: [20, 21, 52, 53],
    seen: false
  }, {
    id: "717",
    code: "FR 121",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55, Perşembe 11:15 - 12:55",
    time: [20, 21, 52, 53],
    seen: false
  }, {
    id: "718",
    code: "FR 201",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "719",
    code: "FR 201",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "720",
    code: "FR 201",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "721",
    code: "FR 201",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "722",
    code: "FR 201",
    group: "5",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "723",
    code: "FR 202",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 15:40, Cuma 14:00 - 15:40",
    time: [39, 40, 71, 72],
    seen: false
  }, {
    id: "724",
    code: "FR 221",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 11:15 - 12:55, Cuma 11:15 - 12:55",
    time: [36, 37, 68, 69],
    seen: false
  }, {
    id: "725",
    code: "FR 221",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 11:15 - 12:55, Cuma 11:15 - 12:55",
    time: [36, 37, 68, 69],
    seen: false
  }, {
    id: "726",
    code: "FR 321",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Perşembe 14:00 - 15:40",
    time: [23, 24, 55, 56],
    seen: false
  }, {
    id: "727",
    code: "FR 321",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Perşembe 14:00 - 15:40",
    time: [23, 24, 55, 56],
    seen: false
  }, {
    id: "728",
    code: "FR 421",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Perşembe 14:00 - 15:40",
    time: [23, 24, 55, 56],
    seen: false
  }, {
    id: "729",
    code: "FR 421",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Perşembe 14:00 - 15:40",
    time: [23, 24, 55, 56],
    seen: false
  }, {
    id: "730",
    code: "FTR 101",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 16:35, Cuma 11:15 - 12:55",
    time: [54, 55, 56, 57, 68, 69],
    seen: false
  }, {
    id: "731",
    code: "FTR 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 18:25, Çarşamba 11:15 - 12:55",
    time: [7, 8, 9, 10, 11, 36, 37],
    seen: false
  }, {
    id: "732",
    code: "FTR 105",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:55, Çarşamba 08:30 - 10:10",
    time: [4, 5, 33, 34],
    seen: false
  }, {
    id: "733",
    code: "FTR 107",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30",
    time: [24, 25, 26],
    seen: false
  }, {
    id: "734",
    code: "FTR 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45, Çarşamba 13:05 - 14:45",
    time: [21, 22, 23, 38, 39],
    seen: false
  }, {
    id: "735",
    code: "FTR 203",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10",
    time: [17, 18],
    seen: false
  }, {
    id: "736",
    code: "FTR 205",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 10:10",
    time: [49, 50],
    seen: false
  }, {
    id: "737",
    code: "FTR 207",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30, Cuma 16:45 - 18:25",
    time: [41, 42, 74, 75],
    seen: false
  }, {
    id: "738",
    code: "FTR 209",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "739",
    code: "FTR 211",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "740",
    code: "FTR 213",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 17:40 - 19:20, Cuma 11:15 - 12:55",
    time: [27, 28, 68, 69],
    seen: false
  }, {
    id: "741",
    code: "FTR 301",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Salı 15:50 - 17:30",
    time: [19, 20, 25, 26],
    seen: false
  }, {
    id: "742",
    code: "FTR 303",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 17:30",
    time: [7, 8, 9, 10],
    seen: false
  }, {
    id: "743",
    code: "FTR 305",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 13:50",
    time: [4, 5, 6],
    seen: false
  }, {
    id: "744",
    code: "FTR 307",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "745",
    code: "FTR 310",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "746",
    code: "FTR 321",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "747",
    code: "FTR 322",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35",
    time: [8, 9],
    seen: false
  }, {
    id: "748",
    code: "FTR 326",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "749",
    code: "FTR 401",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00, Perşembe 08:30 - 12:00, Perşembe 13:05 - 16:35, Cuma 08:30 - 10:10, Cuma 12:10 - 15:40",
    time: [33, 34, 35, 36, 49, 50, 51, 52, 54, 55, 56, 57, 65, 66, 69, 70, 71, 72],
    seen: false
  }, {
    id: "750",
    code: "FTR 403",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10",
    time: [17, 18],
    seen: false
  }, {
    id: "751",
    code: "FYT 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Salı 14:00 - 17:30",
    time: [1, 2, 23, 24, 25, 26],
    seen: false
  }, {
    id: "752",
    code: "FYT 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00",
    time: [3, 4],
    seen: false
  }, {
    id: "753",
    code: "FYT 105",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30",
    time: [41, 42],
    seen: false
  }, {
    id: "754",
    code: "FYT 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45, Salı 08:30 - 12:00, Perşembe 09:25 - 12:55, Perşembe 14:00 - 17:30",
    time: [5, 6, 7, 17, 18, 19, 20, 50, 51, 52, 53, 55, 56, 57, 58],
    seen: false
  }, {
    id: "755",
    code: "FYT 201",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45, Salı 08:30 - 12:00, Cuma 09:25 - 12:55, Cuma 14:00 - 17:30",
    time: [5, 6, 7, 17, 18, 19, 20, 66, 67, 68, 69, 71, 72, 73, 74],
    seen: false
  }, {
    id: "756",
    code: "FYT 203",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 13:50",
    time: [21, 22],
    seen: false
  }, {
    id: "757",
    code: "GBE 100",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 11:05, Cuma 09:25 - 11:05",
    time: [34, 35, 66, 67],
    seen: false
  }, {
    id: "758",
    code: "GBE 100",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 11:05, Perşembe 12:10 - 13:50",
    time: [50, 51, 53, 54],
    seen: false
  }, {
    id: "759",
    code: "GBE 206",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 11:15 - 12:55, Perşembe 09:25 - 11:05",
    time: [36, 37, 50, 51],
    seen: false
  }, {
    id: "760",
    code: "GBE 220",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35, Salı 15:50 - 17:30",
    time: [8, 9, 25, 26],
    seen: false
  }, {
    id: "761",
    code: "GBE 220",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35, Salı 13:05 - 14:45",
    time: [8, 9, 22, 23],
    seen: false
  }, {
    id: "762",
    code: "GBE 251",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "763",
    code: "GBE 303",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 11:15 - 13:50",
    time: [68, 69, 70],
    seen: false
  }, {
    id: "764",
    code: "GBE 304",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "765",
    code: "GBE 306",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00, Perşembe 09:25 - 11:05",
    time: [18, 19, 20, 50, 51],
    seen: false
  }, {
    id: "766",
    code: "GBE 309",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00, Perşembe 09:25 - 11:05",
    time: [18, 19, 20, 50, 51],
    seen: false
  }, {
    id: "767",
    code: "GBE 309",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00, Perşembe 12:10 - 13:50",
    time: [18, 19, 20, 53, 54],
    seen: false
  }, {
    id: "768",
    code: "GBE 309",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00, Perşembe 14:55 - 16:35",
    time: [18, 19, 20, 56, 57],
    seen: false
  }, {
    id: "769",
    code: "GBE 315",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Çarşamba 11:15 - 12:55",
    time: [6, 7, 36, 37],
    seen: false
  }, {
    id: "770",
    code: "GBE 315",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Çarşamba 14:55 - 16:35",
    time: [6, 7, 40, 41],
    seen: false
  }, {
    id: "771",
    code: "GBE 350",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "772",
    code: "GBE 360",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "773",
    code: "GBE 401",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Cuma 14:55 - 18:25",
    time: [3, 4, 72, 73, 74, 75],
    seen: false
  }, {
    id: "774",
    code: "GBE 407",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 13:50, Çarşamba 13:05 - 14:45",
    time: [21, 22, 38, 39],
    seen: false
  }, {
    id: "775",
    code: "GBE 412",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "776",
    code: "GD 304",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00",
    time: [49, 50, 51, 52],
    seen: false
  }, {
    id: "777",
    code: "GD 350",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 15:40",
    time: [53, 54, 55, 56],
    seen: false
  }, {
    id: "778",
    code: "GD 403",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 15:40",
    time: [37, 38, 39, 40],
    seen: false
  }, {
    id: "779",
    code: "GEAR 201",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "780",
    code: "GEAR 203",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "781",
    code: "GEAR 206",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "782",
    code: "GEAR 211",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "783",
    code: "GEAR 211",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "784",
    code: "GEAR 212",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 19:20",
    time: [73, 74, 75, 76],
    seen: false
  }, {
    id: "785",
    code: "GEAR 220",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "786",
    code: "GEAR 306",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "787",
    code: "GEAR 307",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "788",
    code: "GEEC 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "789",
    code: "GEEC 203",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "790",
    code: "GEEC 203",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "791",
    code: "GEEC 203",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "792",
    code: "GEEC 204",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "793",
    code: "GEEC 204",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "794",
    code: "GEEC 204",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 19:20",
    time: [74, 75, 76],
    seen: false
  }, {
    id: "795",
    code: "GEET 202",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "796",
    code: "GEET 304",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "797",
    code: "GEET 304",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50",
    time: [20, 21, 22],
    seen: false
  }, {
    id: "798",
    code: "GEET 304",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "799",
    code: "GEET 304",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "800",
    code: "GEET 310",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "801",
    code: "GEET 310",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 19:20",
    time: [74, 75, 76],
    seen: false
  }, {
    id: "802",
    code: "GEET 310",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "803",
    code: "GEET 312",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 13:50",
    time: [4, 5, 6],
    seen: false
  }, {
    id: "804",
    code: "GEET 312",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 11:15 - 13:50",
    time: [36, 37, 38],
    seen: false
  }, {
    id: "805",
    code: "GEET 312",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 11:15 - 13:50",
    time: [52, 53, 54],
    seen: false
  }, {
    id: "806",
    code: "GEHU 202",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "807",
    code: "GEHU 202",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "808",
    code: "GEHU 205",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "809",
    code: "GEHU 205",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "810",
    code: "GEHU 209",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "811",
    code: "GEHU 209",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "812",
    code: "GEHU 209",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "813",
    code: "GEHU 209",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "814",
    code: "GEHU 209",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 12:55",
    time: [83, 84, 85],
    seen: false
  }, {
    id: "815",
    code: "GEHU 209",
    group: "6",
    type: "Yüz yüze",
    day: "Perşembe 11:15 - 13:50",
    time: [52, 53, 54],
    seen: false
  }, {
    id: "816",
    code: "GEHU 212",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "817",
    code: "GEHU 218",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "818",
    code: "GEHU 218",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "819",
    code: "GEHU 218",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "820",
    code: "GEHU 218",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "821",
    code: "GEHU 218",
    group: "5",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "822",
    code: "GEHU 301",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "823",
    code: "GEIN 304",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 19:20",
    time: [9, 10, 11, 12],
    seen: false
  }, {
    id: "824",
    code: "GEIN 304",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 15:50 - 19:20",
    time: [25, 26, 27, 28],
    seen: false
  }, {
    id: "825",
    code: "GEIN 304",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 19:20",
    time: [41, 42, 43, 44],
    seen: false
  }, {
    id: "826",
    code: "GEIN 304",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 19:20",
    time: [73, 74, 75, 76],
    seen: false
  }, {
    id: "827",
    code: "GEIN 310",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "828",
    code: "GEIN 315",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "829",
    code: "GEMC 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "830",
    code: "GENS 207",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50",
    time: [20, 21, 22],
    seen: false
  }, {
    id: "831",
    code: "GENS 207",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "832",
    code: "GER 101",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "833",
    code: "GER 101",
    group: "10",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "834",
    code: "GER 101",
    group: "11",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "835",
    code: "GER 101",
    group: "12",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "836",
    code: "GER 101",
    group: "13",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "837",
    code: "GER 101",
    group: "14",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "838",
    code: "GER 101",
    group: "15",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "839",
    code: "GER 101",
    group: "16",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "840",
    code: "GER 101",
    group: "17",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "841",
    code: "GER 101",
    group: "18",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "842",
    code: "GER 101",
    group: "19",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "843",
    code: "GER 101",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "844",
    code: "GER 101",
    group: "20",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "845",
    code: "GER 101",
    group: "21",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "846",
    code: "GER 101",
    group: "22",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "847",
    code: "GER 101",
    group: "23",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "848",
    code: "GER 101",
    group: "24",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "849",
    code: "GER 101",
    group: "25",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "850",
    code: "GER 101",
    group: "26",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "851",
    code: "GER 101",
    group: "27",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "852",
    code: "GER 101",
    group: "28",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "853",
    code: "GER 101",
    group: "29",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "854",
    code: "GER 101",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "855",
    code: "GER 101",
    group: "30",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "856",
    code: "GER 101",
    group: "31",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "857",
    code: "GER 101",
    group: "32",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "858",
    code: "GER 101",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "859",
    code: "GER 101",
    group: "5",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "860",
    code: "GER 101",
    group: "6",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "861",
    code: "GER 101",
    group: "7",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "862",
    code: "GER 101",
    group: "8",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "863",
    code: "GER 101",
    group: "9",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "864",
    code: "GER 102",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 17:40 - 19:20, Cuma 14:00 - 15:40",
    time: [11, 12, 71, 72],
    seen: false
  }, {
    id: "865",
    code: "GER 102",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Perşembe 14:00 - 15:40",
    time: [23, 24, 55, 56],
    seen: false
  }, {
    id: "866",
    code: "GER 102",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Çarşamba 14:00 - 15:40",
    time: [3, 4, 39, 40],
    seen: false
  }, {
    id: "867",
    code: "GER 111",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 16:35, Cuma 10:20 - 12:00",
    time: [56, 57, 67, 68],
    seen: false
  }, {
    id: "868",
    code: "GER 121",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05, Perşembe 08:30 - 11:05",
    time: [33, 34, 35, 49, 50, 51],
    seen: false
  }, {
    id: "869",
    code: "GER 201",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "870",
    code: "GER 201",
    group: "10",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "871",
    code: "GER 201",
    group: "11",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "872",
    code: "GER 201",
    group: "12",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "873",
    code: "GER 201",
    group: "13",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "874",
    code: "GER 201",
    group: "14",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "875",
    code: "GER 201",
    group: "15",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "876",
    code: "GER 201",
    group: "16",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "877",
    code: "GER 201",
    group: "17",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "878",
    code: "GER 201",
    group: "18",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "879",
    code: "GER 201",
    group: "19",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "880",
    code: "GER 201",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "881",
    code: "GER 201",
    group: "20",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 19:20",
    time: [74, 75, 76],
    seen: false
  }, {
    id: "882",
    code: "GER 201",
    group: "21",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 19:20",
    time: [74, 75, 76],
    seen: false
  }, {
    id: "883",
    code: "GER 201",
    group: "22",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "884",
    code: "GER 201",
    group: "23",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "885",
    code: "GER 201",
    group: "24",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "886",
    code: "GER 201",
    group: "25",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "887",
    code: "GER 201",
    group: "26",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "888",
    code: "GER 201",
    group: "27",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "889",
    code: "GER 201",
    group: "28",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "890",
    code: "GER 201",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "891",
    code: "GER 201",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "892",
    code: "GER 201",
    group: "5",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "893",
    code: "GER 201",
    group: "6",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "894",
    code: "GER 201",
    group: "7",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "895",
    code: "GER 201",
    group: "8",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "896",
    code: "GER 201",
    group: "9",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "897",
    code: "GER 202",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Çarşamba 14:00 - 15:40",
    time: [7, 8, 39, 40],
    seen: false
  }, {
    id: "898",
    code: "GER 202",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Çarşamba 15:50 - 17:30",
    time: [23, 24, 41, 42],
    seen: false
  }, {
    id: "899",
    code: "GER 202",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Çarşamba 14:00 - 15:40",
    time: [19, 20, 39, 40],
    seen: false
  }, {
    id: "900",
    code: "GER 221",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05, Salı 08:30 - 11:05",
    time: [1, 2, 3, 17, 18, 19],
    seen: false
  }, {
    id: "901",
    code: "GS 591",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 18:35 - 21:10",
    time: [44, 45, 46],
    seen: false
  }, {
    id: "902",
    code: "GS 593",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 18:35 - 21:10",
    time: [44, 45, 46],
    seen: false
  }, {
    id: "903",
    code: "GS 595",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "904",
    code: "GS 595",
    group: "10",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "905",
    code: "GS 595",
    group: "100",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "906",
    code: "GS 595",
    group: "101",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "907",
    code: "GS 595",
    group: "102",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "908",
    code: "GS 595",
    group: "103",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "909",
    code: "GS 595",
    group: "104",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "910",
    code: "GS 595",
    group: "105",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "911",
    code: "GS 595",
    group: "106",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "912",
    code: "GS 595",
    group: "107",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "913",
    code: "GS 595",
    group: "108",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "914",
    code: "GS 595",
    group: "109",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "915",
    code: "GS 595",
    group: "11",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "916",
    code: "GS 595",
    group: "110",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "917",
    code: "GS 595",
    group: "111",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "918",
    code: "GS 595",
    group: "112",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "919",
    code: "GS 595",
    group: "113",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "920",
    code: "GS 595",
    group: "114",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "921",
    code: "GS 595",
    group: "115",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "922",
    code: "GS 595",
    group: "116",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "923",
    code: "GS 595",
    group: "117",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "924",
    code: "GS 595",
    group: "118",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "925",
    code: "GS 595",
    group: "119",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "926",
    code: "GS 595",
    group: "12",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "927",
    code: "GS 595",
    group: "120",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "928",
    code: "GS 595",
    group: "121",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "929",
    code: "GS 595",
    group: "122",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "930",
    code: "GS 595",
    group: "123",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "931",
    code: "GS 595",
    group: "124",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "932",
    code: "GS 595",
    group: "125",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "933",
    code: "GS 595",
    group: "126",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "934",
    code: "GS 595",
    group: "127",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "935",
    code: "GS 595",
    group: "128",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "936",
    code: "GS 595",
    group: "129",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "937",
    code: "GS 595",
    group: "13",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "938",
    code: "GS 595",
    group: "130",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "939",
    code: "GS 595",
    group: "131",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "940",
    code: "GS 595",
    group: "132",
    type: "Yüz yüze",
    day: "Cumartesi 17:40 - 18:25",
    time: [91],
    seen: false
  }, {
    id: "941",
    code: "GS 595",
    group: "14",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "942",
    code: "GS 595",
    group: "15",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "943",
    code: "GS 595",
    group: "16",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "944",
    code: "GS 595",
    group: "17",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "945",
    code: "GS 595",
    group: "18",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "946",
    code: "GS 595",
    group: "19",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "947",
    code: "GS 595",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "948",
    code: "GS 595",
    group: "20",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "949",
    code: "GS 595",
    group: "21",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "950",
    code: "GS 595",
    group: "22",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "951",
    code: "GS 595",
    group: "23",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "952",
    code: "GS 595",
    group: "24",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "953",
    code: "GS 595",
    group: "25",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "954",
    code: "GS 595",
    group: "26",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "955",
    code: "GS 595",
    group: "27",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "956",
    code: "GS 595",
    group: "28",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "957",
    code: "GS 595",
    group: "29",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "958",
    code: "GS 595",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "959",
    code: "GS 595",
    group: "30",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "960",
    code: "GS 595",
    group: "31",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "961",
    code: "GS 595",
    group: "32",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "962",
    code: "GS 595",
    group: "33",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "963",
    code: "GS 595",
    group: "34",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "964",
    code: "GS 595",
    group: "35",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "965",
    code: "GS 595",
    group: "36",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "966",
    code: "GS 595",
    group: "37",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "967",
    code: "GS 595",
    group: "38",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "968",
    code: "GS 595",
    group: "39",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "969",
    code: "GS 595",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "970",
    code: "GS 595",
    group: "40",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "971",
    code: "GS 595",
    group: "41",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "972",
    code: "GS 595",
    group: "42",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "973",
    code: "GS 595",
    group: "43",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "974",
    code: "GS 595",
    group: "44",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "975",
    code: "GS 595",
    group: "45",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "976",
    code: "GS 595",
    group: "46",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "977",
    code: "GS 595",
    group: "47",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "978",
    code: "GS 595",
    group: "48",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "979",
    code: "GS 595",
    group: "49",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "980",
    code: "GS 595",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "981",
    code: "GS 595",
    group: "50",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "982",
    code: "GS 595",
    group: "51",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "983",
    code: "GS 595",
    group: "52",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "984",
    code: "GS 595",
    group: "53",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "985",
    code: "GS 595",
    group: "54",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "986",
    code: "GS 595",
    group: "55",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "987",
    code: "GS 595",
    group: "56",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "988",
    code: "GS 595",
    group: "57",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "989",
    code: "GS 595",
    group: "58",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "990",
    code: "GS 595",
    group: "59",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "991",
    code: "GS 595",
    group: "6",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "992",
    code: "GS 595",
    group: "60",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "993",
    code: "GS 595",
    group: "61",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "994",
    code: "GS 595",
    group: "62",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "995",
    code: "GS 595",
    group: "63",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "996",
    code: "GS 595",
    group: "64",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "997",
    code: "GS 595",
    group: "65",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "998",
    code: "GS 595",
    group: "66",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "999",
    code: "GS 595",
    group: "67",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1000",
    code: "GS 595",
    group: "68",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1001",
    code: "GS 595",
    group: "69",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1002",
    code: "GS 595",
    group: "7",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1003",
    code: "GS 595",
    group: "70",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1004",
    code: "GS 595",
    group: "71",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1005",
    code: "GS 595",
    group: "72",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1006",
    code: "GS 595",
    group: "73",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1007",
    code: "GS 595",
    group: "74",
    type: "Yüz yüze",
    day: "Cumartesi 20:25 - 21:10",
    time: [94],
    seen: false
  }, {
    id: "1008",
    code: "GS 595",
    group: "75",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1009",
    code: "GS 595",
    group: "76",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1010",
    code: "GS 595",
    group: "77",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1011",
    code: "GS 595",
    group: "78",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1012",
    code: "GS 595",
    group: "79",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1013",
    code: "GS 595",
    group: "8",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1014",
    code: "GS 595",
    group: "80",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1015",
    code: "GS 595",
    group: "81",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1016",
    code: "GS 595",
    group: "82",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1017",
    code: "GS 595",
    group: "83",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1018",
    code: "GS 595",
    group: "84",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1019",
    code: "GS 595",
    group: "85",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1020",
    code: "GS 595",
    group: "86",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1021",
    code: "GS 595",
    group: "87",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1022",
    code: "GS 595",
    group: "88",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1023",
    code: "GS 595",
    group: "89",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1024",
    code: "GS 595",
    group: "9",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1025",
    code: "GS 595",
    group: "90",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1026",
    code: "GS 595",
    group: "91",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1027",
    code: "GS 595",
    group: "92",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1028",
    code: "GS 595",
    group: "93",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1029",
    code: "GS 595",
    group: "94",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1030",
    code: "GS 595",
    group: "95",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1031",
    code: "GS 595",
    group: "96",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1032",
    code: "GS 595",
    group: "97",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1033",
    code: "GS 595",
    group: "98",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1034",
    code: "GS 595",
    group: "99",
    type: "Yüz yüze",
    day: "Cumartesi 11:15 - 12:00",
    time: [84],
    seen: false
  }, {
    id: "1035",
    code: "GS 597",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1036",
    code: "GS 597",
    group: "10",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1037",
    code: "GS 597",
    group: "100",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1038",
    code: "GS 597",
    group: "101",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1039",
    code: "GS 597",
    group: "102",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1040",
    code: "GS 597",
    group: "103",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1041",
    code: "GS 597",
    group: "104",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1042",
    code: "GS 597",
    group: "105",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1043",
    code: "GS 597",
    group: "106",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1044",
    code: "GS 597",
    group: "107",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1045",
    code: "GS 597",
    group: "108",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1046",
    code: "GS 597",
    group: "109",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1047",
    code: "GS 597",
    group: "11",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1048",
    code: "GS 597",
    group: "110",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1049",
    code: "GS 597",
    group: "111",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1050",
    code: "GS 597",
    group: "112",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1051",
    code: "GS 597",
    group: "113",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1052",
    code: "GS 597",
    group: "114",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1053",
    code: "GS 597",
    group: "115",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1054",
    code: "GS 597",
    group: "116",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1055",
    code: "GS 597",
    group: "117",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1056",
    code: "GS 597",
    group: "118",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1057",
    code: "GS 597",
    group: "119",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1058",
    code: "GS 597",
    group: "12",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1059",
    code: "GS 597",
    group: "120",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1060",
    code: "GS 597",
    group: "121",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1061",
    code: "GS 597",
    group: "122",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1062",
    code: "GS 597",
    group: "123",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1063",
    code: "GS 597",
    group: "124",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1064",
    code: "GS 597",
    group: "125",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1065",
    code: "GS 597",
    group: "126",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1066",
    code: "GS 597",
    group: "127",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1067",
    code: "GS 597",
    group: "128",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1068",
    code: "GS 597",
    group: "129",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1069",
    code: "GS 597",
    group: "13",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1070",
    code: "GS 597",
    group: "130",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1071",
    code: "GS 597",
    group: "131",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1072",
    code: "GS 597",
    group: "132",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1073",
    code: "GS 597",
    group: "14",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1074",
    code: "GS 597",
    group: "15",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1075",
    code: "GS 597",
    group: "16",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1076",
    code: "GS 597",
    group: "17",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1077",
    code: "GS 597",
    group: "18",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1078",
    code: "GS 597",
    group: "19",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1079",
    code: "GS 597",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1080",
    code: "GS 597",
    group: "20",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1081",
    code: "GS 597",
    group: "21",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1082",
    code: "GS 597",
    group: "22",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1083",
    code: "GS 597",
    group: "23",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1084",
    code: "GS 597",
    group: "24",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1085",
    code: "GS 597",
    group: "25",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1086",
    code: "GS 597",
    group: "26",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1087",
    code: "GS 597",
    group: "27",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1088",
    code: "GS 597",
    group: "28",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1089",
    code: "GS 597",
    group: "29",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1090",
    code: "GS 597",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1091",
    code: "GS 597",
    group: "30",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1092",
    code: "GS 597",
    group: "31",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1093",
    code: "GS 597",
    group: "32",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1094",
    code: "GS 597",
    group: "33",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1095",
    code: "GS 597",
    group: "34",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1096",
    code: "GS 597",
    group: "35",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1097",
    code: "GS 597",
    group: "36",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1098",
    code: "GS 597",
    group: "37",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1099",
    code: "GS 597",
    group: "38",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1100",
    code: "GS 597",
    group: "39",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1101",
    code: "GS 597",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1102",
    code: "GS 597",
    group: "40",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1103",
    code: "GS 597",
    group: "41",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1104",
    code: "GS 597",
    group: "42",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1105",
    code: "GS 597",
    group: "43",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1106",
    code: "GS 597",
    group: "44",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1107",
    code: "GS 597",
    group: "45",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1108",
    code: "GS 597",
    group: "46",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1109",
    code: "GS 597",
    group: "47",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1110",
    code: "GS 597",
    group: "48",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1111",
    code: "GS 597",
    group: "49",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1112",
    code: "GS 597",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1113",
    code: "GS 597",
    group: "50",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1114",
    code: "GS 597",
    group: "51",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1115",
    code: "GS 597",
    group: "52",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1116",
    code: "GS 597",
    group: "53",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1117",
    code: "GS 597",
    group: "54",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1118",
    code: "GS 597",
    group: "55",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1119",
    code: "GS 597",
    group: "56",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1120",
    code: "GS 597",
    group: "57",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1121",
    code: "GS 597",
    group: "58",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1122",
    code: "GS 597",
    group: "59",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1123",
    code: "GS 597",
    group: "6",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1124",
    code: "GS 597",
    group: "60",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1125",
    code: "GS 597",
    group: "61",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1126",
    code: "GS 597",
    group: "62",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1127",
    code: "GS 597",
    group: "63",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1128",
    code: "GS 597",
    group: "64",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1129",
    code: "GS 597",
    group: "65",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1130",
    code: "GS 597",
    group: "66",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1131",
    code: "GS 597",
    group: "67",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1132",
    code: "GS 597",
    group: "68",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1133",
    code: "GS 597",
    group: "69",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1134",
    code: "GS 597",
    group: "7",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1135",
    code: "GS 597",
    group: "70",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1136",
    code: "GS 597",
    group: "71",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1137",
    code: "GS 597",
    group: "72",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1138",
    code: "GS 597",
    group: "73",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1139",
    code: "GS 597",
    group: "74",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1140",
    code: "GS 597",
    group: "75",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1141",
    code: "GS 597",
    group: "76",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1142",
    code: "GS 597",
    group: "77",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1143",
    code: "GS 597",
    group: "78",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1144",
    code: "GS 597",
    group: "79",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1145",
    code: "GS 597",
    group: "8",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1146",
    code: "GS 597",
    group: "80",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1147",
    code: "GS 597",
    group: "81",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1148",
    code: "GS 597",
    group: "82",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1149",
    code: "GS 597",
    group: "83",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1150",
    code: "GS 597",
    group: "84",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1151",
    code: "GS 597",
    group: "85",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1152",
    code: "GS 597",
    group: "86",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1153",
    code: "GS 597",
    group: "87",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1154",
    code: "GS 597",
    group: "88",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1155",
    code: "GS 597",
    group: "89",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1156",
    code: "GS 597",
    group: "9",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1157",
    code: "GS 597",
    group: "90",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1158",
    code: "GS 597",
    group: "91",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1159",
    code: "GS 597",
    group: "92",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1160",
    code: "GS 597",
    group: "93",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1161",
    code: "GS 597",
    group: "94",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1162",
    code: "GS 597",
    group: "95",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1163",
    code: "GS 597",
    group: "96",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1164",
    code: "GS 597",
    group: "97",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1165",
    code: "GS 597",
    group: "98",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1166",
    code: "GS 597",
    group: "99",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 12:55",
    time: [85],
    seen: false
  }, {
    id: "1167",
    code: "GS 599",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1168",
    code: "GS 599",
    group: "10",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1169",
    code: "GS 599",
    group: "100",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1170",
    code: "GS 599",
    group: "101",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1171",
    code: "GS 599",
    group: "102",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1172",
    code: "GS 599",
    group: "103",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1173",
    code: "GS 599",
    group: "104",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1174",
    code: "GS 599",
    group: "105",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1175",
    code: "GS 599",
    group: "106",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1176",
    code: "GS 599",
    group: "107",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1177",
    code: "GS 599",
    group: "108",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1178",
    code: "GS 599",
    group: "109",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1179",
    code: "GS 599",
    group: "11",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1180",
    code: "GS 599",
    group: "110",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1181",
    code: "GS 599",
    group: "111",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1182",
    code: "GS 599",
    group: "112",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1183",
    code: "GS 599",
    group: "113",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1184",
    code: "GS 599",
    group: "114",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1185",
    code: "GS 599",
    group: "115",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1186",
    code: "GS 599",
    group: "116",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1187",
    code: "GS 599",
    group: "117",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1188",
    code: "GS 599",
    group: "118",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1189",
    code: "GS 599",
    group: "119",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1190",
    code: "GS 599",
    group: "12",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1191",
    code: "GS 599",
    group: "120",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1192",
    code: "GS 599",
    group: "121",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1193",
    code: "GS 599",
    group: "122",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1194",
    code: "GS 599",
    group: "123",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1195",
    code: "GS 599",
    group: "124",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1196",
    code: "GS 599",
    group: "125",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1197",
    code: "GS 599",
    group: "126",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1198",
    code: "GS 599",
    group: "127",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1199",
    code: "GS 599",
    group: "128",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1200",
    code: "GS 599",
    group: "129",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1201",
    code: "GS 599",
    group: "13",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1202",
    code: "GS 599",
    group: "130",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1203",
    code: "GS 599",
    group: "131",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1204",
    code: "GS 599",
    group: "132",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1205",
    code: "GS 599",
    group: "14",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1206",
    code: "GS 599",
    group: "15",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1207",
    code: "GS 599",
    group: "16",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1208",
    code: "GS 599",
    group: "17",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1209",
    code: "GS 599",
    group: "18",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1210",
    code: "GS 599",
    group: "19",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1211",
    code: "GS 599",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1212",
    code: "GS 599",
    group: "20",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1213",
    code: "GS 599",
    group: "21",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1214",
    code: "GS 599",
    group: "22",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1215",
    code: "GS 599",
    group: "23",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1216",
    code: "GS 599",
    group: "24",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1217",
    code: "GS 599",
    group: "25",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1218",
    code: "GS 599",
    group: "26",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1219",
    code: "GS 599",
    group: "27",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1220",
    code: "GS 599",
    group: "28",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1221",
    code: "GS 599",
    group: "29",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1222",
    code: "GS 599",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1223",
    code: "GS 599",
    group: "30",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1224",
    code: "GS 599",
    group: "31",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1225",
    code: "GS 599",
    group: "32",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1226",
    code: "GS 599",
    group: "33",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1227",
    code: "GS 599",
    group: "34",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1228",
    code: "GS 599",
    group: "35",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1229",
    code: "GS 599",
    group: "36",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1230",
    code: "GS 599",
    group: "37",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1231",
    code: "GS 599",
    group: "38",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1232",
    code: "GS 599",
    group: "39",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1233",
    code: "GS 599",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1234",
    code: "GS 599",
    group: "40",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1235",
    code: "GS 599",
    group: "41",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1236",
    code: "GS 599",
    group: "42",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1237",
    code: "GS 599",
    group: "43",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1238",
    code: "GS 599",
    group: "44",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1239",
    code: "GS 599",
    group: "45",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1240",
    code: "GS 599",
    group: "46",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1241",
    code: "GS 599",
    group: "47",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1242",
    code: "GS 599",
    group: "48",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1243",
    code: "GS 599",
    group: "49",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1244",
    code: "GS 599",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1245",
    code: "GS 599",
    group: "50",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1246",
    code: "GS 599",
    group: "51",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1247",
    code: "GS 599",
    group: "52",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1248",
    code: "GS 599",
    group: "53",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1249",
    code: "GS 599",
    group: "54",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1250",
    code: "GS 599",
    group: "55",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1251",
    code: "GS 599",
    group: "56",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1252",
    code: "GS 599",
    group: "57",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1253",
    code: "GS 599",
    group: "58",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1254",
    code: "GS 599",
    group: "59",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1255",
    code: "GS 599",
    group: "6",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1256",
    code: "GS 599",
    group: "60",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1257",
    code: "GS 599",
    group: "61",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1258",
    code: "GS 599",
    group: "62",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1259",
    code: "GS 599",
    group: "63",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1260",
    code: "GS 599",
    group: "64",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1261",
    code: "GS 599",
    group: "65",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1262",
    code: "GS 599",
    group: "66",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1263",
    code: "GS 599",
    group: "67",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1264",
    code: "GS 599",
    group: "68",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1265",
    code: "GS 599",
    group: "69",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1266",
    code: "GS 599",
    group: "7",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1267",
    code: "GS 599",
    group: "70",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1268",
    code: "GS 599",
    group: "71",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1269",
    code: "GS 599",
    group: "72",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1270",
    code: "GS 599",
    group: "73",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1271",
    code: "GS 599",
    group: "74",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1272",
    code: "GS 599",
    group: "75",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1273",
    code: "GS 599",
    group: "76",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1274",
    code: "GS 599",
    group: "77",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1275",
    code: "GS 599",
    group: "78",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1276",
    code: "GS 599",
    group: "79",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1277",
    code: "GS 599",
    group: "8",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1278",
    code: "GS 599",
    group: "80",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1279",
    code: "GS 599",
    group: "81",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1280",
    code: "GS 599",
    group: "82",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1281",
    code: "GS 599",
    group: "83",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1282",
    code: "GS 599",
    group: "84",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1283",
    code: "GS 599",
    group: "85",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1284",
    code: "GS 599",
    group: "86",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1285",
    code: "GS 599",
    group: "87",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1286",
    code: "GS 599",
    group: "88",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1287",
    code: "GS 599",
    group: "89",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1288",
    code: "GS 599",
    group: "9",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1289",
    code: "GS 599",
    group: "90",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1290",
    code: "GS 599",
    group: "91",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1291",
    code: "GS 599",
    group: "92",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1292",
    code: "GS 599",
    group: "93",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1293",
    code: "GS 599",
    group: "94",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1294",
    code: "GS 599",
    group: "95",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1295",
    code: "GS 599",
    group: "96",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1296",
    code: "GS 599",
    group: "97",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1297",
    code: "GS 599",
    group: "98",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1298",
    code: "GS 599",
    group: "99",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 13:50",
    time: [86],
    seen: false
  }, {
    id: "1299",
    code: "HEM 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Salı 13:05 - 14:45, Cuma 09:25 - 12:00, Cuma 13:05 - 13:50",
    time: [6, 7, 22, 23, 66, 67, 68, 70],
    seen: false
  }, {
    id: "1300",
    code: "HEM 105",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00, Salı 14:55 - 16:35",
    time: [1, 2, 3, 4, 24, 25],
    seen: false
  }, {
    id: "1301",
    code: "HEM 111",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00, Cuma 13:05 - 14:45",
    time: [66, 67, 68, 70, 71],
    seen: false
  }, {
    id: "1302",
    code: "HEM 113",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Salı 13:05 - 14:45",
    time: [6, 7, 22, 23],
    seen: false
  }, {
    id: "1303",
    code: "HEM 207",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Salı 12:10 - 13:50, Salı 14:55 - 16:35",
    time: [17, 18, 21, 22, 24, 25],
    seen: false
  }, {
    id: "1304",
    code: "HEM 209",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 16:35",
    time: [70, 71, 72, 73],
    seen: false
  }, {
    id: "1305",
    code: "HEM 211",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 16:35",
    time: [38, 39, 40, 41],
    seen: false
  }, {
    id: "1306",
    code: "HEM 213",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "1307",
    code: "HEM 213",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 20:15",
    time: [42, 43, 44, 45],
    seen: false
  }, {
    id: "1308",
    code: "HEM 215",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00, Perşembe 13:05 - 16:35",
    time: [49, 50, 51, 52, 54, 55, 56, 57],
    seen: false
  }, {
    id: "1309",
    code: "HEM 313",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35",
    time: [6, 7, 8, 9],
    seen: false
  }, {
    id: "1310",
    code: "HEM 327",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:55",
    time: [65, 66, 67, 68, 69],
    seen: false
  }, {
    id: "1311",
    code: "HEM 331",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 17:40 - 20:15",
    time: [91, 92, 93],
    seen: false
  }, {
    id: "1312",
    code: "HEM 333",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00, Pazartesi 13:05 - 16:35, Salı 08:30 - 12:00, Salı 13:05 - 16:35",
    time: [1, 2, 3, 4, 6, 7, 8, 9, 17, 18, 19, 20, 22, 23, 24, 25],
    seen: false
  }, {
    id: "1313",
    code: "HEM 333",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 12:00, Cumartesi 13:05 - 16:35, Pazar 08:30 - 12:00, Pazar 13:05 - 16:35",
    time: [81, 82, 83, 84, 86, 87, 88, 89, 97, 98, 99, 100, 102, 103, 104, 105],
    seen: false
  }, {
    id: "1314",
    code: "HEM 340",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "1315",
    code: "HEM 340",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "1316",
    code: "HEM 345",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:00, Pazartesi 13:05 - 15:40",
    time: [4, 6, 7, 8],
    seen: false
  }, {
    id: "1317",
    code: "HEM 501",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "1318",
    code: "HEM 503",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "1319",
    code: "HFS 100",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 17:30, Cumartesi 09:25 - 11:05",
    time: [73, 74, 82, 83],
    seen: false
  }, {
    id: "1320",
    code: "HINT 411",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55, Salı 14:00 - 15:40, Perşembe 13:05 - 16:35, Cuma 08:30 - 12:00",
    time: [20, 21, 23, 24, 54, 55, 56, 57, 65, 66, 67, 68],
    seen: false
  }, {
    id: "1321",
    code: "HINT 411",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 13:50, Cumartesi 14:55 - 20:15",
    time: [81, 82, 83, 84, 85, 86, 88, 89, 90, 91, 92, 93],
    seen: false
  }, {
    id: "1322",
    code: "HINT 413",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 16:35, Perşembe 08:30 - 12:00, Cuma 13:05 - 16:35",
    time: [38, 39, 40, 41, 49, 50, 51, 52, 70, 71, 72, 73],
    seen: false
  }, {
    id: "1323",
    code: "HIST 100",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 17:40 - 19:20, Cumartesi 08:30 - 10:10",
    time: [11, 12, 81, 82],
    seen: false
  }, {
    id: "1324",
    code: "HIST 100",
    group: "10",
    type: "Yüz yüze",
    day: "Cuma 14:55 - 16:35, Cumartesi 14:55 - 16:35",
    time: [72, 73, 88, 89],
    seen: false
  }, {
    id: "1325",
    code: "HIST 100",
    group: "11",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 18:25, Cumartesi 16:45 - 18:25",
    time: [74, 75, 90, 91],
    seen: false
  }, {
    id: "1326",
    code: "HIST 100",
    group: "12",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 18:25, Pazar 17:40 - 19:20",
    time: [58, 59, 107, 108],
    seen: false
  }, {
    id: "1327",
    code: "HIST 100",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 17:40 - 19:20, Cumartesi 10:20 - 12:00",
    time: [27, 28, 83, 84],
    seen: false
  }, {
    id: "1328",
    code: "HIST 100",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 17:40 - 19:20, Cumartesi 12:10 - 13:50",
    time: [43, 44, 85, 86],
    seen: false
  }, {
    id: "1329",
    code: "HIST 100",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 18:25, Cumartesi 10:20 - 12:00",
    time: [10, 11, 83, 84],
    seen: false
  }, {
    id: "1330",
    code: "HIST 100",
    group: "5",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 20:15, Pazar 09:25 - 11:05",
    time: [12, 13, 98, 99],
    seen: false
  }, {
    id: "1331",
    code: "HIST 100",
    group: "6",
    type: "Yüz yüze",
    day: "Salı 16:45 - 18:25, Pazar 11:15 - 12:55",
    time: [26, 27, 100, 101],
    seen: false
  }, {
    id: "1332",
    code: "HIST 100",
    group: "7",
    type: "Yüz yüze",
    day: "Salı 18:35 - 20:15, Pazar 14:00 - 15:40",
    time: [28, 29, 103, 104],
    seen: false
  }, {
    id: "1333",
    code: "HIST 100",
    group: "8",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 18:25, Cumartesi 15:50 - 17:30",
    time: [42, 43, 89, 90],
    seen: false
  }, {
    id: "1334",
    code: "HIST 100",
    group: "9",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 17:30, Pazar 08:30 - 10:10",
    time: [57, 58, 97, 98],
    seen: false
  }, {
    id: "1335",
    code: "HS 301",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "1336",
    code: "HS 303",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "1337",
    code: "HSP 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45",
    time: [6, 7],
    seen: false
  }, {
    id: "1338",
    code: "HSP 201",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 16:35",
    time: [54, 55, 56, 57],
    seen: false
  }, {
    id: "1339",
    code: "HSP 301",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 14:45",
    time: [70, 71],
    seen: false
  }, {
    id: "1340",
    code: "HUK 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "1341",
    code: "HUK 103",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "1342",
    code: "HUK 111",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30",
    time: [24, 25, 26],
    seen: false
  }, {
    id: "1343",
    code: "HUK 111",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "1344",
    code: "HUK 113",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1345",
    code: "HUK 113",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "1346",
    code: "HUK 115",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1347",
    code: "HUK 201",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 11:15 - 13:50",
    time: [52, 53, 54],
    seen: false
  }, {
    id: "1348",
    code: "HUK 203",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "1349",
    code: "HUK 204",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1350",
    code: "HUK 204",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 11:15 - 13:50",
    time: [52, 53, 54],
    seen: false
  }, {
    id: "1351",
    code: "HUK 205",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "1352",
    code: "HUK 206",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50",
    time: [20, 21, 22],
    seen: false
  }, {
    id: "1353",
    code: "HUK 207",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "1354",
    code: "HUK 207",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 11:15 - 13:50",
    time: [68, 69, 70],
    seen: false
  }, {
    id: "1355",
    code: "HUK 211",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "1356",
    code: "HUK 213",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "1357",
    code: "HUK 215",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 11:15 - 13:50",
    time: [52, 53, 54],
    seen: false
  }, {
    id: "1358",
    code: "HUK 271",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "1359",
    code: "HUK 273",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1360",
    code: "HUK 280",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 11:15 - 13:50",
    time: [52, 53, 54],
    seen: false
  }, {
    id: "1361",
    code: "HUK 292",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "1362",
    code: "HUK 293",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "1363",
    code: "HUK 295",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 13:50",
    time: [4, 5, 6],
    seen: false
  }, {
    id: "1364",
    code: "HUK 297",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1365",
    code: "HUK 301",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1366",
    code: "HUK 303",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "1367",
    code: "HUK 303",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "1368",
    code: "HUK 306",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 13:50",
    time: [4, 5, 6],
    seen: false
  }, {
    id: "1369",
    code: "HUK 307",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1370",
    code: "HUK 307",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 19:20",
    time: [74, 75, 76],
    seen: false
  }, {
    id: "1371",
    code: "HUK 311",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50",
    time: [20, 21, 22],
    seen: false
  }, {
    id: "1372",
    code: "HUK 313",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1373",
    code: "HUK 313",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 11:15 - 13:50",
    time: [52, 53, 54],
    seen: false
  }, {
    id: "1374",
    code: "HUK 350",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1375",
    code: "HUK 385",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 11:15 - 13:50",
    time: [68, 69, 70],
    seen: false
  }, {
    id: "1376",
    code: "HUK 387",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "1377",
    code: "HUK 389",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 11:15 - 13:50",
    time: [68, 69, 70],
    seen: false
  }, {
    id: "1378",
    code: "HUK 401",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "1379",
    code: "HUK 401",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "1380",
    code: "HUK 403",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "1381",
    code: "HUK 405",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "1382",
    code: "HUK 411",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "1383",
    code: "HUK 413",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 13:50",
    time: [4, 5, 6],
    seen: false
  }, {
    id: "1384",
    code: "HUK 415",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "1385",
    code: "HUK 430",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "1386",
    code: "HUK 447",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "1387",
    code: "HUK 459",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1388",
    code: "HUK 467",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "1389",
    code: "HUK 471",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 13:50",
    time: [4, 5, 6],
    seen: false
  }, {
    id: "1390",
    code: "HUK 477",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "1391",
    code: "HUK 479",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1392",
    code: "HUK 490",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "1393",
    code: "HUK 501",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 18:35 - 21:10",
    time: [44, 45, 46],
    seen: false
  }, {
    id: "1394",
    code: "HUK 507",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "1395",
    code: "HUK 509",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:55 - 17:30",
    time: [72, 73, 74],
    seen: false
  }, {
    id: "1396",
    code: "HUK 515",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "1397",
    code: "HUK 516",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "1398",
    code: "HUK 519",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "1399",
    code: "HUK 526",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "1400",
    code: "HUK 541",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "1401",
    code: "HUK 556",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "1402",
    code: "HUK 602",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "1403",
    code: "HUK 604",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "1404",
    code: "HUK 605",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "1405",
    code: "HUK 613",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "1406",
    code: "HUK 691",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 18:35 - 21:10",
    time: [44, 45, 46],
    seen: false
  }, {
    id: "1407",
    code: "HUK 695",
    group: "1",
    type: "Yüz yüze",
    day: "Pazar 15:50 - 18:25",
    time: [105, 106, 107],
    seen: false
  }, {
    id: "1408",
    code: "HUK 695",
    group: "2",
    type: "Yüz yüze",
    day: "Pazar 13:05 - 15:40",
    time: [102, 103, 104],
    seen: false
  }, {
    id: "1409",
    code: "HUK 695",
    group: "3",
    type: "Yüz yüze",
    day: "Pazar 14:55 - 17:30",
    time: [104, 105, 106],
    seen: false
  }, {
    id: "1410",
    code: "HUK 695",
    group: "4",
    type: "Yüz yüze",
    day: "Pazar 15:50 - 18:25",
    time: [105, 106, 107],
    seen: false
  }, {
    id: "1411",
    code: "HUK 695",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 12:10 - 14:45",
    time: [85, 86, 87],
    seen: false
  }, {
    id: "1412",
    code: "HUK 695",
    group: "6",
    type: "Yüz yüze",
    day: "Pazar 10:20 - 12:55",
    time: [99, 100, 101],
    seen: false
  }, {
    id: "1413",
    code: "HUK 695",
    group: "7",
    type: "Yüz yüze",
    day: "Pazar 08:30 - 11:05",
    time: [97, 98, 99],
    seen: false
  }, {
    id: "1414",
    code: "HUK 695",
    group: "8",
    type: "Yüz yüze",
    day: "Pazar 10:20 - 12:55",
    time: [99, 100, 101],
    seen: false
  }, {
    id: "1415",
    code: "HUK 695",
    group: "9",
    type: "Yüz yüze",
    day: "Pazar 08:30 - 11:05",
    time: [97, 98, 99],
    seen: false
  }, {
    id: "1416",
    code: "HUK 697",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "1417",
    code: "HUK 698",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "1418",
    code: "HUM 103",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "1419",
    code: "HUM 103",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "1420",
    code: "HYHY 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "1421",
    code: "HYHY 101",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "1422",
    code: "HYHY 105",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "1423",
    code: "HYHY 105",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 12:10 - 14:45",
    time: [69, 70, 71],
    seen: false
  }, {
    id: "1424",
    code: "HYHY 108",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55",
    time: [20, 21],
    seen: false
  }, {
    id: "1425",
    code: "HYHY 191",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "1426",
    code: "HYHY 191",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 12:10 - 14:45",
    time: [69, 70, 71],
    seen: false
  }, {
    id: "1427",
    code: "HYHY 193",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1428",
    code: "HYHY 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "1429",
    code: "HYHY 201",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45",
    time: [21, 22, 23],
    seen: false
  }, {
    id: "1430",
    code: "HYHY 203",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "1431",
    code: "HYHY 205",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "1432",
    code: "HYHY 207",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10",
    time: [17, 18],
    seen: false
  }, {
    id: "1433",
    code: "HYHY 209",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1434",
    code: "HYHY 291",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "1435",
    code: "HYHY 291",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45",
    time: [21, 22, 23],
    seen: false
  }, {
    id: "1436",
    code: "HYHY 298",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1437",
    code: "HYHY 299",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 10:10",
    time: [49, 50],
    seen: false
  }, {
    id: "1438",
    code: "HYHY 299",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:00",
    time: [51, 52],
    seen: false
  }, {
    id: "1439",
    code: "IA 301",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 15:40, Perşembe 12:10 - 15:40",
    time: [5, 6, 7, 8, 53, 54, 55, 56],
    seen: false
  }, {
    id: "1440",
    code: "IA 301",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 15:40, Perşembe 12:10 - 15:40",
    time: [5, 6, 7, 8, 53, 54, 55, 56],
    seen: false
  }, {
    id: "1441",
    code: "IA 301",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 15:40, Perşembe 12:10 - 15:40",
    time: [5, 6, 7, 8, 53, 54, 55, 56],
    seen: false
  }, {
    id: "1442",
    code: "IA 401",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 65, 66, 67, 68],
    seen: false
  }, {
    id: "1443",
    code: "IA 401",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 65, 66, 67, 68],
    seen: false
  }, {
    id: "1444",
    code: "IA 494",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 16:35",
    time: [22, 23, 24, 25],
    seen: false
  }, {
    id: "1445",
    code: "IA 498",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 65, 66, 67, 68],
    seen: false
  }, {
    id: "1446",
    code: "IAED 101",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00",
    time: [49, 50, 51, 52],
    seen: false
  }, {
    id: "1447",
    code: "IAED 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 65, 66, 67, 68],
    seen: false
  }, {
    id: "1448",
    code: "IAED 201",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 65, 66, 67, 68],
    seen: false
  }, {
    id: "1449",
    code: "IAED 203",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "1450",
    code: "IAED 203",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "1451",
    code: "IAED 207",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "1452",
    code: "IAED 207",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "1453",
    code: "IAED 207",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "1454",
    code: "IAED 209",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1455",
    code: "IAED 304",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "1456",
    code: "IAED 320",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "1457",
    code: "IAED 330",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "1458",
    code: "IAED 347",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00",
    time: [17, 18, 19, 20],
    seen: false
  }, {
    id: "1459",
    code: "IAED 352",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "1460",
    code: "IAED 401",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "1461",
    code: "IAED 404",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1462",
    code: "IAY 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Çarşamba 12:10 - 13:50",
    time: [7, 8, 37, 38],
    seen: false
  }, {
    id: "1463",
    code: "IAY 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 13:50",
    time: [5, 6],
    seen: false
  }, {
    id: "1464",
    code: "IAY 105",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Çarşamba 15:50 - 17:30",
    time: [19, 20, 41, 42],
    seen: false
  }, {
    id: "1465",
    code: "IAY 117",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Çarşamba 08:30 - 10:10",
    time: [1, 2, 33, 34],
    seen: false
  }, {
    id: "1466",
    code: "IAY 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Perşembe 13:05 - 15:40, Cumartesi 08:30 - 12:00",
    time: [3, 4, 54, 55, 56, 81, 82, 83, 84],
    seen: false
  }, {
    id: "1467",
    code: "IAY 203",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:55, Cumartesi 12:10 - 15:40",
    time: [66, 67, 68, 69, 85, 86, 87, 88],
    seen: false
  }, {
    id: "1468",
    code: "IAY 205",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00",
    time: [35, 36],
    seen: false
  }, {
    id: "1469",
    code: "IAY 208",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30",
    time: [9, 10],
    seen: false
  }, {
    id: "1470",
    code: "ID 101",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 16:35",
    time: [22, 23, 24, 25],
    seen: false
  }, {
    id: "1471",
    code: "ID 115",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 11:05",
    time: [34, 35],
    seen: false
  }, {
    id: "1472",
    code: "ID 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 65, 66, 67, 68],
    seen: false
  }, {
    id: "1473",
    code: "ID 203",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "1474",
    code: "ID 203",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35",
    time: [6, 7, 8, 9],
    seen: false
  }, {
    id: "1475",
    code: "ID 203",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "1476",
    code: "ID 203",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "1477",
    code: "ID 205",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 11:05",
    time: [34, 35],
    seen: false
  }, {
    id: "1478",
    code: "ID 207",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "1479",
    code: "ID 211",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 16:35",
    time: [22, 23, 24, 25],
    seen: false
  }, {
    id: "1480",
    code: "ID 301",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1481",
    code: "ID 303",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35, Perşembe 13:05 - 16:35",
    time: [6, 7, 8, 9, 54, 55, 56, 57],
    seen: false
  }, {
    id: "1482",
    code: "ID 320",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00",
    time: [49, 50, 51, 52],
    seen: false
  }, {
    id: "1483",
    code: "ID 330",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 16:35",
    time: [54, 55, 56, 57],
    seen: false
  }, {
    id: "1484",
    code: "ID 330",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "1485",
    code: "ID 331",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00",
    time: [49, 50, 51, 52],
    seen: false
  }, {
    id: "1486",
    code: "ID 420",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 16:35",
    time: [22, 23, 24, 25],
    seen: false
  }, {
    id: "1487",
    code: "ID 494",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 12:00",
    time: [81, 82, 83, 84],
    seen: false
  }, {
    id: "1488",
    code: "IE 215",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "1489",
    code: "IE 215",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "1490",
    code: "IE 251",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 11:05, Salı 12:10 - 13:50",
    time: [18, 19, 21, 22],
    seen: false
  }, {
    id: "1491",
    code: "IE 251",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 13:50",
    time: [51, 52, 53, 54],
    seen: false
  }, {
    id: "1492",
    code: "IE 261",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "1493",
    code: "IE 261",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "1494",
    code: "IE 314",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "1495",
    code: "IE 321",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 11:05, Salı 12:10 - 13:50",
    time: [18, 19, 21, 22],
    seen: false
  }, {
    id: "1496",
    code: "IE 321",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:00, Cuma 13:05 - 14:45",
    time: [67, 68, 70, 71],
    seen: false
  }, {
    id: "1497",
    code: "IE 322",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "1498",
    code: "IE 322",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "1499",
    code: "IE 323",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30",
    time: [24, 25, 26],
    seen: false
  }, {
    id: "1500",
    code: "IE 323",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "1501",
    code: "IE 325",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "1502",
    code: "IE 327",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "1503",
    code: "IE 337",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 14:45, Çarşamba 15:50 - 17:30",
    time: [38, 39, 41, 42],
    seen: false
  }, {
    id: "1504",
    code: "IE 342",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "1505",
    code: "IE 346",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "1506",
    code: "IE 346",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "1507",
    code: "IE 353",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 11:05, Salı 12:10 - 13:50",
    time: [18, 19, 21, 22],
    seen: false
  }, {
    id: "1508",
    code: "IE 353",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:00, Cuma 13:05 - 14:45",
    time: [67, 68, 70, 71],
    seen: false
  }, {
    id: "1509",
    code: "IE 358",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "1510",
    code: "IE 372",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1511",
    code: "IE 502",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "1512",
    code: "IE 513",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "1513",
    code: "IEU 200",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "1514",
    code: "ING 105",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "1515",
    code: "ING 105",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "1516",
    code: "ING 105",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 13:50",
    time: [4, 5, 6],
    seen: false
  }, {
    id: "1517",
    code: "ING 105",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1518",
    code: "ING 105",
    group: "5",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "1519",
    code: "ING 205",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "1520",
    code: "ING 205",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "1521",
    code: "ING 205",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "1522",
    code: "ING 205",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "1523",
    code: "ING 205",
    group: "5",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "1524",
    code: "ING 210",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30, Çarşamba 14:55 - 17:30",
    time: [24, 25, 26, 40, 41, 42],
    seen: false
  }, {
    id: "1525",
    code: "ING 210",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05, Perşembe 14:55 - 17:30",
    time: [33, 34, 35, 56, 57, 58],
    seen: false
  }, {
    id: "1526",
    code: "ING 215",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 12:10 - 14:45",
    time: [69, 70, 71],
    seen: false
  }, {
    id: "1527",
    code: "ING 230",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 17:40 - 19:20",
    time: [27, 28],
    seen: false
  }, {
    id: "1528",
    code: "ING 230",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 17:40 - 19:20",
    time: [43, 44],
    seen: false
  }, {
    id: "1529",
    code: "ING 251",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "1530",
    code: "ING 270",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "1531",
    code: "ING 297",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 12:10 - 14:45",
    time: [69, 70, 71],
    seen: false
  }, {
    id: "1532",
    code: "ING 305",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "1533",
    code: "ING 305",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Çarşamba 13:05 - 14:45",
    time: [23, 24, 38, 39],
    seen: false
  }, {
    id: "1534",
    code: "ING 305",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 16:35",
    time: [70, 71, 72, 73],
    seen: false
  }, {
    id: "1535",
    code: "ING 405",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05, Salı 08:30 - 11:05",
    time: [1, 2, 3, 17, 18, 19],
    seen: false
  }, {
    id: "1536",
    code: "ING 405",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 13:50, Salı 12:10 - 13:50",
    time: [5, 6, 21, 22],
    seen: false
  }, {
    id: "1537",
    code: "ISL 505",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "1538",
    code: "ISL 507",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 12:55",
    time: [83, 84, 85],
    seen: false
  }, {
    id: "1539",
    code: "ISL 511",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 18:35 - 21:10",
    time: [44, 45, 46],
    seen: false
  }, {
    id: "1540",
    code: "ISL 513",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "1541",
    code: "ISL 520",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "1542",
    code: "ISL 567",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 18:35 - 21:10",
    time: [44, 45, 46],
    seen: false
  }, {
    id: "1543",
    code: "ITF 210",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "1544",
    code: "ITF 223",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "1545",
    code: "ITF 223",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "1546",
    code: "ITF 301",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "1547",
    code: "ITF 301",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "1548",
    code: "ITF 311",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "1549",
    code: "ITF 311",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "1550",
    code: "ITF 311",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "1551",
    code: "ITF 321",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "1552",
    code: "ITF 321",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "1553",
    code: "ITF 403",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "1554",
    code: "ITF 404",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1555",
    code: "ITF 407",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "1556",
    code: "ITF 414",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "1557",
    code: "ITF 421",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "1558",
    code: "ITF 422",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "1559",
    code: "ITF 430",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "1560",
    code: "ITF 460",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "1561",
    code: "ITF 507",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "1562",
    code: "ITL 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "1563",
    code: "ITL 103",
    group: "10",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "1564",
    code: "ITL 103",
    group: "11",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1565",
    code: "ITL 103",
    group: "12",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "1566",
    code: "ITL 103",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "1567",
    code: "ITL 103",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "1568",
    code: "ITL 103",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "1569",
    code: "ITL 103",
    group: "5",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "1570",
    code: "ITL 103",
    group: "6",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "1571",
    code: "ITL 103",
    group: "7",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "1572",
    code: "ITL 103",
    group: "8",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "1573",
    code: "ITL 103",
    group: "9",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "1574",
    code: "ITL 104",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10, Cuma 14:00 - 15:40",
    time: [33, 34, 71, 72],
    seen: false
  }, {
    id: "1575",
    code: "ITL 104",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 17:40 - 19:20, Cuma 08:30 - 10:10",
    time: [43, 44, 65, 66],
    seen: false
  }, {
    id: "1576",
    code: "ITL 121",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55, Perşembe 11:15 - 12:55",
    time: [20, 21, 52, 53],
    seen: false
  }, {
    id: "1577",
    code: "ITL 121",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55, Perşembe 11:15 - 12:55",
    time: [20, 21, 52, 53],
    seen: false
  }, {
    id: "1578",
    code: "ITL 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "1579",
    code: "ITL 201",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "1580",
    code: "ITL 201",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "1581",
    code: "ITL 201",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "1582",
    code: "ITL 201",
    group: "5",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1583",
    code: "ITL 201",
    group: "6",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "1584",
    code: "ITL 201",
    group: "7",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "1585",
    code: "ITL 202",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30, Perşembe 14:00 - 15:40",
    time: [41, 42, 55, 56],
    seen: false
  }, {
    id: "1586",
    code: "ITL 221",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 11:15 - 12:55, Cuma 11:15 - 12:55",
    time: [36, 37, 68, 69],
    seen: false
  }, {
    id: "1587",
    code: "ITL 321",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Perşembe 14:00 - 15:40",
    time: [23, 24, 55, 56],
    seen: false
  }, {
    id: "1588",
    code: "ITL 421",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Perşembe 14:00 - 15:40",
    time: [23, 24, 55, 56],
    seen: false
  }, {
    id: "1589",
    code: "IUE 310",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "1590",
    code: "JPN 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Çarşamba 17:40 - 19:20",
    time: [9, 10, 43, 44],
    seen: false
  }, {
    id: "1591",
    code: "JPN 101",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 17:40 - 19:20, Cuma 15:50 - 17:30",
    time: [27, 28, 73, 74],
    seen: false
  }, {
    id: "1592",
    code: "JPN 101",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30, Cuma 17:40 - 19:20",
    time: [41, 42, 75, 76],
    seen: false
  }, {
    id: "1593",
    code: "JPN 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 17:40 - 19:20, Perşembe 17:40 - 19:20",
    time: [11, 12, 59, 60],
    seen: false
  }, {
    id: "1594",
    code: "JPN 201",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 15:50 - 17:30, Perşembe 15:50 - 17:30",
    time: [25, 26, 57, 58],
    seen: false
  }, {
    id: "1595",
    code: "KHUK 511",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "1596",
    code: "KHUK 513",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "1597",
    code: "KHUK 516",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "1598",
    code: "KHUK 520",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "1599",
    code: "KHUK 522",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "1600",
    code: "KHUK 529",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "1601",
    code: "KHUK 570",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "1602",
    code: "KHUK 623",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "1603",
    code: "KHUK 627",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "1604",
    code: "KHUK 631",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "1605",
    code: "LAW 100",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "1606",
    code: "LAW 100",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "1607",
    code: "LAW 101",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "1608",
    code: "LAW 103",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 19:20",
    time: [74, 75, 76],
    seen: false
  }, {
    id: "1609",
    code: "LAW 111",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50",
    time: [20, 21, 22],
    seen: false
  }, {
    id: "1610",
    code: "LAW 111",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1611",
    code: "LAW 202",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "1612",
    code: "LAW 203",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "1613",
    code: "LAW 293",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1614",
    code: "LAW 294",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "1615",
    code: "LAW 300",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "1616",
    code: "LAW 321",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "1617",
    code: "LAW 322",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1618",
    code: "LAW 325",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 11:15 - 13:50",
    time: [52, 53, 54],
    seen: false
  }, {
    id: "1619",
    code: "LAW 330",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "1620",
    code: "LAW 364",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 11:15 - 13:50",
    time: [52, 53, 54],
    seen: false
  }, {
    id: "1621",
    code: "LAW 392",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "1622",
    code: "LAW 393",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "1623",
    code: "LAW 396",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1624",
    code: "LAW 401",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 11:15 - 13:50",
    time: [68, 69, 70],
    seen: false
  }, {
    id: "1625",
    code: "LAW 406",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 19:20",
    time: [58, 59, 60],
    seen: false
  }, {
    id: "1626",
    code: "LAW 444",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1627",
    code: "LAW 461",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1628",
    code: "LAW 470",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 11:15 - 13:50",
    time: [68, 69, 70],
    seen: false
  }, {
    id: "1629",
    code: "LEE 595",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1630",
    code: "LEE 595",
    group: "10",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1631",
    code: "LEE 595",
    group: "11",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1632",
    code: "LEE 595",
    group: "12",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1633",
    code: "LEE 595",
    group: "13",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1634",
    code: "LEE 595",
    group: "14",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1635",
    code: "LEE 595",
    group: "15",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1636",
    code: "LEE 595",
    group: "16",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1637",
    code: "LEE 595",
    group: "17",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1638",
    code: "LEE 595",
    group: "18",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1639",
    code: "LEE 595",
    group: "19",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1640",
    code: "LEE 595",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1641",
    code: "LEE 595",
    group: "20",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1642",
    code: "LEE 595",
    group: "21",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1643",
    code: "LEE 595",
    group: "22",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1644",
    code: "LEE 595",
    group: "23",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1645",
    code: "LEE 595",
    group: "24",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1646",
    code: "LEE 595",
    group: "25",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1647",
    code: "LEE 595",
    group: "27",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1648",
    code: "LEE 595",
    group: "28",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1649",
    code: "LEE 595",
    group: "29",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1650",
    code: "LEE 595",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1651",
    code: "LEE 595",
    group: "30",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1652",
    code: "LEE 595",
    group: "31",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1653",
    code: "LEE 595",
    group: "32",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1654",
    code: "LEE 595",
    group: "33",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1655",
    code: "LEE 595",
    group: "34",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1656",
    code: "LEE 595",
    group: "35",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1657",
    code: "LEE 595",
    group: "36",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1658",
    code: "LEE 595",
    group: "37",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1659",
    code: "LEE 595",
    group: "38",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1660",
    code: "LEE 595",
    group: "39",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1661",
    code: "LEE 595",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1662",
    code: "LEE 595",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1663",
    code: "LEE 595",
    group: "6",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1664",
    code: "LEE 595",
    group: "7",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1665",
    code: "LEE 595",
    group: "8",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1666",
    code: "LEE 595",
    group: "9",
    type: "Yüz yüze",
    day: "Cumartesi 08:30 - 09:15",
    time: [81],
    seen: false
  }, {
    id: "1667",
    code: "LEE 597",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1668",
    code: "LEE 597",
    group: "10",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1669",
    code: "LEE 597",
    group: "11",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1670",
    code: "LEE 597",
    group: "12",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1671",
    code: "LEE 597",
    group: "13",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1672",
    code: "LEE 597",
    group: "14",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1673",
    code: "LEE 597",
    group: "15",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1674",
    code: "LEE 597",
    group: "16",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1675",
    code: "LEE 597",
    group: "17",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1676",
    code: "LEE 597",
    group: "18",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1677",
    code: "LEE 597",
    group: "19",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1678",
    code: "LEE 597",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1679",
    code: "LEE 597",
    group: "20",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1680",
    code: "LEE 597",
    group: "21",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1681",
    code: "LEE 597",
    group: "22",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1682",
    code: "LEE 597",
    group: "23",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1683",
    code: "LEE 597",
    group: "24",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1684",
    code: "LEE 597",
    group: "25",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1685",
    code: "LEE 597",
    group: "26",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1686",
    code: "LEE 597",
    group: "28",
    type: "Yüz yüze",
    day: "Cumartesi 22:15 - 23:00",
    time: [96],
    seen: false
  }, {
    id: "1687",
    code: "LEE 597",
    group: "29",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1688",
    code: "LEE 597",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1689",
    code: "LEE 597",
    group: "30",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1690",
    code: "LEE 597",
    group: "31",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1691",
    code: "LEE 597",
    group: "32",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1692",
    code: "LEE 597",
    group: "33",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1693",
    code: "LEE 597",
    group: "34",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1694",
    code: "LEE 597",
    group: "35",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1695",
    code: "LEE 597",
    group: "36",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1696",
    code: "LEE 597",
    group: "37",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1697",
    code: "LEE 597",
    group: "38",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1698",
    code: "LEE 597",
    group: "39",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1699",
    code: "LEE 597",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1700",
    code: "LEE 597",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1701",
    code: "LEE 597",
    group: "6",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1702",
    code: "LEE 597",
    group: "7",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1703",
    code: "LEE 597",
    group: "8",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1704",
    code: "LEE 597",
    group: "9",
    type: "Yüz yüze",
    day: "Cumartesi 09:25 - 10:10",
    time: [82],
    seen: false
  }, {
    id: "1705",
    code: "LEE 599",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1706",
    code: "LEE 599",
    group: "10",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1707",
    code: "LEE 599",
    group: "11",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1708",
    code: "LEE 599",
    group: "12",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1709",
    code: "LEE 599",
    group: "13",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1710",
    code: "LEE 599",
    group: "15",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1711",
    code: "LEE 599",
    group: "16",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1712",
    code: "LEE 599",
    group: "17",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1713",
    code: "LEE 599",
    group: "18",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1714",
    code: "LEE 599",
    group: "19",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1715",
    code: "LEE 599",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1716",
    code: "LEE 599",
    group: "20",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1717",
    code: "LEE 599",
    group: "21",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1718",
    code: "LEE 599",
    group: "22",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1719",
    code: "LEE 599",
    group: "23",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1720",
    code: "LEE 599",
    group: "24",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1721",
    code: "LEE 599",
    group: "25",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1722",
    code: "LEE 599",
    group: "26",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1723",
    code: "LEE 599",
    group: "27",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1724",
    code: "LEE 599",
    group: "28",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1725",
    code: "LEE 599",
    group: "29",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1726",
    code: "LEE 599",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1727",
    code: "LEE 599",
    group: "30",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1728",
    code: "LEE 599",
    group: "31",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1729",
    code: "LEE 599",
    group: "32",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1730",
    code: "LEE 599",
    group: "33",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1731",
    code: "LEE 599",
    group: "34",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1732",
    code: "LEE 599",
    group: "35",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1733",
    code: "LEE 599",
    group: "36",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1734",
    code: "LEE 599",
    group: "37",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1735",
    code: "LEE 599",
    group: "38",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1736",
    code: "LEE 599",
    group: "39",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1737",
    code: "LEE 599",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1738",
    code: "LEE 599",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1739",
    code: "LEE 599",
    group: "6",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1740",
    code: "LEE 599",
    group: "7",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1741",
    code: "LEE 599",
    group: "8",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1742",
    code: "LEE 599",
    group: "9",
    type: "Yüz yüze",
    day: "Cumartesi 10:20 - 11:05",
    time: [83],
    seen: false
  }, {
    id: "1743",
    code: "LOG 203",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "1744",
    code: "LOG 203",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "1745",
    code: "LOG 311",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:55",
    time: [66, 67, 68, 69],
    seen: false
  }, {
    id: "1746",
    code: "LOG 315",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "1747",
    code: "LOG 321",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:55",
    time: [50, 51, 52, 53],
    seen: false
  }, {
    id: "1748",
    code: "LOG 351",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 15:40",
    time: [55, 56],
    seen: false
  }, {
    id: "1749",
    code: "LOG 405",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "1750",
    code: "LOG 414",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "1751",
    code: "LOG 455",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45",
    time: [21, 22, 23],
    seen: false
  }, {
    id: "1752",
    code: "LOG 472",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "1753",
    code: "LOG 497",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35",
    time: [6, 7, 8, 9],
    seen: false
  }, {
    id: "1754",
    code: "LOG 497",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35",
    time: [6, 7, 8, 9],
    seen: false
  }, {
    id: "1755",
    code: "LOG 497",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35",
    time: [6, 7, 8, 9],
    seen: false
  }, {
    id: "1756",
    code: "LOG 497",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35",
    time: [6, 7, 8, 9],
    seen: false
  }, {
    id: "1757",
    code: "LOG 497",
    group: "5",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35",
    time: [6, 7, 8, 9],
    seen: false
  }, {
    id: "1758",
    code: "LOG 518",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 18:35 - 21:10",
    time: [76, 77, 78],
    seen: false
  }, {
    id: "1759",
    code: "LOG 519",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "1760",
    code: "MATH 101",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "1761",
    code: "MATH 101",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "1762",
    code: "MATH 101",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "1763",
    code: "MATH 101",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "1764",
    code: "MATH 101",
    group: "5",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1765",
    code: "MATH 101",
    group: "6",
    type: "Yüz yüze",
    day: "Cuma 14:55 - 17:30",
    time: [72, 73, 74],
    seen: false
  }, {
    id: "1766",
    code: "MATH 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "1767",
    code: "MATH 109",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 13:50, Perşembe 12:10 - 13:50",
    time: [21, 22, 53, 54],
    seen: false
  }, {
    id: "1768",
    code: "MATH 111",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "1769",
    code: "MATH 111",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "1770",
    code: "MATH 117",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "1771",
    code: "MATH 121",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "1772",
    code: "MATH 153",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:55, Cuma 11:15 - 12:55",
    time: [4, 5, 68, 69],
    seen: false
  }, {
    id: "1773",
    code: "MATH 153",
    group: "10",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Salı 11:15 - 12:55",
    time: [17, 18, 20, 21],
    seen: false
  }, {
    id: "1774",
    code: "MATH 153",
    group: "11",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:55, Cuma 11:15 - 12:55",
    time: [4, 5, 68, 69],
    seen: false
  }, {
    id: "1775",
    code: "MATH 153",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Cuma 14:00 - 15:40",
    time: [7, 8, 71, 72],
    seen: false
  }, {
    id: "1776",
    code: "MATH 153",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Cuma 10:20 - 12:00",
    time: [19, 20, 67, 68],
    seen: false
  }, {
    id: "1777",
    code: "MATH 153",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Cuma 10:20 - 12:00",
    time: [19, 20, 67, 68],
    seen: false
  }, {
    id: "1778",
    code: "MATH 153",
    group: "5",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55, Cuma 11:15 - 12:55",
    time: [20, 21, 68, 69],
    seen: false
  }, {
    id: "1779",
    code: "MATH 153",
    group: "6",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45, Cuma 13:05 - 14:45",
    time: [22, 23, 70, 71],
    seen: false
  }, {
    id: "1780",
    code: "MATH 153",
    group: "7",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45, Cuma 13:05 - 14:45",
    time: [22, 23, 70, 71],
    seen: false
  }, {
    id: "1781",
    code: "MATH 153",
    group: "8",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45, Cuma 13:05 - 14:45",
    time: [22, 23, 70, 71],
    seen: false
  }, {
    id: "1782",
    code: "MATH 153",
    group: "9",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45, Cuma 13:05 - 14:45",
    time: [22, 23, 70, 71],
    seen: false
  }, {
    id: "1783",
    code: "MATH 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Çarşamba 11:15 - 12:55",
    time: [19, 20, 36, 37],
    seen: false
  }, {
    id: "1784",
    code: "MATH 203",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Perşembe 08:30 - 10:10",
    time: [17, 18, 49, 50],
    seen: false
  }, {
    id: "1785",
    code: "MATH 207",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:55, Cuma 11:15 - 12:55",
    time: [4, 5, 68, 69],
    seen: false
  }, {
    id: "1786",
    code: "MATH 207",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:55, Perşembe 11:15 - 12:55",
    time: [4, 5, 52, 53],
    seen: false
  }, {
    id: "1787",
    code: "MATH 207",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Perşembe 13:05 - 14:45",
    time: [7, 8, 54, 55],
    seen: false
  }, {
    id: "1788",
    code: "MATH 207",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Perşembe 13:05 - 14:45",
    time: [7, 8, 54, 55],
    seen: false
  }, {
    id: "1789",
    code: "MATH 225",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "1790",
    code: "MATH 231",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "1791",
    code: "MATH 236",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "1792",
    code: "MATH 236",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "1793",
    code: "MATH 236",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "1794",
    code: "MATH 236",
    group: "4",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "1795",
    code: "MATH 240",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "1796",
    code: "MATH 240",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "1797",
    code: "MATH 240",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "1798",
    code: "MATH 240",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "1799",
    code: "MATH 240",
    group: "5",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "1800",
    code: "MATH 240",
    group: "6",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "1801",
    code: "MATH 250",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "1802",
    code: "MATH 250",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "1803",
    code: "MATH 250",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "1804",
    code: "MATH 250",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1805",
    code: "MATH 250",
    group: "5",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1806",
    code: "MATH 250",
    group: "6",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "1807",
    code: "MATH 301",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "1808",
    code: "MATH 303",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "1809",
    code: "MATH 305",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "1810",
    code: "MATH 307",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "1811",
    code: "MATH 313",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "1812",
    code: "MATH 336",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "1813",
    code: "MATH 336",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "1814",
    code: "MATH 401",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "1815",
    code: "MATH 403",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1816",
    code: "MATH 441",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "1817",
    code: "MATH 470",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "1818",
    code: "MATH 485",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "1819",
    code: "MATH 497",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 15:40",
    time: [86, 87, 88],
    seen: false
  }, {
    id: "1820",
    code: "MATH 497",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 15:40",
    time: [86, 87, 88],
    seen: false
  }, {
    id: "1821",
    code: "MATH 497",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 15:40",
    time: [86, 87, 88],
    seen: false
  }, {
    id: "1822",
    code: "MATH 497",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 15:40",
    time: [86, 87, 88],
    seen: false
  }, {
    id: "1823",
    code: "MATH 497",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 15:40",
    time: [86, 87, 88],
    seen: false
  }, {
    id: "1824",
    code: "MATH 497",
    group: "6",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 15:40",
    time: [86, 87, 88],
    seen: false
  }, {
    id: "1825",
    code: "MATH 497",
    group: "7",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 15:40",
    time: [86, 87, 88],
    seen: false
  }, {
    id: "1826",
    code: "MATH 602",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "1827",
    code: "MATH 695",
    group: "1",
    type: "Yüz yüze",
    day: "Pazar 13:05 - 13:50",
    time: [102],
    seen: false
  }, {
    id: "1828",
    code: "MATH 695",
    group: "2",
    type: "Yüz yüze",
    day: "Pazar 13:05 - 13:50",
    time: [102],
    seen: false
  }, {
    id: "1829",
    code: "MATH 695",
    group: "3",
    type: "Yüz yüze",
    day: "Pazar 13:05 - 13:50",
    time: [102],
    seen: false
  }, {
    id: "1830",
    code: "MATH 695",
    group: "4",
    type: "Yüz yüze",
    day: "Pazar 13:05 - 13:50",
    time: [102],
    seen: false
  }, {
    id: "1831",
    code: "MATH 695",
    group: "5",
    type: "Yüz yüze",
    day: "Pazar 13:05 - 13:50",
    time: [102],
    seen: false
  }, {
    id: "1832",
    code: "MATH 695",
    group: "6",
    type: "Yüz yüze",
    day: "Pazar 13:05 - 13:50",
    time: [102],
    seen: false
  }, {
    id: "1833",
    code: "MATH 699",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 17:40 - 18:25",
    time: [91],
    seen: false
  }, {
    id: "1834",
    code: "MATH 699",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 17:40 - 18:25",
    time: [91],
    seen: false
  }, {
    id: "1835",
    code: "MBP 101",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 10:10",
    time: [65, 66],
    seen: false
  }, {
    id: "1836",
    code: "MBP 101",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:00",
    time: [67, 68],
    seen: false
  }, {
    id: "1837",
    code: "MBP 101",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 14:45",
    time: [70, 71],
    seen: false
  }, {
    id: "1838",
    code: "MBP 101",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 14:55 - 16:35",
    time: [72, 73],
    seen: false
  }, {
    id: "1839",
    code: "MBP 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "1840",
    code: "MBP 103",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "1841",
    code: "MBP 103",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1842",
    code: "MBP 103",
    group: "4",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "1843",
    code: "MBP 105",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10",
    time: [17, 18],
    seen: false
  }, {
    id: "1844",
    code: "MBP 105",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10",
    time: [33, 34],
    seen: false
  }, {
    id: "1845",
    code: "MBP 105",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00",
    time: [35, 36],
    seen: false
  }, {
    id: "1846",
    code: "MBP 105",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40",
    time: [23, 24],
    seen: false
  }, {
    id: "1847",
    code: "MBP 191",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "1848",
    code: "MBP 191",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "1849",
    code: "MBP 191",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1850",
    code: "MBP 191",
    group: "4",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "1851",
    code: "MBP 193",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10",
    time: [17, 18],
    seen: false
  }, {
    id: "1852",
    code: "MBP 193",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10",
    time: [33, 34],
    seen: false
  }, {
    id: "1853",
    code: "MBP 193",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00",
    time: [35, 36],
    seen: false
  }, {
    id: "1854",
    code: "MBP 193",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40",
    time: [23, 24],
    seen: false
  }, {
    id: "1855",
    code: "MBP 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Çarşamba 14:00 - 15:40",
    time: [7, 8, 39, 40],
    seen: false
  }, {
    id: "1856",
    code: "MBP 201",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Çarşamba 15:50 - 17:30",
    time: [9, 10, 41, 42],
    seen: false
  }, {
    id: "1857",
    code: "MBP 201",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 17:40 - 19:20, Çarşamba 17:40 - 19:20",
    time: [11, 12, 43, 44],
    seen: false
  }, {
    id: "1858",
    code: "MBP 203",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Çarşamba 12:10 - 13:50",
    time: [23, 24, 37, 38],
    seen: false
  }, {
    id: "1859",
    code: "MBP 205",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Salı 12:10 - 13:50",
    time: [1, 2, 21, 22],
    seen: false
  }, {
    id: "1860",
    code: "MBP 205",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Salı 14:00 - 15:40",
    time: [3, 4, 23, 24],
    seen: false
  }, {
    id: "1861",
    code: "MBP 205",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Çarşamba 15:50 - 17:30",
    time: [7, 8, 41, 42],
    seen: false
  }, {
    id: "1862",
    code: "MBP 207",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Salı 08:30 - 10:10",
    time: [3, 4, 17, 18],
    seen: false
  }, {
    id: "1863",
    code: "MBP 207",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Salı 10:20 - 12:00",
    time: [1, 2, 19, 20],
    seen: false
  }, {
    id: "1864",
    code: "MBP 207",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Çarşamba 14:00 - 15:40",
    time: [9, 10, 39, 40],
    seen: false
  }, {
    id: "1865",
    code: "MBP 211",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 13:50, Çarşamba 08:30 - 10:10",
    time: [21, 22, 33, 34],
    seen: false
  }, {
    id: "1866",
    code: "MBP 221",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Çarşamba 10:20 - 12:00",
    time: [19, 20, 35, 36],
    seen: false
  }, {
    id: "1867",
    code: "MBP 251",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 11:15 - 14:45",
    time: [52, 53, 54, 55],
    seen: false
  }, {
    id: "1868",
    code: "MBP 252",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:55",
    time: [50, 51, 52, 53],
    seen: false
  }, {
    id: "1869",
    code: "MBP 281",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Çarşamba 14:00 - 15:40",
    time: [7, 8, 39, 40],
    seen: false
  }, {
    id: "1870",
    code: "MBP 281",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Çarşamba 15:50 - 17:30",
    time: [9, 10, 41, 42],
    seen: false
  }, {
    id: "1871",
    code: "MBP 281",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 17:40 - 19:20, Çarşamba 17:40 - 19:20",
    time: [11, 12, 43, 44],
    seen: false
  }, {
    id: "1872",
    code: "MBP 283",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "1873",
    code: "MCE 202",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30, Perşembe 14:00 - 15:40",
    time: [41, 42, 55, 56],
    seen: false
  }, {
    id: "1874",
    code: "MCE 202",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 15:40, Perşembe 15:50 - 17:30",
    time: [39, 40, 57, 58],
    seen: false
  }, {
    id: "1875",
    code: "MCE 306",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30, Cuma 12:10 - 13:50",
    time: [41, 42, 69, 70],
    seen: false
  }, {
    id: "1876",
    code: "MCE 310",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00, Perşembe 12:10 - 12:55",
    time: [2, 3, 4, 53],
    seen: false
  }, {
    id: "1877",
    code: "MCE 310",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00, Perşembe 13:05 - 13:50",
    time: [2, 3, 4, 54],
    seen: false
  }, {
    id: "1878",
    code: "MCE 350",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "1879",
    code: "MCE 402",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Çarşamba 14:00 - 15:40",
    time: [6, 7, 39, 40],
    seen: false
  }, {
    id: "1880",
    code: "MCE 412",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "1881",
    code: "MCE 420",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35, Salı 14:55 - 16:35",
    time: [8, 9, 24, 25],
    seen: false
  }, {
    id: "1882",
    code: "MCE 460",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 11:05, Perşembe 16:45 - 17:30",
    time: [50, 51, 58],
    seen: false
  }, {
    id: "1883",
    code: "MCPR 551",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "1884",
    code: "MCPR 566",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "1885",
    code: "MCPR 569",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "1886",
    code: "MCS 111",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Cuma 09:25 - 11:05, Cumartesi 08:30 - 09:15",
    time: [1, 2, 66, 67, 81],
    seen: false
  }, {
    id: "1887",
    code: "MCS 111",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 12:10 - 13:50, Perşembe 09:25 - 11:05, Cumartesi 08:30 - 09:15",
    time: [21, 22, 50, 51, 81],
    seen: false
  }, {
    id: "1888",
    code: "MCS 260",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "1889",
    code: "MCS 260",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "1890",
    code: "MCS 260",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "1891",
    code: "MCS 270",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00",
    time: [49, 50, 51, 52],
    seen: false
  }, {
    id: "1892",
    code: "MCS 270",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "1893",
    code: "MCSB 301",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40, Perşembe 09:25 - 12:00, Cumartesi 13:05 - 14:45",
    time: [6, 7, 8, 50, 51, 52, 86, 87],
    seen: false
  }, {
    id: "1894",
    code: "MCSB 497",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:55, Cumartesi 08:30 - 09:15",
    time: [65, 66, 67, 68, 69, 81],
    seen: false
  }, {
    id: "1895",
    code: "ME 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 17:30, Çarşamba 10:20 - 12:00",
    time: [25, 26, 35, 36],
    seen: false
  }, {
    id: "1896",
    code: "ME 202",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35, Salı 15:50 - 17:30",
    time: [8, 9, 25, 26],
    seen: false
  }, {
    id: "1897",
    code: "ME 203",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:55",
    time: [17, 18, 19, 20, 21],
    seen: false
  }, {
    id: "1898",
    code: "ME 203",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 18:25",
    time: [7, 8, 9, 10, 11],
    seen: false
  }, {
    id: "1899",
    code: "ME 203",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:55",
    time: [65, 66, 67, 68, 69],
    seen: false
  }, {
    id: "1900",
    code: "ME 205",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Çarşamba 14:00 - 14:45",
    time: [23, 24, 39],
    seen: false
  }, {
    id: "1901",
    code: "ME 206",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Perşembe 10:20 - 12:00",
    time: [17, 18, 51, 52],
    seen: false
  }, {
    id: "1902",
    code: "ME 208",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 13:50, Salı 10:20 - 12:00",
    time: [5, 6, 19, 20],
    seen: false
  }, {
    id: "1903",
    code: "ME 211",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 11:05, Salı 12:10 - 13:50",
    time: [2, 3, 21, 22],
    seen: false
  }, {
    id: "1904",
    code: "ME 211",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Çarşamba 14:00 - 15:40",
    time: [23, 24, 39, 40],
    seen: false
  }, {
    id: "1905",
    code: "ME 211",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Çarşamba 14:55 - 16:35",
    time: [23, 24, 40, 41],
    seen: false
  }, {
    id: "1906",
    code: "ME 305",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 15:40, Perşembe 12:10 - 13:50",
    time: [39, 40, 53, 54],
    seen: false
  }, {
    id: "1907",
    code: "ME 307",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Perşembe 09:25 - 11:05",
    time: [9, 10, 50, 51],
    seen: false
  }, {
    id: "1908",
    code: "ME 309",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 13:50, Çarşamba 15:50 - 17:30",
    time: [21, 22, 41, 42],
    seen: false
  }, {
    id: "1909",
    code: "ME 311",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "1910",
    code: "ME 401",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 13:50, Çarşamba 15:50 - 17:30",
    time: [21, 22, 41, 42],
    seen: false
  }, {
    id: "1911",
    code: "ME 403",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Salı 08:30 - 10:10",
    time: [3, 4, 17, 18],
    seen: false
  }, {
    id: "1912",
    code: "ME 410",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 17:30, Perşembe 14:00 - 15:40",
    time: [25, 26, 55, 56],
    seen: false
  }, {
    id: "1913",
    code: "ME 423",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 10:10, Cuma 10:20 - 12:00",
    time: [49, 50, 67, 68],
    seen: false
  }, {
    id: "1914",
    code: "ME 425",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 17:30, Çarşamba 08:30 - 10:10",
    time: [25, 26, 33, 34],
    seen: false
  }, {
    id: "1915",
    code: "ME 450",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 13:50, Cuma 12:10 - 13:50",
    time: [53, 54, 69, 70],
    seen: false
  }, {
    id: "1916",
    code: "ME 460",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1917",
    code: "ME 523",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 18:35 - 21:10",
    time: [76, 77, 78],
    seen: false
  }, {
    id: "1918",
    code: "ME 528",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "1919",
    code: "ME 529",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "1920",
    code: "MED 215",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "1921",
    code: "MED 245",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "1922",
    code: "MED 255",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "1923",
    code: "MED 265",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "1924",
    code: "MED 310",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "1925",
    code: "MEKO 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "1926",
    code: "MEKO 101",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "1927",
    code: "MEKO 101",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1928",
    code: "MEKO 190",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "1929",
    code: "MEKO 190",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1930",
    code: "MEKO 190",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "1931",
    code: "MGT 131",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "1932",
    code: "MGT 131",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1933",
    code: "MGT 131",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "1934",
    code: "MGT 151",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05, Pazar 08:30 - 11:05",
    time: [17, 18, 19, 97, 98, 99],
    seen: false
  }, {
    id: "1935",
    code: "MGT 151",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25, Pazar 11:15 - 13:50",
    time: [41, 42, 43, 100, 101, 102],
    seen: false
  }, {
    id: "1936",
    code: "MGT 151",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45, Pazar 14:00 - 16:35",
    time: [37, 38, 39, 103, 104, 105],
    seen: false
  }, {
    id: "1937",
    code: "MGT 191",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "1938",
    code: "MGT 191",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1939",
    code: "MGT 191",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "1940",
    code: "MGT 193",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "1941",
    code: "MGT 193",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "1942",
    code: "MGT 193",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1943",
    code: "MGT 195",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "1944",
    code: "MGT 195",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "1945",
    code: "MGT 195",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1946",
    code: "MGT 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05, Salı 10:20 - 12:55",
    time: [1, 2, 3, 19, 20, 21],
    seen: false
  }, {
    id: "1947",
    code: "MGT 201",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05, Salı 11:15 - 13:50",
    time: [1, 2, 3, 20, 21, 22],
    seen: false
  }, {
    id: "1948",
    code: "MGT 201",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45, Salı 15:50 - 18:25",
    time: [5, 6, 7, 25, 26, 27],
    seen: false
  }, {
    id: "1949",
    code: "MGT 201",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45, Cuma 15:50 - 18:25",
    time: [5, 6, 7, 73, 74, 75],
    seen: false
  }, {
    id: "1950",
    code: "MGT 203",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "1951",
    code: "MGT 203",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "1952",
    code: "MGT 203",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "1953",
    code: "MGT 203",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "1954",
    code: "MGT 205",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "1955",
    code: "MGT 207",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "1956",
    code: "MGT 207",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 17:40 - 21:10",
    time: [59, 60, 61, 62],
    seen: false
  }, {
    id: "1957",
    code: "MGT 207",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 15:40",
    time: [37, 38, 39, 40],
    seen: false
  }, {
    id: "1958",
    code: "MGT 207",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "1959",
    code: "MGT 209",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45, Salı 14:55 - 17:30",
    time: [5, 6, 7, 24, 25, 26],
    seen: false
  }, {
    id: "1960",
    code: "MGT 209",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45, Perşembe 12:10 - 14:45",
    time: [37, 38, 39, 53, 54, 55],
    seen: false
  }, {
    id: "1961",
    code: "MGT 209",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 17:40 - 20:15, Salı 18:35 - 21:10",
    time: [11, 12, 13, 28, 29, 30],
    seen: false
  }, {
    id: "1962",
    code: "MGT 209",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05, Salı 11:15 - 13:50",
    time: [1, 2, 3, 20, 21, 22],
    seen: false
  }, {
    id: "1963",
    code: "MGT 225",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "1964",
    code: "MGT 225",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "1965",
    code: "MGT 227",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "1966",
    code: "MGT 227",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "1967",
    code: "MGT 295",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "1968",
    code: "MGT 295",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "1969",
    code: "MGT 296",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "1970",
    code: "MGT 296",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "1971",
    code: "MICM 107",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "1972",
    code: "MICM 107",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "1973",
    code: "MICM 109",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 15:40",
    time: [21, 22, 23, 24],
    seen: false
  }, {
    id: "1974",
    code: "MICM 109",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "1975",
    code: "MICM 109",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00",
    time: [49, 50, 51, 52],
    seen: false
  }, {
    id: "1976",
    code: "MICM 203",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30",
    time: [41, 42],
    seen: false
  }, {
    id: "1977",
    code: "MICM 205",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "1978",
    code: "MICM 205",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35",
    time: [6, 7, 8, 9],
    seen: false
  }, {
    id: "1979",
    code: "MICM 207",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 15:40",
    time: [21, 22, 23, 24],
    seen: false
  }, {
    id: "1980",
    code: "MICM 207",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 15:40",
    time: [37, 38, 39, 40],
    seen: false
  }, {
    id: "1981",
    code: "MICM 231",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "1982",
    code: "MICM 231",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35",
    time: [6, 7, 8, 9],
    seen: false
  }, {
    id: "1983",
    code: "MINT 101",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 16:35, Perşembe 08:30 - 10:10",
    time: [40, 41, 49, 50],
    seen: false
  }, {
    id: "1984",
    code: "MINT 103",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Perşembe 10:20 - 12:00",
    time: [17, 18, 51, 52],
    seen: false
  }, {
    id: "1985",
    code: "MINT 105",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "1986",
    code: "MINT 105",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 17:30",
    time: [71, 72, 73, 74],
    seen: false
  }, {
    id: "1987",
    code: "MINT 191",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 16:35, Perşembe 08:30 - 10:10",
    time: [40, 41, 49, 50],
    seen: false
  }, {
    id: "1988",
    code: "MINT 193",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Perşembe 10:20 - 12:00",
    time: [17, 18, 51, 52],
    seen: false
  }, {
    id: "1989",
    code: "MINT 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Perşembe 13:05 - 14:45",
    time: [19, 20, 54, 55],
    seen: false
  }, {
    id: "1990",
    code: "MINT 203",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 13:50, Perşembe 14:55 - 16:35",
    time: [37, 38, 56, 57],
    seen: false
  }, {
    id: "1991",
    code: "MINT 205",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "1992",
    code: "MINT 207",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "1993",
    code: "MINT 209",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 18:25, Çarşamba 16:45 - 18:25",
    time: [10, 11, 42, 43],
    seen: false
  }, {
    id: "1994",
    code: "MINT 250",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "1995",
    code: "MISG 101",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "1996",
    code: "MISG 101",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "1997",
    code: "MISG 105",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10",
    time: [33, 34],
    seen: false
  }, {
    id: "1998",
    code: "MISG 106",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "1999",
    code: "MISG 191",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10",
    time: [33, 34],
    seen: false
  }, {
    id: "2000",
    code: "MISG 201",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2001",
    code: "MISG 203",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 17:30",
    time: [57, 58],
    seen: false
  }, {
    id: "2002",
    code: "MISG 211",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "2003",
    code: "MISG 215",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30",
    time: [41, 42],
    seen: false
  }, {
    id: "2004",
    code: "MISG 217",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 11:15 - 12:55, Çarşamba 14:55 - 15:40",
    time: [36, 37, 40],
    seen: false
  }, {
    id: "2005",
    code: "MISG 280",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "2006",
    code: "MISG 281",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2007",
    code: "MISL 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2008",
    code: "MISL 101",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "2009",
    code: "MISL 101",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "2010",
    code: "MMAT 113",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2011",
    code: "MMAT 113",
    group: "10",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "2012",
    code: "MMAT 113",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "2013",
    code: "MMAT 113",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50",
    time: [20, 21, 22],
    seen: false
  }, {
    id: "2014",
    code: "MMAT 113",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "2015",
    code: "MMAT 113",
    group: "5",
    type: "Yüz yüze",
    day: "Çarşamba 11:15 - 13:50",
    time: [36, 37, 38],
    seen: false
  }, {
    id: "2016",
    code: "MMAT 113",
    group: "6",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "2017",
    code: "MMAT 113",
    group: "7",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "2018",
    code: "MMAT 113",
    group: "8",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "2019",
    code: "MMAT 113",
    group: "9",
    type: "Yüz yüze",
    day: "Cuma 11:15 - 13:50",
    time: [68, 69, 70],
    seen: false
  }, {
    id: "2020",
    code: "MMC 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "2021",
    code: "MMC 101",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "2022",
    code: "MMC 101",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "2023",
    code: "MMC 101",
    group: "4",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "2024",
    code: "MMC 220",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Cuma 09:25 - 10:10",
    time: [1, 2, 66],
    seen: false
  }, {
    id: "2025",
    code: "MMC 220",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 12:10 - 13:50, Perşembe 09:25 - 10:10",
    time: [21, 22, 50],
    seen: false
  }, {
    id: "2026",
    code: "MMC 304",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Perşembe 13:05 - 14:45",
    time: [17, 18, 54, 55],
    seen: false
  }, {
    id: "2027",
    code: "MMC 304",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55, Cuma 13:05 - 14:45",
    time: [20, 21, 70, 71],
    seen: false
  }, {
    id: "2028",
    code: "MMD 301",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45, Pazartesi 15:50 - 16:35, Perşembe 12:10 - 15:40",
    time: [5, 6, 7, 9, 53, 54, 55, 56],
    seen: false
  }, {
    id: "2029",
    code: "MMD 304",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00",
    time: [17, 18, 19, 20],
    seen: false
  }, {
    id: "2030",
    code: "MMD 306",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 15:40",
    time: [37, 38, 39, 40],
    seen: false
  }, {
    id: "2031",
    code: "MMD 401",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 65, 66, 67, 68],
    seen: false
  }, {
    id: "2032",
    code: "MMD 431",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "2033",
    code: "MMD 433",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 12:10 - 15:40",
    time: [69, 70, 71, 72],
    seen: false
  }, {
    id: "2034",
    code: "MMD 494",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "2035",
    code: "MMIR 101",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45",
    time: [21, 22, 23],
    seen: false
  }, {
    id: "2036",
    code: "MMIR 101",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "2037",
    code: "MMIR 101",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "2038",
    code: "MMIR 101",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "2039",
    code: "MMIR 101",
    group: "5",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "2040",
    code: "MMIR 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10",
    time: [1, 2],
    seen: false
  }, {
    id: "2041",
    code: "MMIR 105",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30",
    time: [24, 25, 26],
    seen: false
  }, {
    id: "2042",
    code: "MMIR 107",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "2043",
    code: "MMIR 107",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "2044",
    code: "MMIR 191",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30",
    time: [24, 25, 26],
    seen: false
  }, {
    id: "2045",
    code: "MMIR 193",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "2046",
    code: "MMIR 193",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "2047",
    code: "MMIR 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "2048",
    code: "MMIR 203",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35",
    time: [6, 7, 8, 9],
    seen: false
  }, {
    id: "2049",
    code: "MMIR 205",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "2050",
    code: "MMIR 207",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "2051",
    code: "MMIR 209",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "2052",
    code: "MMIR 209",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 16:35",
    time: [70, 71, 72, 73],
    seen: false
  }, {
    id: "2053",
    code: "MMIR 211",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "2054",
    code: "MMIR 231",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "2055",
    code: "MMIR 291",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "2056",
    code: "MMVD 105",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "2057",
    code: "MMVD 105",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 16:35",
    time: [70, 71, 72, 73],
    seen: false
  }, {
    id: "2058",
    code: "MMVD 201",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "2059",
    code: "MMVD 212",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:00",
    time: [67, 68],
    seen: false
  }, {
    id: "2060",
    code: "MMVD 250",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "2061",
    code: "MPAZ 110",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "2062",
    code: "MPAZ 190",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "2063",
    code: "MTOI 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2064",
    code: "MTOI 101",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "2065",
    code: "MTOI 103",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "2066",
    code: "MTOI 103",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "2067",
    code: "MTOI 105",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10",
    time: [17, 18],
    seen: false
  }, {
    id: "2068",
    code: "MTOI 203",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2069",
    code: "MTOI 207",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "2070",
    code: "MTOI 209",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "2071",
    code: "MTOI 225",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "2072",
    code: "MTOI 230",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "2073",
    code: "MTOI 230",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "2074",
    code: "MTOI 241",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "2075",
    code: "MTOI 260",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 18:25",
    time: [42, 43],
    seen: false
  }, {
    id: "2076",
    code: "MUH 100",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "2077",
    code: "MUH 100",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "2078",
    code: "MUH 100",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "2079",
    code: "MUH 103",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "2080",
    code: "MUH 190",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "2081",
    code: "MUH 190",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "2082",
    code: "MUH 190",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "2083",
    code: "MYO 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 11:05, Perşembe 13:05 - 15:40, Cuma 08:30 - 09:15",
    time: [2, 3, 54, 55, 56, 65],
    seen: false
  }, {
    id: "2084",
    code: "NMC 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 13:50, Çarşamba 12:10 - 13:50",
    time: [5, 6, 37, 38],
    seen: false
  }, {
    id: "2085",
    code: "NMC 103",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35, Perşembe 08:30 - 10:10",
    time: [8, 9, 49, 50],
    seen: false
  }, {
    id: "2086",
    code: "NMC 103",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 16:35, Perşembe 11:15 - 12:55",
    time: [40, 41, 52, 53],
    seen: false
  }, {
    id: "2087",
    code: "NMC 105",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "2088",
    code: "NMC 201",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00",
    time: [49, 50, 51, 52],
    seen: false
  }, {
    id: "2089",
    code: "NMC 201",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "2090",
    code: "NMC 203",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Perşembe 13:05 - 14:45",
    time: [17, 18, 54, 55],
    seen: false
  }, {
    id: "2091",
    code: "NMC 203",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55, Cuma 13:05 - 14:45",
    time: [20, 21, 70, 71],
    seen: false
  }, {
    id: "2092",
    code: "NMC 205",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2093",
    code: "NMC 205",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "2094",
    code: "NMC 205",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "2095",
    code: "NMC 207",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "2096",
    code: "NMC 209",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 13:50",
    time: [37, 38],
    seen: false
  }, {
    id: "2097",
    code: "NMC 209",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 16:35",
    time: [40, 41],
    seen: false
  }, {
    id: "2098",
    code: "NMC 301",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40, Perşembe 09:25 - 12:00",
    time: [6, 7, 8, 50, 51, 52],
    seen: false
  }, {
    id: "2099",
    code: "NMC 302",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "2100",
    code: "NMC 303",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "2101",
    code: "NMC 310",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2102",
    code: "NMC 312",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "2103",
    code: "NMC 401",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:55, Cumartesi 08:30 - 09:15",
    time: [65, 66, 67, 68, 69, 81],
    seen: false
  }, {
    id: "2104",
    code: "NMC 454",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "2105",
    code: "NMC 465",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2106",
    code: "NMC 466",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2107",
    code: "NMC 467",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "2108",
    code: "OPT 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2109",
    code: "OPT 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45",
    time: [6, 7],
    seen: false
  }, {
    id: "2110",
    code: "OPT 105",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "2111",
    code: "OPT 107",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 17:30",
    time: [25, 26],
    seen: false
  }, {
    id: "2112",
    code: "OPT 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "2113",
    code: "OPT 203",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Perşembe 10:20 - 12:55, Cuma 10:20 - 16:35",
    time: [17, 18, 51, 52, 53, 67, 68, 69, 70, 71, 72, 73],
    seen: false
  }, {
    id: "2114",
    code: "OPT 203",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Perşembe 14:00 - 16:35, Cuma 10:20 - 16:35",
    time: [17, 18, 55, 56, 57, 67, 68, 69, 70, 71, 72, 73],
    seen: false
  }, {
    id: "2115",
    code: "OPT 205",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35",
    time: [8, 9],
    seen: false
  }, {
    id: "2116",
    code: "OPT 210",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30",
    time: [41, 42],
    seen: false
  }, {
    id: "2117",
    code: "PD 316",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "2118",
    code: "PD 409",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 65, 66, 67, 68],
    seen: false
  }, {
    id: "2119",
    code: "PHYS 100",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Çarşamba 14:55 - 16:35",
    time: [1, 2, 40, 41],
    seen: false
  }, {
    id: "2120",
    code: "PHYS 100",
    group: "10",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Çarşamba 13:05 - 14:45",
    time: [6, 7, 38, 39],
    seen: false
  }, {
    id: "2121",
    code: "PHYS 100",
    group: "11",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Perşembe 14:00 - 15:40",
    time: [6, 7, 55, 56],
    seen: false
  }, {
    id: "2122",
    code: "PHYS 100",
    group: "12",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Perşembe 14:00 - 15:40",
    time: [6, 7, 55, 56],
    seen: false
  }, {
    id: "2123",
    code: "PHYS 100",
    group: "13",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Perşembe 12:10 - 13:50",
    time: [19, 20, 53, 54],
    seen: false
  }, {
    id: "2124",
    code: "PHYS 100",
    group: "14",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Perşembe 12:10 - 13:50",
    time: [19, 20, 53, 54],
    seen: false
  }, {
    id: "2125",
    code: "PHYS 100",
    group: "15",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Çarşamba 10:20 - 12:00",
    time: [19, 20, 35, 36],
    seen: false
  }, {
    id: "2126",
    code: "PHYS 100",
    group: "16",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Çarşamba 10:20 - 12:00",
    time: [19, 20, 35, 36],
    seen: false
  }, {
    id: "2127",
    code: "PHYS 100",
    group: "17",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Çarşamba 08:30 - 10:10",
    time: [17, 18, 33, 34],
    seen: false
  }, {
    id: "2128",
    code: "PHYS 100",
    group: "18",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Çarşamba 08:30 - 10:10",
    time: [17, 18, 33, 34],
    seen: false
  }, {
    id: "2129",
    code: "PHYS 100",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Çarşamba 14:55 - 16:35",
    time: [1, 2, 40, 41],
    seen: false
  }, {
    id: "2130",
    code: "PHYS 100",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Perşembe 08:30 - 10:10",
    time: [1, 2, 49, 50],
    seen: false
  }, {
    id: "2131",
    code: "PHYS 100",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Perşembe 08:30 - 10:10",
    time: [1, 2, 49, 50],
    seen: false
  }, {
    id: "2132",
    code: "PHYS 100",
    group: "5",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Perşembe 10:20 - 12:00",
    time: [3, 4, 51, 52],
    seen: false
  }, {
    id: "2133",
    code: "PHYS 100",
    group: "6",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Perşembe 10:20 - 12:00",
    time: [3, 4, 51, 52],
    seen: false
  }, {
    id: "2134",
    code: "PHYS 100",
    group: "7",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Perşembe 15:50 - 17:30",
    time: [3, 4, 57, 58],
    seen: false
  }, {
    id: "2135",
    code: "PHYS 100",
    group: "8",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Perşembe 15:50 - 17:30",
    time: [3, 4, 57, 58],
    seen: false
  }, {
    id: "2136",
    code: "PHYS 100",
    group: "9",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Çarşamba 13:05 - 14:45",
    time: [6, 7, 38, 39],
    seen: false
  }, {
    id: "2137",
    code: "PHYS 105",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:55, Çarşamba 10:20 - 12:00, Cuma 13:05 - 15:40",
    time: [4, 5, 35, 36, 70, 71, 72],
    seen: false
  }, {
    id: "2138",
    code: "PHYS 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35, Çarşamba 08:30 - 10:10",
    time: [8, 9, 33, 34],
    seen: false
  }, {
    id: "2139",
    code: "PHYS 301",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Perşembe 12:10 - 13:50",
    time: [19, 20, 53, 54],
    seen: false
  }, {
    id: "2140",
    code: "PHYS 305",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 16:45 - 18:25, Perşembe 08:30 - 10:10",
    time: [26, 27, 49, 50],
    seen: false
  }, {
    id: "2141",
    code: "PHYS 307",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Çarşamba 10:20 - 12:00",
    time: [17, 18, 35, 36],
    seen: false
  }, {
    id: "2142",
    code: "PHYS 309",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 16:35, Cuma 09:25 - 11:05",
    time: [24, 25, 66, 67],
    seen: false
  }, {
    id: "2143",
    code: "PHYS 401",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35, Perşembe 15:50 - 17:30",
    time: [8, 9, 57, 58],
    seen: false
  }, {
    id: "2144",
    code: "PHYS 403",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45, Çarşamba 12:10 - 13:50",
    time: [22, 23, 37, 38],
    seen: false
  }, {
    id: "2145",
    code: "PHYS 407",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10, Perşembe 10:20 - 12:00",
    time: [33, 34, 51, 52],
    seen: false
  }, {
    id: "2146",
    code: "PHYS 413",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 18:25, Çarşamba 14:55 - 16:35",
    time: [10, 11, 40, 41],
    seen: false
  }, {
    id: "2147",
    code: "PHYS 497",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "2148",
    code: "PRA 205",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "2149",
    code: "PRA 205",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2150",
    code: "PRA 206",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "2151",
    code: "PRA 206",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2152",
    code: "PRA 221",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "2153",
    code: "PRA 230",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "2154",
    code: "PRA 230",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "2155",
    code: "PRA 300",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "2156",
    code: "PRA 301",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "2157",
    code: "PRA 307",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "2158",
    code: "PRA 313",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "2159",
    code: "PRA 315",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "2160",
    code: "PRA 317",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "2161",
    code: "PRA 319",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "2162",
    code: "PRA 320",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "2163",
    code: "PRA 342",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "2164",
    code: "PRA 347",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00",
    time: [49, 50, 51, 52],
    seen: false
  }, {
    id: "2165",
    code: "PRA 380",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "2166",
    code: "PRA 416",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "2167",
    code: "PRA 427",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35, Perşembe 14:55 - 18:25",
    time: [23, 24, 25, 56, 57, 58, 59],
    seen: false
  }, {
    id: "2168",
    code: "PRA 427",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35, Perşembe 14:55 - 18:25",
    time: [23, 24, 25, 56, 57, 58, 59],
    seen: false
  }, {
    id: "2169",
    code: "PRA 435",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35, Perşembe 14:55 - 18:25",
    time: [23, 24, 25, 56, 57, 58, 59],
    seen: false
  }, {
    id: "2170",
    code: "PRA 435",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35, Perşembe 14:55 - 18:25",
    time: [23, 24, 25, 56, 57, 58, 59],
    seen: false
  }, {
    id: "2171",
    code: "PRA 485",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 16:35, Perşembe 08:30 - 12:00",
    time: [34, 35, 36, 37, 38, 39, 40, 41, 49, 50, 51, 52],
    seen: false
  }, {
    id: "2172",
    code: "PRA 495",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "2173",
    code: "PSIR 101",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "2174",
    code: "PSIR 101",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "2175",
    code: "PSIR 201",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "2176",
    code: "PSIR 203",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "2177",
    code: "PSIR 205",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "2178",
    code: "PSIR 207",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "2179",
    code: "PSIR 215",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "2180",
    code: "PSIR 230",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "2181",
    code: "PSIR 240",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "2182",
    code: "PSIR 301",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "2183",
    code: "PSIR 303",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "2184",
    code: "PSIR 305",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "2185",
    code: "PSIR 307",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "2186",
    code: "PSIR 320",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2187",
    code: "PSIR 325",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "2188",
    code: "PSIR 340",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "2189",
    code: "PSIR 400",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "2190",
    code: "PSIR 442",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "2191",
    code: "PSIR 444",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "2192",
    code: "PSIR 450",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "2193",
    code: "PSIR 503",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "2194",
    code: "PSIR 505",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 18:35 - 21:10",
    time: [76, 77, 78],
    seen: false
  }, {
    id: "2195",
    code: "PSIR 514",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "2196",
    code: "PSIR 552",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "2197",
    code: "PSIR 601",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "2198",
    code: "PSIR 603",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "2199",
    code: "PSIR 631",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "2200",
    code: "PSIR 674",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "2201",
    code: "PSIR 695",
    group: "5",
    type: "Yüz yüze",
    day: "Pazar 14:55 - 15:40",
    time: [104],
    seen: false
  }, {
    id: "2202",
    code: "PSIR 697",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "2203",
    code: "PSIR 697",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "2204",
    code: "PSIR 698",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "2205",
    code: "PSIR 699",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "2206",
    code: "PSIR 699",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 15:50 - 16:35",
    time: [89],
    seen: false
  }, {
    id: "2207",
    code: "PSIR 699",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "2208",
    code: "PSIR 699",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "2209",
    code: "PSIR 699",
    group: "5",
    type: "Yüz yüze",
    day: "Cumartesi 14:55 - 15:40",
    time: [88],
    seen: false
  }, {
    id: "2210",
    code: "PSIR 699",
    group: "6",
    type: "Yüz yüze",
    day: "Cumartesi 15:50 - 16:35",
    time: [89],
    seen: false
  }, {
    id: "2211",
    code: "PSY 101",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "2212",
    code: "PSY 101",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "2213",
    code: "PSY 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "2214",
    code: "PSY 103",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2215",
    code: "PSY 201",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "2216",
    code: "PSY 201",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "2217",
    code: "PSY 203",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2218",
    code: "PSY 203",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "2219",
    code: "PSY 205",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "2220",
    code: "PSY 205",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "2221",
    code: "PSY 303",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 17:30",
    time: [40, 41, 42],
    seen: false
  }, {
    id: "2222",
    code: "PSY 303",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "2223",
    code: "PSY 304",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "2224",
    code: "PSY 305",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "2225",
    code: "PSY 305",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "2226",
    code: "PSY 307",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "2227",
    code: "PSY 307",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "2228",
    code: "PSY 311",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "2229",
    code: "PSY 318",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "2230",
    code: "PSY 323",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00, Perşembe 13:05 - 15:40",
    time: [50, 51, 52, 54, 55, 56],
    seen: false
  }, {
    id: "2231",
    code: "PSY 411",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "2232",
    code: "PSY 420",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "2233",
    code: "PSY 421",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "2234",
    code: "PSY 430",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "2235",
    code: "PSY 490",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "2236",
    code: "PSY 501",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "2237",
    code: "PSY 501",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "2238",
    code: "PSY 503",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2239",
    code: "PSY 504",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "2240",
    code: "PSY 553",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "2241",
    code: "PSY 601",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "2242",
    code: "PSY 603",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "2243",
    code: "PSY 614",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "2244",
    code: "PSY 632",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "2245",
    code: "PSY 695",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 16:45 - 17:30",
    time: [90],
    seen: false
  }, {
    id: "2246",
    code: "PSY 695",
    group: "2",
    type: "Yüz yüze",
    day: "Cumartesi 16:45 - 17:30",
    time: [90],
    seen: false
  }, {
    id: "2247",
    code: "PSY 695",
    group: "3",
    type: "Yüz yüze",
    day: "Cumartesi 16:45 - 17:30",
    time: [90],
    seen: false
  }, {
    id: "2248",
    code: "PSY 695",
    group: "4",
    type: "Yüz yüze",
    day: "Cumartesi 16:45 - 17:30",
    time: [90],
    seen: false
  }, {
    id: "2249",
    code: "PSY 699",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 14:00 - 14:45",
    time: [87],
    seen: false
  }, {
    id: "2250",
    code: "RTV 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "2251",
    code: "RTV 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "2252",
    code: "RTV 103",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45",
    time: [21, 22, 23],
    seen: false
  }, {
    id: "2253",
    code: "RTV 104",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "2254",
    code: "RTV 105",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "2255",
    code: "RTV 105",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "2256",
    code: "RTV 105",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "2257",
    code: "RTV 105",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "2258",
    code: "RTV 105",
    group: "5",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45",
    time: [21, 22, 23],
    seen: false
  }, {
    id: "2259",
    code: "RTV 106",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "2260",
    code: "RTV 106",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 12:10 - 14:45",
    time: [69, 70, 71],
    seen: false
  }, {
    id: "2261",
    code: "RTV 107",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "2262",
    code: "RTV 140",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "2263",
    code: "RTV 140",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2264",
    code: "RTV 190",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "2265",
    code: "RTV 190",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2266",
    code: "RTV 191",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "2267",
    code: "RTV 191",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45",
    time: [21, 22, 23],
    seen: false
  }, {
    id: "2268",
    code: "RTV 193",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "2269",
    code: "RTV 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "2270",
    code: "RTV 203",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "2271",
    code: "RTV 209",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "2272",
    code: "RTV 211",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "2273",
    code: "RTV 217",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 14:45",
    time: [37, 38, 39],
    seen: false
  }, {
    id: "2274",
    code: "RTV 217",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 14:45",
    time: [53, 54, 55],
    seen: false
  }, {
    id: "2275",
    code: "RTV 219",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "2276",
    code: "RTV 221",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "2277",
    code: "RTV 223",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "2278",
    code: "RTV 231",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "2279",
    code: "RTV 235",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "2280",
    code: "RTV 251",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 18:25",
    time: [25, 26, 27],
    seen: false
  }, {
    id: "2281",
    code: "RUS 101",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 19:20",
    time: [42, 43, 44],
    seen: false
  }, {
    id: "2282",
    code: "RUS 101",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "2283",
    code: "RUS 101",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "2284",
    code: "RUS 102",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 17:30, Cuma 15:50 - 17:30",
    time: [25, 26, 73, 74],
    seen: false
  }, {
    id: "2285",
    code: "RUS 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Perşembe 15:50 - 17:30",
    time: [9, 10, 57, 58],
    seen: false
  }, {
    id: "2286",
    code: "RUS 201",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 17:40 - 19:20, Perşembe 17:40 - 19:20",
    time: [27, 28, 59, 60],
    seen: false
  }, {
    id: "2287",
    code: "RUS 202",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 17:40 - 19:20, Cuma 17:40 - 19:20",
    time: [27, 28, 75, 76],
    seen: false
  }, {
    id: "2288",
    code: "SABE 552",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 18:35 - 21:10",
    time: [44, 45, 46],
    seen: false
  }, {
    id: "2289",
    code: "SB 220",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "2290",
    code: "SBM 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00, Salı 09:25 - 12:00, Çarşamba 09:25 - 12:00, Çarşamba 13:05 - 14:45, Perşembe 09:25 - 12:00, Perşembe 13:05 - 14:45",
    time: [2, 3, 4, 18, 19, 20, 34, 35, 36, 38, 39, 50, 51, 52, 54, 55],
    seen: false
  }, {
    id: "2291",
    code: "SBM 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00, Salı 08:30 - 12:00, Salı 13:05 - 14:45, Çarşamba 08:30 - 12:00, Perşembe 08:30 - 12:00, Cuma 13:05 - 14:45",
    time: [3, 4, 17, 18, 19, 20, 22, 23, 33, 34, 35, 36, 49, 50, 51, 52, 70, 71],
    seen: false
  }, {
    id: "2292",
    code: "SBM 301",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00, Pazartesi 13:05 - 14:45, Salı 08:30 - 12:00, Çarşamba 08:30 - 12:00, Perşembe 08:30 - 12:00",
    time: [1, 2, 3, 4, 6, 7, 17, 18, 19, 20, 33, 34, 35, 36, 49, 50, 51, 52],
    seen: false
  }, {
    id: "2293",
    code: "SE 105",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50",
    time: [20, 21, 22],
    seen: false
  }, {
    id: "2294",
    code: "SE 105",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "2295",
    code: "SE 113",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00, Perşembe 08:30 - 10:10",
    time: [35, 36, 49, 50],
    seen: false
  }, {
    id: "2296",
    code: "SE 113",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00, Perşembe 08:30 - 10:10",
    time: [35, 36, 49, 50],
    seen: false
  }, {
    id: "2297",
    code: "SE 113",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00, Perşembe 08:30 - 10:10",
    time: [35, 36, 49, 50],
    seen: false
  }, {
    id: "2298",
    code: "SE 113",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00, Perşembe 10:20 - 12:00",
    time: [35, 36, 51, 52],
    seen: false
  }, {
    id: "2299",
    code: "SE 113",
    group: "5",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 14:45, Perşembe 10:20 - 12:00",
    time: [38, 39, 51, 52],
    seen: false
  }, {
    id: "2300",
    code: "SE 113",
    group: "6",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 14:45, Perşembe 14:00 - 15:40",
    time: [38, 39, 55, 56],
    seen: false
  }, {
    id: "2301",
    code: "SE 113",
    group: "7",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 14:45, Perşembe 14:00 - 15:40",
    time: [38, 39, 55, 56],
    seen: false
  }, {
    id: "2302",
    code: "SE 113",
    group: "8",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 14:45, Perşembe 14:00 - 15:40",
    time: [38, 39, 55, 56],
    seen: false
  }, {
    id: "2303",
    code: "SE 115",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 11:05, Salı 08:30 - 10:10",
    time: [2, 3, 17, 18],
    seen: false
  }, {
    id: "2304",
    code: "SE 115",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 11:05, Salı 08:30 - 10:10",
    time: [2, 3, 17, 18],
    seen: false
  }, {
    id: "2305",
    code: "SE 115",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35, Çarşamba 14:55 - 16:35",
    time: [8, 9, 40, 41],
    seen: false
  }, {
    id: "2306",
    code: "SE 115",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35, Çarşamba 14:55 - 16:35",
    time: [8, 9, 40, 41],
    seen: false
  }, {
    id: "2307",
    code: "SE 115",
    group: "5",
    type: "Yüz yüze",
    day: "Salı 14:55 - 16:35, Çarşamba 08:30 - 10:10",
    time: [24, 25, 33, 34],
    seen: false
  }, {
    id: "2308",
    code: "SE 115",
    group: "6",
    type: "Yüz yüze",
    day: "Salı 14:55 - 16:35, Çarşamba 08:30 - 10:10",
    time: [24, 25, 33, 34],
    seen: false
  }, {
    id: "2309",
    code: "SE 115",
    group: "7",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 13:50, Cuma 11:15 - 12:55",
    time: [53, 54, 68, 69],
    seen: false
  }, {
    id: "2310",
    code: "SE 115",
    group: "8",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 13:50, Cuma 13:05 - 14:45",
    time: [53, 54, 70, 71],
    seen: false
  }, {
    id: "2311",
    code: "SE 209",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 13:50",
    time: [20, 21, 22],
    seen: false
  }, {
    id: "2312",
    code: "SE 209",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "2313",
    code: "SE 302",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:55",
    time: [35, 36, 37],
    seen: false
  }, {
    id: "2314",
    code: "SE 302",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "2315",
    code: "SE 305",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Çarşamba 12:10 - 13:50",
    time: [17, 18, 37, 38],
    seen: false
  }, {
    id: "2316",
    code: "SE 305",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45, Perşembe 08:30 - 10:10",
    time: [22, 23, 49, 50],
    seen: false
  }, {
    id: "2317",
    code: "SE 307",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 10:10, Cuma 14:55 - 16:35",
    time: [49, 50, 72, 73],
    seen: false
  }, {
    id: "2318",
    code: "SE 309",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Çarşamba 10:20 - 12:00",
    time: [1, 2, 35, 36],
    seen: false
  }, {
    id: "2319",
    code: "SE 309",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Perşembe 10:20 - 12:00",
    time: [6, 7, 51, 52],
    seen: false
  }, {
    id: "2320",
    code: "SE 320",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30",
    time: [24, 25, 26],
    seen: false
  }, {
    id: "2321",
    code: "SE 321",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Çarşamba 12:10 - 13:50",
    time: [17, 18, 37, 38],
    seen: false
  }, {
    id: "2322",
    code: "SE 321",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45, Perşembe 08:30 - 10:10",
    time: [22, 23, 49, 50],
    seen: false
  }, {
    id: "2323",
    code: "SE 323",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 10:10, Çarşamba 10:20 - 12:00",
    time: [1, 2, 35, 36],
    seen: false
  }, {
    id: "2324",
    code: "SE 323",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45, Perşembe 10:20 - 12:00",
    time: [6, 7, 51, 52],
    seen: false
  }, {
    id: "2325",
    code: "SE 350",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "2326",
    code: "SE 354",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 17:30",
    time: [56, 57, 58],
    seen: false
  }, {
    id: "2327",
    code: "SE 360",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "2328",
    code: "SE 380",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "2329",
    code: "SE 410",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:55",
    time: [19, 20, 21],
    seen: false
  }, {
    id: "2330",
    code: "SE 420",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2331",
    code: "SE 431",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "2332",
    code: "SE 460",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "2333",
    code: "SE 480",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30",
    time: [24, 25, 26],
    seen: false
  }, {
    id: "2334",
    code: "SE 491",
    group: "1",
    type: "Yüz yüze",
    day: "Cumartesi 13:05 - 18:25",
    time: [86, 87, 88, 89, 90, 91],
    seen: false
  }, {
    id: "2335",
    code: "SEN 503",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "2336",
    code: "SEN 509",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 21:10",
    time: [12, 13, 14],
    seen: false
  }, {
    id: "2337",
    code: "SEN 552",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 18:35 - 21:10",
    time: [60, 61, 62],
    seen: false
  }, {
    id: "2338",
    code: "SHKH 104",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "2339",
    code: "SHKH 108",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "2340",
    code: "SHKH 111",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 11:05, Cuma 09:25 - 11:05",
    time: [2, 3, 66, 67],
    seen: false
  }, {
    id: "2341",
    code: "SHKH 111",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:55, Cuma 11:15 - 12:55",
    time: [4, 5, 68, 69],
    seen: false
  }, {
    id: "2342",
    code: "SHKH 115",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 09:15, Çarşamba 08:30 - 10:10",
    time: [1, 33, 34],
    seen: false
  }, {
    id: "2343",
    code: "SHKH 115",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 13:50",
    time: [4, 5, 6],
    seen: false
  }, {
    id: "2344",
    code: "SHKH 117",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 15:40",
    time: [71, 72],
    seen: false
  }, {
    id: "2345",
    code: "SHKH 131",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "2346",
    code: "SHKH 131",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "2347",
    code: "SHKH 191",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 11:05, Cuma 09:25 - 11:05",
    time: [2, 3, 66, 67],
    seen: false
  }, {
    id: "2348",
    code: "SHKH 191",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:55, Cuma 11:15 - 12:55",
    time: [4, 5, 68, 69],
    seen: false
  }, {
    id: "2349",
    code: "SHKH 193",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 09:15, Çarşamba 08:30 - 10:10",
    time: [1, 33, 34],
    seen: false
  }, {
    id: "2350",
    code: "SHKH 193",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 13:50",
    time: [4, 5, 6],
    seen: false
  }, {
    id: "2351",
    code: "SHKH 195",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "2352",
    code: "SHKH 195",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:55 - 17:30",
    time: [24, 25, 26],
    seen: false
  }, {
    id: "2353",
    code: "SHKH 197",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "2354",
    code: "SHKH 199",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "2355",
    code: "SHKH 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 17:40 - 19:20, Çarşamba 18:35 - 20:15",
    time: [27, 28, 44, 45],
    seen: false
  }, {
    id: "2356",
    code: "SHKH 201",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 17:40 - 18:25, Perşembe 17:40 - 20:15",
    time: [43, 59, 60, 61],
    seen: false
  }, {
    id: "2357",
    code: "SHKH 203",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 16:35",
    time: [24, 25],
    seen: false
  }, {
    id: "2358",
    code: "SHKH 203",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10",
    time: [33, 34],
    seen: false
  }, {
    id: "2359",
    code: "SHKH 203",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35",
    time: [8, 9],
    seen: false
  }, {
    id: "2360",
    code: "SHKH 205",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 11:15 - 12:55, Çarşamba 13:05 - 14:45",
    time: [20, 21, 38, 39],
    seen: false
  }, {
    id: "2361",
    code: "SHKH 205",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45, Çarşamba 11:15 - 12:55",
    time: [22, 23, 36, 37],
    seen: false
  }, {
    id: "2362",
    code: "SHKH 209",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "2363",
    code: "SHKH 213",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 11:15 - 13:50",
    time: [68, 69, 70],
    seen: false
  }, {
    id: "2364",
    code: "SHKH 294",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "2365",
    code: "SHKH 298",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 12:10 - 13:50",
    time: [53, 54],
    seen: false
  }, {
    id: "2366",
    code: "SKG 501",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 18:35 - 21:10",
    time: [28, 29, 30],
    seen: false
  }, {
    id: "2367",
    code: "SOC 101",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "2368",
    code: "SOC 101",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 13:05 - 15:40",
    time: [38, 39, 40],
    seen: false
  }, {
    id: "2369",
    code: "SOC 104",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "2370",
    code: "SOC 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "2371",
    code: "SOC 205",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "2372",
    code: "SOC 208",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "2373",
    code: "SOC 211",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45, Çarşamba 12:10 - 13:50",
    time: [22, 23, 37, 38],
    seen: false
  }, {
    id: "2374",
    code: "SOC 221",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "2375",
    code: "SOC 303",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "2376",
    code: "SOC 311",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "2377",
    code: "SOC 313",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "2378",
    code: "SOC 316",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "2379",
    code: "SOC 321",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "2380",
    code: "SOC 372",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 10:20 - 12:55",
    time: [67, 68, 69],
    seen: false
  }, {
    id: "2381",
    code: "SOC 421",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 15:40",
    time: [6, 7, 8],
    seen: false
  }, {
    id: "2382",
    code: "SOC 480",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:55",
    time: [3, 4, 5],
    seen: false
  }, {
    id: "2383",
    code: "SOC 497",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "2384",
    code: "SOC 499",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 13:50",
    time: [51, 52, 53, 54],
    seen: false
  }, {
    id: "2385",
    code: "SPN 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "2386",
    code: "SPN 101",
    group: "10",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "2387",
    code: "SPN 101",
    group: "11",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "2388",
    code: "SPN 101",
    group: "12",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 11:05",
    time: [33, 34, 35],
    seen: false
  }, {
    id: "2389",
    code: "SPN 101",
    group: "13",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "2390",
    code: "SPN 101",
    group: "14",
    type: "Yüz yüze",
    day: "Cuma 15:50 - 18:25",
    time: [73, 74, 75],
    seen: false
  }, {
    id: "2391",
    code: "SPN 101",
    group: "15",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "2392",
    code: "SPN 101",
    group: "16",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "2393",
    code: "SPN 101",
    group: "17",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "2394",
    code: "SPN 101",
    group: "18",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 11:05",
    time: [49, 50, 51],
    seen: false
  }, {
    id: "2395",
    code: "SPN 101",
    group: "19",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "2396",
    code: "SPN 101",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "2397",
    code: "SPN 101",
    group: "20",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 16:35",
    time: [71, 72, 73],
    seen: false
  }, {
    id: "2398",
    code: "SPN 101",
    group: "21",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00",
    time: [66, 67, 68],
    seen: false
  }, {
    id: "2399",
    code: "SPN 101",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "2400",
    code: "SPN 101",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "2401",
    code: "SPN 101",
    group: "5",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "2402",
    code: "SPN 101",
    group: "6",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "2403",
    code: "SPN 101",
    group: "7",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "2404",
    code: "SPN 101",
    group: "8",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "2405",
    code: "SPN 101",
    group: "9",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 16:35",
    time: [7, 8, 9],
    seen: false
  }, {
    id: "2406",
    code: "SPN 102",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Perşembe 14:00 - 15:40",
    time: [17, 18, 55, 56],
    seen: false
  }, {
    id: "2407",
    code: "SPN 102",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Çarşamba 10:20 - 12:00",
    time: [9, 10, 35, 36],
    seen: false
  }, {
    id: "2408",
    code: "SPN 102",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Perşembe 17:40 - 19:20",
    time: [19, 20, 59, 60],
    seen: false
  }, {
    id: "2409",
    code: "SPN 102",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 16:45 - 18:25, Perşembe 14:00 - 15:40",
    time: [26, 27, 55, 56],
    seen: false
  }, {
    id: "2410",
    code: "SPN 102",
    group: "5",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Çarşamba 10:20 - 12:00",
    time: [7, 8, 35, 36],
    seen: false
  }, {
    id: "2411",
    code: "SPN 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:00",
    time: [18, 19, 20],
    seen: false
  }, {
    id: "2412",
    code: "SPN 201",
    group: "10",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "2413",
    code: "SPN 201",
    group: "11",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "2414",
    code: "SPN 201",
    group: "12",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "2415",
    code: "SPN 201",
    group: "13",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 19:20",
    time: [10, 11, 12],
    seen: false
  }, {
    id: "2416",
    code: "SPN 201",
    group: "14",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "2417",
    code: "SPN 201",
    group: "15",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 16:35",
    time: [55, 56, 57],
    seen: false
  }, {
    id: "2418",
    code: "SPN 201",
    group: "16",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "2419",
    code: "SPN 201",
    group: "17",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "2420",
    code: "SPN 201",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 16:45 - 19:20",
    time: [26, 27, 28],
    seen: false
  }, {
    id: "2421",
    code: "SPN 201",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "2422",
    code: "SPN 201",
    group: "4",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "2423",
    code: "SPN 201",
    group: "5",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2424",
    code: "SPN 201",
    group: "6",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2425",
    code: "SPN 201",
    group: "7",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "2426",
    code: "SPN 201",
    group: "8",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "2427",
    code: "SPN 201",
    group: "9",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 18:25",
    time: [57, 58, 59],
    seen: false
  }, {
    id: "2428",
    code: "SPN 202",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Çarşamba 14:00 - 15:40",
    time: [9, 10, 39, 40],
    seen: false
  }, {
    id: "2429",
    code: "SPN 202",
    group: "2",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 17:30, Çarşamba 14:00 - 15:40",
    time: [9, 10, 39, 40],
    seen: false
  }, {
    id: "2430",
    code: "SPN 202",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Perşembe 10:20 - 12:00",
    time: [17, 18, 51, 52],
    seen: false
  }, {
    id: "2431",
    code: "SPN 202",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Perşembe 14:00 - 15:40",
    time: [19, 20, 55, 56],
    seen: false
  }, {
    id: "2432",
    code: "SPN 301",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Cuma 10:20 - 12:00",
    time: [7, 8, 67, 68],
    seen: false
  }, {
    id: "2433",
    code: "SPN 310",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 16:35",
    time: [23, 24, 25],
    seen: false
  }, {
    id: "2434",
    code: "STAT 601",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "2435",
    code: "STAT 601",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "2436",
    code: "TDS 101",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Salı 13:05 - 14:45",
    time: [19, 20, 22, 23],
    seen: false
  }, {
    id: "2437",
    code: "TDS 105",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 18:25",
    time: [42, 43],
    seen: false
  }, {
    id: "2438",
    code: "TDS 165",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 15:40",
    time: [39, 40],
    seen: false
  }, {
    id: "2439",
    code: "TDS 203",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 11:05, Perşembe 13:05 - 15:40, Cuma 08:30 - 09:15",
    time: [2, 3, 54, 55, 56, 65],
    seen: false
  }, {
    id: "2440",
    code: "TDS 205",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30",
    time: [41, 42],
    seen: false
  }, {
    id: "2441",
    code: "TDS 207",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 11:15 - 12:55, Perşembe 08:30 - 12:00",
    time: [4, 5, 49, 50, 51, 52],
    seen: false
  }, {
    id: "2442",
    code: "TDS 208",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 13:50",
    time: [37, 38],
    seen: false
  }, {
    id: "2443",
    code: "TDS 214",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40",
    time: [23, 24],
    seen: false
  }, {
    id: "2444",
    code: "TDS 215",
    group: "1",
    type: "Yüz yüze",
    day: "Cuma 09:25 - 12:00, Cuma 13:05 - 15:40",
    time: [66, 67, 68, 70, 71, 72],
    seen: false
  }, {
    id: "2445",
    code: "TDS 250",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40",
    time: [7, 8],
    seen: false
  }, {
    id: "2446",
    code: "TGT 101",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45, Çarşamba 08:30 - 11:05, Çarşamba 12:10 - 14:45",
    time: [21, 22, 23, 33, 34, 35, 37, 38, 39],
    seen: false
  }, {
    id: "2447",
    code: "TGT 101",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45, Perşembe 08:30 - 11:05, Perşembe 12:10 - 14:45",
    time: [21, 22, 23, 49, 50, 51, 53, 54, 55],
    seen: false
  }, {
    id: "2448",
    code: "TGT 101",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 12:10 - 14:45, Cuma 08:30 - 11:05, Cuma 12:10 - 14:45",
    time: [21, 22, 23, 65, 66, 67, 69, 70, 71],
    seen: false
  }, {
    id: "2449",
    code: "TGT 201",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 15:40, Perşembe 13:05 - 15:40",
    time: [1, 2, 3, 4, 5, 6, 7, 8, 54, 55, 56],
    seen: false
  }, {
    id: "2450",
    code: "TGT 201",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 08:30 - 15:40, Perşembe 13:05 - 15:40",
    time: [17, 18, 19, 20, 21, 22, 23, 24, 54, 55, 56],
    seen: false
  }, {
    id: "2451",
    code: "TGT 201",
    group: "3",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40, Cuma 08:30 - 15:40",
    time: [54, 55, 56, 65, 66, 67, 68, 69, 70, 71, 72],
    seen: false
  }, {
    id: "2452",
    code: "TGT 203",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "2453",
    code: "TGT 205",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10",
    time: [33, 34],
    seen: false
  }, {
    id: "2454",
    code: "TGT 209",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 15:50 - 17:30",
    time: [57, 58],
    seen: false
  }, {
    id: "2455",
    code: "TLT 101",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 10:20 - 12:00, Çarşamba 09:25 - 11:05",
    time: [19, 20, 34, 35],
    seen: false
  }, {
    id: "2456",
    code: "TLT 103",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 11:15 - 12:55",
    time: [36, 37],
    seen: false
  }, {
    id: "2457",
    code: "TLT 105",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 14:45",
    time: [5, 6, 7],
    seen: false
  }, {
    id: "2458",
    code: "TLT 107",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 10:10, Çarşamba 14:00 - 16:35",
    time: [17, 18, 39, 40, 41],
    seen: false
  }, {
    id: "2459",
    code: "TLT 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 14:45, Perşembe 09:25 - 11:05, Perşembe 13:05 - 15:40, Cuma 09:25 - 11:05, Cuma 13:05 - 15:40",
    time: [22, 23, 50, 51, 54, 55, 56, 66, 67, 70, 71, 72],
    seen: false
  }, {
    id: "2460",
    code: "TLT 203",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00",
    time: [3, 4],
    seen: false
  }, {
    id: "2461",
    code: "TLT 205",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 18:25",
    time: [41, 42, 43],
    seen: false
  }, {
    id: "2462",
    code: "TLT 207",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:55 - 16:35",
    time: [24, 25],
    seen: false
  }, {
    id: "2463",
    code: "TLT 212",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 16:35",
    time: [6, 7, 8, 9],
    seen: false
  }, {
    id: "2464",
    code: "TR 101",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 17:40 - 19:20, Perşembe 17:40 - 19:20",
    time: [27, 28, 59, 60],
    seen: false
  }, {
    id: "2465",
    code: "TRH 100",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 17:40 - 19:20, Cumartesi 14:00 - 15:40",
    time: [59, 60, 87, 88],
    seen: false
  }, {
    id: "2466",
    code: "TRH 100",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 17:40 - 19:20, Cumartesi 15:50 - 17:30",
    time: [75, 76, 89, 90],
    seen: false
  }, {
    id: "2467",
    code: "TRH 100",
    group: "3",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 16:35, Cumartesi 14:00 - 14:45, Pazar 13:05 - 13:50",
    time: [8, 9, 87, 102],
    seen: false
  }, {
    id: "2468",
    code: "TRH 100",
    group: "4",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 18:25, Pazar 11:15 - 12:55",
    time: [10, 11, 100, 101],
    seen: false
  }, {
    id: "2469",
    code: "TRH 100",
    group: "5",
    type: "Yüz yüze",
    day: "Salı 16:45 - 18:25, Pazar 14:00 - 15:40",
    time: [26, 27, 103, 104],
    seen: false
  }, {
    id: "2470",
    code: "TRH 100",
    group: "6",
    type: "Yüz yüze",
    day: "Salı 18:35 - 20:15, Pazar 15:50 - 17:30",
    time: [28, 29, 105, 106],
    seen: false
  }, {
    id: "2471",
    code: "TRH 100",
    group: "7",
    type: "Yüz yüze",
    day: "Cuma 18:35 - 20:15, Pazar 20:25 - 22:05",
    time: [76, 77, 110, 111],
    seen: false
  }, {
    id: "2472",
    code: "TRH 100",
    group: "8",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 18:25, Cumartesi 09:25 - 11:05",
    time: [10, 11, 82, 83],
    seen: false
  }, {
    id: "2473",
    code: "TRH 100",
    group: "9",
    type: "Yüz yüze",
    day: "Salı 16:45 - 18:25, Cumartesi 14:00 - 15:40",
    time: [26, 27, 87, 88],
    seen: false
  }, {
    id: "2474",
    code: "TRH 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 19:30 - 20:15, Cumartesi 19:30 - 20:15",
    time: [13, 93],
    seen: false
  }, {
    id: "2475",
    code: "TRH 101",
    group: "10",
    type: "Yüz yüze",
    day: "Çarşamba 17:40 - 18:25, Pazar 14:00 - 14:45",
    time: [43, 103],
    seen: false
  }, {
    id: "2476",
    code: "TRH 101",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 19:30 - 20:15, Cumartesi 20:25 - 21:10",
    time: [29, 94],
    seen: false
  }, {
    id: "2477",
    code: "TRH 101",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 17:30, Cumartesi 19:30 - 20:15",
    time: [42, 93],
    seen: false
  }, {
    id: "2478",
    code: "TRH 101",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 17:40 - 18:25, Cumartesi 09:25 - 10:10",
    time: [43, 82],
    seen: false
  }, {
    id: "2479",
    code: "TRH 101",
    group: "5",
    type: "Yüz yüze",
    day: "Perşembe 17:40 - 18:25, Cumartesi 18:35 - 19:20",
    time: [59, 92],
    seen: false
  }, {
    id: "2480",
    code: "TRH 101",
    group: "6",
    type: "Yüz yüze",
    day: "Cuma 14:00 - 14:45, Cumartesi 08:30 - 09:15",
    time: [71, 81],
    seen: false
  }, {
    id: "2481",
    code: "TRH 101",
    group: "7",
    type: "Yüz yüze",
    day: "Pazartesi 18:35 - 19:20, Cumartesi 13:05 - 13:50",
    time: [12, 86],
    seen: false
  }, {
    id: "2482",
    code: "TRH 101",
    group: "8",
    type: "Yüz yüze",
    day: "Salı 18:35 - 19:20, Cumartesi 11:15 - 12:00",
    time: [28, 84],
    seen: false
  }, {
    id: "2483",
    code: "TRH 101",
    group: "9",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 17:30, Cumartesi 17:40 - 18:25",
    time: [42, 91],
    seen: false
  }, {
    id: "2484",
    code: "TRK 100",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 16:45 - 18:25, Pazar 19:30 - 21:10",
    time: [10, 11, 109, 110],
    seen: false
  }, {
    id: "2485",
    code: "TRK 100",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 14:55 - 16:35, Pazar 14:55 - 16:35",
    time: [56, 57, 104, 105],
    seen: false
  }, {
    id: "2486",
    code: "TRK 100",
    group: "3",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 18:25, Pazar 16:45 - 18:25",
    time: [42, 43, 106, 107],
    seen: false
  }, {
    id: "2487",
    code: "TRK 100",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 18:35 - 20:15, Pazar 11:15 - 12:55",
    time: [44, 45, 100, 101],
    seen: false
  }, {
    id: "2488",
    code: "TRK 100",
    group: "5",
    type: "Yüz yüze",
    day: "Perşembe 17:40 - 19:20, Cumartesi 13:05 - 14:45",
    time: [59, 60, 86, 87],
    seen: false
  }, {
    id: "2489",
    code: "TRK 100",
    group: "6",
    type: "Yüz yüze",
    day: "Çarşamba 18:35 - 20:15, Pazar 12:10 - 13:50",
    time: [44, 45, 101, 102],
    seen: false
  }, {
    id: "2490",
    code: "TRK 100",
    group: "7",
    type: "Yüz yüze",
    day: "Perşembe 17:40 - 19:20, Pazar 20:25 - 22:05",
    time: [59, 60, 110, 111],
    seen: false
  }, {
    id: "2491",
    code: "TRK 101",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 14:00 - 14:45, Pazar 22:15 - 23:00",
    time: [55, 112],
    seen: false
  }, {
    id: "2492",
    code: "TRK 101",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 17:30, Pazar 20:25 - 21:10",
    time: [58, 110],
    seen: false
  }, {
    id: "2493",
    code: "TRK 101",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 17:30, Pazar 20:25 - 21:10",
    time: [74, 110],
    seen: false
  }, {
    id: "2494",
    code: "TRK 101",
    group: "4",
    type: "Yüz yüze",
    day: "Salı 18:35 - 19:20, Pazar 14:55 - 15:40",
    time: [28, 104],
    seen: false
  }, {
    id: "2495",
    code: "TRK 101",
    group: "5",
    type: "Yüz yüze",
    day: "Perşembe 16:45 - 17:30, Cumartesi 17:40 - 18:25",
    time: [58, 91],
    seen: false
  }, {
    id: "2496",
    code: "TRK 101",
    group: "6",
    type: "Yüz yüze",
    day: "Cuma 16:45 - 17:30, Pazar 16:45 - 17:30",
    time: [74, 106],
    seen: false
  }, {
    id: "2497",
    code: "TS 101",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2498",
    code: "TS 101",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 09:25 - 10:10, Salı 11:15 - 12:55",
    time: [18, 20, 21],
    seen: false
  }, {
    id: "2499",
    code: "TS 101",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "2500",
    code: "TS 101",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 16:35",
    time: [39, 40, 41],
    seen: false
  }, {
    id: "2501",
    code: "TS 103",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 15:50 - 18:25",
    time: [9, 10, 11],
    seen: false
  }, {
    id: "2502",
    code: "TS 103",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 11:05",
    time: [65, 66, 67],
    seen: false
  }, {
    id: "2503",
    code: "TS 103",
    group: "3",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2504",
    code: "TS 104",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 12:00",
    time: [34, 35, 36],
    seen: false
  }, {
    id: "2505",
    code: "TS 104",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 09:25 - 12:00",
    time: [50, 51, 52],
    seen: false
  }, {
    id: "2506",
    code: "TS 105",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 17:30",
    time: [25, 26],
    seen: false
  }, {
    id: "2507",
    code: "TS 107",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 14:00 - 15:40",
    time: [39, 40],
    seen: false
  }, {
    id: "2508",
    code: "TS 109",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:55 - 17:30",
    time: [8, 9, 10],
    seen: false
  }, {
    id: "2509",
    code: "TS 109",
    group: "2",
    type: "Yüz yüze",
    day: "Perşembe 10:20 - 12:55",
    time: [51, 52, 53],
    seen: false
  }, {
    id: "2510",
    code: "TS 109",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 08:30 - 11:05",
    time: [17, 18, 19],
    seen: false
  }, {
    id: "2511",
    code: "TS 115",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 17:30",
    time: [25, 26],
    seen: false
  }, {
    id: "2512",
    code: "TS 120",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 15:50 - 17:30",
    time: [25, 26],
    seen: false
  }, {
    id: "2513",
    code: "TS 120",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00",
    time: [35, 36],
    seen: false
  }, {
    id: "2514",
    code: "TS 150",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30",
    time: [41, 42],
    seen: false
  }, {
    id: "2515",
    code: "TS 202",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10",
    time: [33, 34],
    seen: false
  }, {
    id: "2516",
    code: "TS 202",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 18:35 - 20:15",
    time: [44, 45],
    seen: false
  }, {
    id: "2517",
    code: "TS 205",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 10:10",
    time: [33, 34],
    seen: false
  }, {
    id: "2518",
    code: "TS 205",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30",
    time: [41, 42],
    seen: false
  }, {
    id: "2519",
    code: "TS 208",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 13:50",
    time: [37, 38],
    seen: false
  }, {
    id: "2520",
    code: "TS 210",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 11:15 - 12:55",
    time: [36, 37],
    seen: false
  }, {
    id: "2521",
    code: "TS 215",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 12:10 - 13:50",
    time: [5, 6],
    seen: false
  }, {
    id: "2522",
    code: "TS 217",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 15:50 - 17:30",
    time: [41, 42],
    seen: false
  }, {
    id: "2523",
    code: "TURK 100",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 14:00 - 15:40, Pazar 08:30 - 10:10",
    time: [7, 8, 97, 98],
    seen: false
  }, {
    id: "2524",
    code: "TURK 100",
    group: "2",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Pazar 10:20 - 12:00",
    time: [23, 24, 99, 100],
    seen: false
  }, {
    id: "2525",
    code: "TURK 100",
    group: "3",
    type: "Yüz yüze",
    day: "Salı 16:45 - 18:25, Pazar 13:05 - 14:45",
    time: [26, 27, 102, 103],
    seen: false
  }, {
    id: "2526",
    code: "TURK 100",
    group: "4",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 13:50, Pazar 12:10 - 13:50",
    time: [37, 38, 101, 102],
    seen: false
  }, {
    id: "2527",
    code: "TURK 100",
    group: "5",
    type: "Yüz yüze",
    day: "Çarşamba 14:55 - 16:35, Pazar 14:00 - 15:40",
    time: [40, 41, 103, 104],
    seen: false
  }, {
    id: "2528",
    code: "TURK 100",
    group: "6",
    type: "Yüz yüze",
    day: "Cuma 17:40 - 19:20, Pazar 08:30 - 10:10",
    time: [75, 76, 97, 98],
    seen: false
  }, {
    id: "2529",
    code: "TURK 100",
    group: "7",
    type: "Yüz yüze",
    day: "Salı 16:45 - 18:25, Pazar 08:30 - 10:10",
    time: [26, 27, 97, 98],
    seen: false
  }, {
    id: "2530",
    code: "TURK 100",
    group: "8",
    type: "Yüz yüze",
    day: "Çarşamba 16:45 - 18:25, Pazar 10:20 - 12:00",
    time: [42, 43, 99, 100],
    seen: false
  }, {
    id: "2531",
    code: "TURK 100",
    group: "9",
    type: "Yüz yüze",
    day: "Cuma 17:40 - 19:20, Pazar 17:40 - 19:20",
    time: [75, 76, 107, 108],
    seen: false
  }, {
    id: "2532",
    code: "VCD 101",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "2533",
    code: "VCD 101",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 08:30 - 12:00",
    time: [33, 34, 35, 36],
    seen: false
  }, {
    id: "2534",
    code: "VCD 111",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00",
    time: [49, 50, 51, 52],
    seen: false
  }, {
    id: "2535",
    code: "VCD 111",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 08:30 - 12:00",
    time: [65, 66, 67, 68],
    seen: false
  }, {
    id: "2536",
    code: "VCD 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 08:30 - 12:00, Cuma 08:30 - 12:00",
    time: [17, 18, 19, 20, 65, 66, 67, 68],
    seen: false
  }, {
    id: "2537",
    code: "VCD 203",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 12:00",
    time: [49, 50, 51, 52],
    seen: false
  }, {
    id: "2538",
    code: "VCD 205",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 13:05 - 15:40",
    time: [22, 23, 24],
    seen: false
  }, {
    id: "2539",
    code: "VCD 205",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 09:25 - 09:15, Çarşamba 10:20 - 12:00",
    time: [35, 36],
    seen: false
  }, {
    id: "2540",
    code: "VCD 207",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 12:00",
    time: [1, 2, 3, 4],
    seen: false
  }, {
    id: "2541",
    code: "VCD 207",
    group: "2",
    type: "Yüz yüze",
    day: "Çarşamba 12:10 - 15:40",
    time: [37, 38, 39, 40],
    seen: false
  }, {
    id: "2542",
    code: "VCD 211",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 13:05 - 15:40",
    time: [54, 55, 56],
    seen: false
  }, {
    id: "2543",
    code: "VCD 211",
    group: "2",
    type: "Yüz yüze",
    day: "Cuma 13:05 - 15:40",
    time: [70, 71, 72],
    seen: false
  }, {
    id: "2544",
    code: "VCD 331",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 08:30 - 11:05",
    time: [1, 2, 3],
    seen: false
  }, {
    id: "2545",
    code: "VCD 426",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 12:10 - 15:40",
    time: [21, 22, 23, 24],
    seen: false
  }, {
    id: "2546",
    code: "YB 101",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 09:25 - 12:55",
    time: [18, 19, 20, 21],
    seen: false
  }, {
    id: "2547",
    code: "YB 109",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00",
    time: [35, 36],
    seen: false
  }, {
    id: "2548",
    code: "YB 119",
    group: "1",
    type: "Yüz yüze",
    day: "Çarşamba 10:20 - 12:00",
    time: [35, 36],
    seen: false
  }, {
    id: "2549",
    code: "YB 180",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 13:05 - 14:45",
    time: [6, 7],
    seen: false
  }, {
    id: "2550",
    code: "YB 201",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Cuma 08:30 - 15:40",
    time: [23, 24, 65, 66, 67, 68, 69, 70, 71, 72],
    seen: false
  }, {
    id: "2551",
    code: "YB 203",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 09:25 - 12:00",
    time: [2, 3, 4],
    seen: false
  }, {
    id: "2552",
    code: "YB 207",
    group: "1",
    type: "Yüz yüze",
    day: "Perşembe 08:30 - 15:40",
    time: [49, 50, 51, 52, 53, 54, 55, 56],
    seen: false
  }, {
    id: "2553",
    code: "YB 211",
    group: "1",
    type: "Yüz yüze",
    day: "Salı 14:00 - 15:40, Cuma 08:30 - 15:40",
    time: [23, 24, 65, 66, 67, 68, 69, 70, 71, 72],
    seen: false
  }, {
    id: "2554",
    code: "YB 260",
    group: "1",
    type: "Yüz yüze",
    day: "Pazartesi 10:20 - 12:00",
    time: [3, 4],
    seen: false
  }]
}